import * as i0 from '@angular/core';
import { Injectable, Directive, Input, HostListener, HostBinding, EventEmitter, Output, Pipe, NgModule, ElementRef, Inject, Component, forwardRef, Self, ViewEncapsulation, ContentChild, Optional, Host, ViewChild, ChangeDetectionStrategy, SkipSelf, InjectionToken, ViewContainerRef } from '@angular/core';
import { Subject, fromEvent, debounceTime, distinctUntilChanged, share, BehaviorSubject, combineLatest, takeUntil as takeUntil$1, tap, filter, of, map as map$1 } from 'rxjs';
import * as i2 from '@angular/common';
import { CommonModule, DatePipe, DOCUMENT } from '@angular/common';
import * as i1 from '@angular/animations';
import { animate, keyframes, style, trigger, state, transition } from '@angular/animations';
import { take, map, takeUntil, last, delay, tap as tap$1, filter as filter$1, debounceTime as debounceTime$1 } from 'rxjs/operators';
import * as i2$1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i1$1 from '@angular/platform-browser';
import * as i1$2 from '@angular/forms';
import { FormGroup, FormsModule, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl, ReactiveFormsModule } from '@angular/forms';
import * as i3 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i3$1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i6 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i6$1 from '@angular/material/core';
import * as i4 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i5 from 'ngx-scrollbar';
import { NgScrollbarModule, NgScrollbar } from 'ngx-scrollbar';
import * as i2$3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import * as i1$3 from '@angular/cdk/observers';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i3$2 from '@angular/material/form-field';
import { MatFormFieldControl, MatFormFieldModule } from '@angular/material/form-field';
import * as i2$2 from '@angular/cdk/a11y';
import * as i7 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i5$1 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i5$2 from 'ngx-scrollbar/reached-event';
import { NgScrollbarReachedModule } from 'ngx-scrollbar/reached-event';
import * as i4$1 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import * as i4$2 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i1$5 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i1$4 from '@angular/cdk/layout';
import * as i8 from '@angular/material/toolbar';
import { MatToolbarModule } from '@angular/material/toolbar';
import * as i2$4 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
function Rtl2SearchComponent_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function Rtl2SearchComponent_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleDropdown());
    });
    i0.ɵɵelementStart(1, "i", 3);
    i0.ɵɵtext(2, "arrow_drop_down");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("foregroundBlack", ctx_r2.dark);
    i0.ɵɵproperty("@rotateAnimation", ctx_r2.dropdownOpened);
  }
}
function Rtl2SearchComponent_mat_option_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r4, " ");
  }
}
function Rtl2SearchComponent_div_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
}
function Rtl2SearchComponent_div_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
}
function Rtl2DashboardFavoritesComponent_mat_nav_list_0_a_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 3);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function Rtl2DashboardFavoritesComponent_mat_nav_list_0_a_1_Template_a_click_0_listener() {
      const favorite_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.openUrl(favorite_r2.link));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const favorite_r2 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 2, favorite_r2.name), i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("href", favorite_r2.link, i0.ɵɵsanitizeUrl);
  }
}
function Rtl2DashboardFavoritesComponent_mat_nav_list_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-nav-list");
    i0.ɵɵtemplate(1, Rtl2DashboardFavoritesComponent_mat_nav_list_0_a_1_Template, 2, 4, "a", 2);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r2.favourites$));
  }
}
function Rtl2DashboardFavoritesComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "rtl2.dashboardPopup.favorites.noSelected"), " ");
  }
}
function Rtl2DashboardServicesComponent_mat_nav_list_1_a_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 3);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function Rtl2DashboardServicesComponent_mat_nav_list_1_a_1_Template_a_click_0_listener() {
      const service_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.openUrl(service_r2.link));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const service_r2 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 2, service_r2.name), i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("href", service_r2.link, i0.ɵɵsanitizeUrl);
  }
}
function Rtl2DashboardServicesComponent_mat_nav_list_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-nav-list");
    i0.ɵɵtemplate(1, Rtl2DashboardServicesComponent_mat_nav_list_1_a_1_Template, 2, 4, "a", 2);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r2.visible$));
  }
}
function Rtl2DashboardServicesComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "rtl2.dashboardPopup.services.noResults"), " ");
  }
}
const _c0 = (a0, a1, a2) => ({
  week: a0,
  disabled: a1,
  selected: a2
});
const _c1 = (a0, a1, a2) => ({
  year: a0,
  month: a1,
  day: a2
});
const _c2 = (a0, a1, a2, a3) => ({
  date: a0,
  currentMonth: a1,
  disabled: a2,
  selected: a3
});
function Rtl2DatepickerMonthView_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "rtl2.datepicker.KW"), " ");
  }
}
function Rtl2DatepickerMonthView_div_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const w_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r1.i18n.getWeekdayShortName(w_r1)), " ");
  }
}
function Rtl2DatepickerMonthView_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, Rtl2DatepickerMonthView_div_0_div_1_Template, 3, 3, "div", 3)(2, Rtl2DatepickerMonthView_div_0_div_2_Template, 3, 3, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showWeekNumbers);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.month.weekdays);
  }
}
function Rtl2DatepickerMonthView_ng_template_1_div_0_div_1_ng_template_1_Template(rf, ctx) {}
function Rtl2DatepickerMonthView_ng_template_1_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function Rtl2DatepickerMonthView_ng_template_1_div_0_div_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const week_r4 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.doSelect(week_r4));
    });
    i0.ɵɵtemplate(1, Rtl2DatepickerMonthView_ng_template_1_div_0_div_1_ng_template_1_Template, 0, 0, "ng-template", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const week_r4 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("non-selectable", !ctx_r1.weeksSelectable)("selected", ctx_r1.isSelectedWeek(week_r4))("disabled", ctx_r1.isDisabledWeek(week_r4));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.weekNumberTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(8, _c0, week_r4, ctx_r1.isDisabledWeek(week_r4), ctx_r1.isSelectedWeek(week_r4)));
  }
}
function Rtl2DatepickerMonthView_ng_template_1_div_0_div_2_ng_template_1_ng_template_0_Template(rf, ctx) {}
function Rtl2DatepickerMonthView_ng_template_1_div_0_div_2_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Rtl2DatepickerMonthView_ng_template_1_div_0_div_2_ng_template_1_ng_template_0_Template, 0, 0, "ng-template", 10);
  }
  if (rf & 2) {
    const day_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.dayTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction4(6, _c2, i0.ɵɵpureFunction3(2, _c1, day_r6.date.year, day_r6.date.month, day_r6.date.day), ctx_r1.month.number, ctx_r1.isDisabled(day_r6), ctx_r1.isSelected(day_r6.date)));
  }
}
function Rtl2DatepickerMonthView_ng_template_1_div_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵlistener("click", function Rtl2DatepickerMonthView_ng_template_1_div_0_div_2_Template_div_click_0_listener() {
      const day_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const week_r4 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.doSelect(week_r4, day_r6));
    });
    i0.ɵɵtemplate(1, Rtl2DatepickerMonthView_ng_template_1_div_0_div_2_ng_template_1_Template, 1, 11, "ng-template", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("selected", ctx_r1.isSelected(day_r6.date))("disabled", ctx_r1.isDisabled(day_r6))("hidden", ctx_r1.isHidden(day_r6));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isHidden(day_r6));
  }
}
function Rtl2DatepickerMonthView_ng_template_1_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, Rtl2DatepickerMonthView_ng_template_1_div_0_div_1_Template, 2, 12, "div", 7)(2, Rtl2DatepickerMonthView_ng_template_1_div_0_div_2_Template, 2, 7, "div", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const week_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("week-selected", ctx_r1.isSelectedWeek(week_r4))("item-selected", ctx_r1.isSelectedWeekDay(week_r4));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showWeekNumbers);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", week_r4.days);
  }
}
function Rtl2DatepickerMonthView_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Rtl2DatepickerMonthView_ng_template_1_div_0_Template, 3, 6, "div", 6);
  }
  if (rf & 2) {
    const week_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r1.isCollapsed(week_r4));
  }
}
function Rtl2DatepickerNavigationSelect_option_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 2);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const m_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", m_r1)("selected", (ctx_r1.date == null ? null : ctx_r1.date.month) === m_r1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 3, ctx_r1.i18n.getMonthShortName(m_r1)));
  }
}
function Rtl2DatepickerNavigationSelect_option_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const y_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", y_r3)("selected", (ctx_r1.date == null ? null : ctx_r1.date.year) === y_r3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(y_r3);
  }
}
function Rtl2DatepickerNavigation_rtl2_datepicker_navigation_select_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "rtl2-datepicker-navigation-select", 5);
    i0.ɵɵlistener("select", function Rtl2DatepickerNavigation_rtl2_datepicker_navigation_select_0_Template_rtl2_datepicker_navigation_select_select_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectDate($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r1.months * 9, "rem");
    i0.ɵɵproperty("date", ctx_r1.date)("minDate", ctx_r1.minDate)("maxDate", ctx_r1.maxDate)("disabled", ctx_r1.disabled);
  }
}
const _c3 = ["rtl2DatepickerDayView", ""];
const _c4 = ["rtl2DatepickerWeekNumberView", ""];
function Rtl2Datepicker_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
  }
  if (rf & 2) {
    const date_r1 = ctx.date;
    const currentMonth_r2 = ctx.currentMonth;
    const selected_r3 = ctx.selected;
    const disabled_r4 = ctx.disabled;
    i0.ɵɵproperty("date", date_r1)("currentMonth", currentMonth_r2)("selected", selected_r3)("disabled", disabled_r4);
  }
}
function Rtl2Datepicker_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
  }
  if (rf & 2) {
    const week_r5 = ctx.week;
    const selected_r6 = ctx.selected;
    const disabled_r7 = ctx.disabled;
    i0.ɵɵproperty("week", week_r5)("selected", selected_r6)("disabled", disabled_r7);
  }
}
function Rtl2Datepicker_rtl2_datepicker_navigation_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "rtl2-datepicker-navigation", 8);
    i0.ɵɵlistener("navigate", function Rtl2Datepicker_rtl2_datepicker_navigation_5_Template_rtl2_datepicker_navigation_navigate_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r8 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r8.onNavigateEvent($event));
    })("select", function Rtl2Datepicker_rtl2_datepicker_navigation_5_Template_rtl2_datepicker_navigation_select_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r8 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r8.onNavigateDateSelect($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("date", ctx_r8.months[0] == null ? null : ctx_r8.months[0].firstDate)("minDate", ctx_r8._minDate)("maxDate", ctx_r8._maxDate)("months", ctx_r8.months.length)("disabled", ctx_r8.disabled)("showWeekNumbers", ctx_r8.showWeekNumbers)("showSelect", ctx_r8.navigation === "select");
  }
}
function Rtl2Datepicker_ng_template_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const month_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, ctx_r8.i18n.getMonthFullName(month_r11.number)), " ", month_r11.year, " ");
  }
}
function Rtl2Datepicker_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, Rtl2Datepicker_ng_template_7_div_1_Template, 3, 4, "div", 10);
    i0.ɵɵelementStart(2, "rtl2-datepicker-month-view", 11);
    i0.ɵɵlistener("select", function Rtl2Datepicker_ng_template_7_Template_rtl2_datepicker_month_view_select_2_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r8 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r8.onDateSelect($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const month_r11 = ctx.$implicit;
    const ctx_r8 = i0.ɵɵnextContext();
    const dt_r12 = i0.ɵɵreference(1);
    const wt_r13 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r8.navigation !== "select" || ctx_r8.displayMonths > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("month", month_r11)("selectedData", ctx_r8.model)("dayTemplate", ctx_r8.dayTemplate || dt_r12)("weekNumberTemplate", ctx_r8.weekNumberTemplate || wt_r13)("showWeekdays", ctx_r8.showWeekdays)("showWeekNumbers", ctx_r8.showWeekNumbers)("weeksSelectable", ctx_r8.weeksSelectable)("disabled", ctx_r8.disabled)("outsideDays", ctx_r8.displayMonths === 1 ? ctx_r8.outsideDays : "hidden");
  }
}
const _c5 = [[["", "md-mini-fab", ""], ["", "mat-mini-fab", ""]]];
const _c6 = ["[md-mini-fab], [mat-mini-fab]"];
const _c7 = [[["", "mat-fab", ""]]];
const _c8 = ["[mat-fab]"];
const _c9 = [[["rtl2-fab-trigger"]], [["rtl2-fab-actions"]]];
const _c10 = ["rtl2-fab-trigger", "rtl2-fab-actions"];
function Rtl2IdNameAutocompleteComponent_mat_option_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 5)(1, "p", 6);
    i0.ɵɵtext(2, "No results");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵproperty("disabled", true);
  }
}
function Rtl2IdNameAutocompleteComponent_ng_template_4_mat_option_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-option", 8);
    i0.ɵɵlistener("onSelectionChange", function Rtl2IdNameAutocompleteComponent_ng_template_4_mat_option_0_Template_mat_option_onSelectionChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.select($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", option_r3)("innerHtml", ctx_r1.optionsDisplayResolver(option_r3).name, i0.ɵɵsanitizeHtml);
  }
}
function Rtl2IdNameAutocompleteComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Rtl2IdNameAutocompleteComponent_ng_template_4_mat_option_0_Template, 1, 2, "mat-option", 7);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r1.options);
  }
}
function Rtl2IdNameSelectComponent_mat_option_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r1.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r1.name);
  }
}
const _c11 = ["iframe"];
function Rtl2ImageCarouselThumbnailComponent_img_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 3, 0);
    i0.ɵɵlistener("load", function Rtl2ImageCarouselThumbnailComponent_img_0_Template_img_load_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const image_r2 = i0.ɵɵreference(1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.imageLoaded(image_r2));
    })("error", function Rtl2ImageCarouselThumbnailComponent_img_0_Template_img_error_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.setError());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r2.url, i0.ɵɵsanitizeUrl);
  }
}
function Rtl2ImageCarouselThumbnailComponent_mat_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 4);
    i0.ɵɵtext(1, "broken_image");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r2.iconSize, "px")("height", ctx_r2.iconSize, "px")("font-size", ctx_r2.iconSize, "px");
  }
}
function Rtl2ImageCarouselContainerComponent_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function Rtl2ImageCarouselContainerComponent_button_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.navigateLeft());
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "keyboard_arrow_left");
    i0.ɵɵelementEnd()();
  }
}
function Rtl2ImageCarouselContainerComponent_rtl2_image_carousel_thumbnail_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "rtl2-image-carousel-thumbnail", 6, 0);
    i0.ɵɵlistener("click", function Rtl2ImageCarouselContainerComponent_rtl2_image_carousel_thumbnail_2_Template_rtl2_image_carousel_thumbnail_click_0_listener() {
      const displayElement_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const imgCrslTmbn_r5 = i0.ɵɵreference(1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerEmmiterForElementAndInputClick(displayElement_r4, imgCrslTmbn_r5));
    })("mouseenter", function Rtl2ImageCarouselContainerComponent_rtl2_image_carousel_thumbnail_2_Template_rtl2_image_carousel_thumbnail_mouseenter_0_listener() {
      const displayElement_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const imgCrslTmbn_r5 = i0.ɵɵreference(1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerEmmiterForElementAndInputMouseEnter(displayElement_r4, imgCrslTmbn_r5));
    })("mouseleave", function Rtl2ImageCarouselContainerComponent_rtl2_image_carousel_thumbnail_2_Template_rtl2_image_carousel_thumbnail_mouseleave_0_listener() {
      const displayElement_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const imgCrslTmbn_r5 = i0.ɵɵreference(1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.triggerEmmiterForElementAndInputMouseLeave(displayElement_r4, imgCrslTmbn_r5));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const displayElement_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("min-width", ctx_r1.parentHeight, "px")("min-height", ctx_r1.parentHeight, "px")("margin-right", displayElement_r4.imageRightMargin, "px");
    i0.ɵɵclassProp("is-selected", ctx_r1.isSelected(displayElement_r4))("is-highlighted", ctx_r1.isHighlighted(displayElement_r4));
    i0.ɵɵproperty("url", displayElement_r4.url);
  }
}
function Rtl2ImageCarouselContainerComponent_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function Rtl2ImageCarouselContainerComponent_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.navigateRight());
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "keyboard_arrow_right");
    i0.ɵɵelementEnd()();
  }
}
const _c12 = ["imageElement"];
function Rtl2ImageLoaderComponent_img_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 4, 0);
    i0.ɵɵlistener("load", function Rtl2ImageLoaderComponent_img_0_Template_img_load_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLoad($event));
    })("error", function Rtl2ImageLoaderComponent_img_0_Template_img_error_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onError($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("hidden", !ctx_r1.loaded)("portrait", ctx_r1.portrait);
    i0.ɵɵproperty("src", ctx_r1.src, i0.ɵɵsanitizeUrl)("@fadeIn", ctx_r1.state);
  }
}
function Rtl2ImageLoaderComponent_mat_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 5);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2, "image");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("matTooltip", i0.ɵɵpipeBind1(1, 3, "rtl2.imageLoader.error"))("matTooltipPosition", "above")("matTooltipClass", "warn image-loader-error");
  }
}
function Rtl2ImageLoaderComponent_mat_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 6);
    i0.ɵɵtext(1, "data_usage");
    i0.ɵɵelementEnd();
  }
}
function Rtl2KeywordsInputComponent_mat_chip_row_2_button_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 5)(1, "mat-icon");
    i0.ɵɵtext(2, "cancel");
    i0.ɵɵelementEnd()();
  }
}
function Rtl2KeywordsInputComponent_mat_chip_row_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-chip-row", 3);
    i0.ɵɵlistener("removed", function Rtl2KeywordsInputComponent_mat_chip_row_2_Template_mat_chip_row_removed_0_listener() {
      const i_r3 = i0.ɵɵrestoreView(_r2).index;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.removeTag(i_r3));
    });
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, Rtl2KeywordsInputComponent_mat_chip_row_2_button_2_Template, 3, 0, "button", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tag_r5 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("read", ctx_r3.disabled);
    i0.ɵɵproperty("disabled", ctx_r3.disabled)("removable", !ctx_r3.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", tag_r5.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3.disabled);
  }
}
function Rtl2LogoComponent__svg_g_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "g");
    i0.ɵɵelement(1, "path", 8)(2, "path", 9)(3, "path", 10)(4, "path", 11)(5, "path", 12)(6, "path", 13)(7, "path", 14);
    i0.ɵɵelementEnd();
  }
}
const _c13 = [[["", "controls-prefix", ""]], [["", "controls-suffix", ""]]];
const _c14 = ["[controls-prefix]", "[controls-suffix]"];
function Rtl2ToolbarComponent_button_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function Rtl2ToolbarComponent_button_9_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleInfoMenu($event));
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "help_outlined");
    i0.ɵɵelementEnd()();
  }
}
function Rtl2ToolbarComponent_div_10_a_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 10);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("click", function Rtl2ToolbarComponent_div_10_a_2_Template_a_click_0_listener() {
      const item_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.go(item_r5.url));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, item_r5.name), i0.ɵɵsanitizeHtml);
  }
}
function Rtl2ToolbarComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("rtl2MouseclickOutside", function Rtl2ToolbarComponent_div_10_Template_div_rtl2MouseclickOutside_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.displayInfoMenu = false);
    });
    i0.ɵɵelementStart(1, "mat-nav-list");
    i0.ɵɵtemplate(2, Rtl2ToolbarComponent_div_10_a_2_Template, 2, 3, "a", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@appMenu", undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.infoMenu);
  }
}
function Rtl2ToolbarComponent_button_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function Rtl2ToolbarComponent_button_12_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleMenu($event));
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "apps");
    i0.ɵɵelementEnd()();
  }
}
function Rtl2ToolbarComponent_div_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("rtl2MouseclickOutside", function Rtl2ToolbarComponent_div_13_Template_div_rtl2MouseclickOutside_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.displayMenu = false);
    });
    i0.ɵɵelement(1, "rtl2-dashboard-popup");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("@appMenu", undefined);
  }
}
const _c15 = ["*", [["", "menu-controls-prefix", ""]], [["", "menu-controls-suffix", ""]]];
const _c16 = ["*", "[menu-controls-prefix]", "[menu-controls-suffix]"];
function Rtl2LayoutBaseComponent_ng_container_0_rtl2_toolbar_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "rtl2-toolbar", 4);
    i0.ɵɵelementContainerStart(1, 5);
    i0.ɵɵprojection(2, 1);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(3, 6);
    i0.ɵɵprojection(4, 2);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r0.title)("menu", ctx_r0.showMenu);
  }
}
function Rtl2LayoutBaseComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Rtl2LayoutBaseComponent_ng_container_0_rtl2_toolbar_1_Template, 5, 2, "rtl2-toolbar", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.useToolbar);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("container-fullheight", ctx_r0.useFullHeight);
  }
}
function Rtl2LayoutBaseComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "rtl2-placeholder-empty", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0.title);
  }
}
const _c17 = () => ["/"];
function Rtl2403Component_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "p", 9);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p", 10);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "rtl2.services.403.missingRole"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 4, ctx_r0.missingRole$));
  }
}
const _c18 = ".large[_ngcontent-%COMP%]{font-size:8rem;font-weight:200;line-height:8rem;width:500px}";
const _c19 = ["prelHours"];
const _c20 = ["prelMinutes"];
const _c21 = a0 => ({
  "mat-form-field-invalid": a0
});
const _c22 = ["rtl2ElementContentContainer", ""];
const _c23 = ["*"];
function Rtl2ElementContentContainer_ng_container_0_ng_scrollbar_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-scrollbar");
    i0.ɵɵelementContainer(1, 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const content_r1 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r1);
  }
}
function Rtl2ElementContentContainer_ng_container_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const content_r1 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r1);
  }
}
function Rtl2ElementContentContainer_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 3);
    i0.ɵɵtemplate(1, Rtl2ElementContentContainer_ng_container_0_ng_scrollbar_1_Template, 2, 1, "ng-scrollbar", 4)(2, Rtl2ElementContentContainer_ng_container_0_ng_container_2_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", ctx_r1.height100);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", false);
  }
}
function Rtl2ElementContentContainer_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "mat-spinner");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("@loadingAnimation", undefined);
  }
}
function Rtl2ElementContentContainer_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c24 = [[["", 8, "column-0"]], [["", 8, "column-1"]], [["", 8, "column-2"]], [["", 8, "column-3"]], [["", 8, "column-4"]], [["", 8, "column-5"]], [["", 8, "column-6"]], [["", 8, "column-7"]], [["", 8, "column-8"]], [["", 8, "column-9"]]];
const _c25 = [".column-0", ".column-1", ".column-2", ".column-3", ".column-4", ".column-5", ".column-6", ".column-7", ".column-8", ".column-9"];
function Rtl2ElementContentColumnsCenteredComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", ctx_r0.columnLoading[0])("height100", ctx_r0.columnHeight100[0])("width", ctx_r0.columnWidth[0])("styles", ctx_r0.columnStyles[0]);
  }
}
function Rtl2ElementContentColumnsCenteredComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", ctx_r0.columnLoading[1])("height100", ctx_r0.columnHeight100[1])("width", ctx_r0.columnWidth[1])("styles", ctx_r0.columnStyles[1]);
  }
}
function Rtl2ElementContentColumnsCenteredComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", ctx_r0.columnLoading[2])("height100", ctx_r0.columnHeight100[2])("width", ctx_r0.columnWidth[2])("styles", ctx_r0.columnStyles[2]);
  }
}
function Rtl2ElementContentColumnsCenteredComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", ctx_r0.columnLoading[3])("height100", ctx_r0.columnHeight100[3])("width", ctx_r0.columnWidth[3])("styles", ctx_r0.columnStyles[3]);
  }
}
function Rtl2ElementContentColumnsCenteredComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1, 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", ctx_r0.columnLoading[4])("height100", ctx_r0.columnHeight100[4])("width", ctx_r0.columnWidth[4])("styles", ctx_r0.columnStyles[4]);
  }
}
function Rtl2ElementContentColumnsCenteredComponent_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1, 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", ctx_r0.columnLoading[5])("height100", ctx_r0.columnHeight100[5])("width", ctx_r0.columnWidth[5])("styles", ctx_r0.columnStyles[5]);
  }
}
function Rtl2ElementContentColumnsCenteredComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1, 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", ctx_r0.columnLoading[6])("height100", ctx_r0.columnHeight100[6])("width", ctx_r0.columnWidth[6])("styles", ctx_r0.columnStyles[6]);
  }
}
function Rtl2ElementContentColumnsCenteredComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1, 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", ctx_r0.columnLoading[7])("height100", ctx_r0.columnHeight100[7])("width", ctx_r0.columnWidth[7])("styles", ctx_r0.columnStyles[7]);
  }
}
function Rtl2ElementContentColumnsCenteredComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1, 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", ctx_r0.columnLoading[8])("height100", ctx_r0.columnHeight100[8])("width", ctx_r0.columnWidth[8])("styles", ctx_r0.columnStyles[8]);
  }
}
function Rtl2ElementContentColumnsCenteredComponent_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1, 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", ctx_r0.columnLoading[9])("height100", ctx_r0.columnHeight100[9])("width", ctx_r0.columnWidth[9])("styles", ctx_r0.columnStyles[9]);
  }
}
const _c26 = "[_nghost-%COMP%]{display:block;overflow:hidden;max-width:95%;width:0;padding:1rem .2rem;margin:0 auto;transition:width .2s ease}.container-wrapper[_ngcontent-%COMP%]{max-width:100%}.container-content[_ngcontent-%COMP%]{padding:0}.container-content.height100[_ngcontent-%COMP%]{height:100%}.container-content.height100[_ngcontent-%COMP%] > .container-wrapper[_ngcontent-%COMP%]{height:100%}";
class Rtl2UiMenuGroup {
  constructor(init) {
    this.list = [];
    Object.assign(this, init);
  }
}
class Rtl2UiMenuItem {
  constructor(init) {
    this.name = '';
    this.link = '';
    this.disabled = false;
    Object.assign(this, init);
  }
}
let Rtl2UiInterface = /*#__PURE__*/(() => {
  class Rtl2UiInterface {
    static {
      this.ɵfac = function Rtl2UiInterface_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2UiInterface)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: Rtl2UiInterface,
        factory: Rtl2UiInterface.ɵfac
      });
    }
  }
  return Rtl2UiInterface;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2WindowResizeObserverService = /*#__PURE__*/(() => {
  class Rtl2WindowResizeObserverService {
    constructor(zone) {
      this.zone = zone;
      this._action = new Subject();
      this.zone.runOutsideAngular(() => {
        fromEvent(window, 'resize').pipe(debounceTime(300), distinctUntilChanged()).subscribe(e => {
          this.zone.run(() => {
            this._action.next(e);
          });
        });
      });
    }
    get watch() {
      return this._action.pipe(share());
    }
    static {
      this.ɵfac = function Rtl2WindowResizeObserverService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2WindowResizeObserverService)(i0.ɵɵinject(i0.NgZone));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: Rtl2WindowResizeObserverService,
        factory: Rtl2WindowResizeObserverService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return Rtl2WindowResizeObserverService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2CollapseHeaderDirective = /*#__PURE__*/(() => {
  class Rtl2CollapseHeaderDirective {
    set rtl2CollapseHeader(v) {
      this.value = !!v;
      if (this.value) this.toggle();
    }
    onClick() {
      this.toggle();
    }
    constructor(ref, builder) {
      this.ref = ref;
      this.builder = builder;
      this.value = false;
    }
    toggle() {
      const element = this.ref.nativeElement.nextSibling;
      if (!element?.classList) return;
      element.style.overflow = 'hidden';
      element.classList.toggle('rtl2-collapsed');
      const metadata = element.classList.contains('rtl2-collapsed') ? animate('0.2s', keyframes([style({
        height: '0',
        visibility: 'hidden',
        opacity: 0
      })])) : animate('0.2s', keyframes([style({
        height: 'auto',
        visibility: 'visible',
        opacity: 1
      })]));
      const factory = this.builder.build(metadata);
      const player = factory.create(element);
      player.play();
    }
    static {
      this.ɵfac = function Rtl2CollapseHeaderDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2CollapseHeaderDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.AnimationBuilder));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: Rtl2CollapseHeaderDirective,
        selectors: [["", "rtl2CollapseHeader", ""]],
        hostAttrs: [2, "cursor", "pointer"],
        hostBindings: function Rtl2CollapseHeaderDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function Rtl2CollapseHeaderDirective_click_HostBindingHandler() {
              return ctx.onClick();
            });
          }
        },
        inputs: {
          rtl2CollapseHeader: "rtl2CollapseHeader"
        }
      });
    }
  }
  return Rtl2CollapseHeaderDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2FallbackImageDirective = /*#__PURE__*/(() => {
  class Rtl2FallbackImageDirective {
    constructor(ref) {
      this.ref = ref;
    }
    loadFallbackOnError() {
      const element = this.ref?.nativeElement;
      element.src = this.rtl2Fallback || 'data:image/png;base64,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';
      this.className = 'image-error image-fallback';
    }
    loadSuccess() {
      this.className = 'image-loaded';
    }
    static {
      this.ɵfac = function Rtl2FallbackImageDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2FallbackImageDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: Rtl2FallbackImageDirective,
        selectors: [["img", "rtl2Fallback", ""]],
        hostVars: 2,
        hostBindings: function Rtl2FallbackImageDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("error", function Rtl2FallbackImageDirective_error_HostBindingHandler() {
              return ctx.loadFallbackOnError();
            })("load", function Rtl2FallbackImageDirective_load_HostBindingHandler() {
              return ctx.loadSuccess();
            });
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.className);
          }
        },
        inputs: {
          rtl2Fallback: "rtl2Fallback"
        }
      });
    }
  }
  return Rtl2FallbackImageDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2FocusClassDirective = /*#__PURE__*/(() => {
  class Rtl2FocusClassDirective {
    constructor(elementRef, renderer) {
      this.elementRef = elementRef;
      this.renderer = renderer;
    }
    focus() {
      this.renderer.addClass(this.elementRef.nativeElement, this.rtl2FocusClass);
    }
    focusout() {
      this.renderer.removeClass(this.elementRef.nativeElement, this.rtl2FocusClass);
    }
    static {
      this.ɵfac = function Rtl2FocusClassDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2FocusClassDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: Rtl2FocusClassDirective,
        selectors: [["", "rtl2FocusClass", ""]],
        hostBindings: function Rtl2FocusClassDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("focus", function Rtl2FocusClassDirective_focus_HostBindingHandler() {
              return ctx.focus();
            })("focusout", function Rtl2FocusClassDirective_focusout_HostBindingHandler() {
              return ctx.focusout();
            });
          }
        },
        inputs: {
          rtl2FocusClass: "rtl2FocusClass"
        }
      });
    }
  }
  return Rtl2FocusClassDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2HoverClassDirective = /*#__PURE__*/(() => {
  class Rtl2HoverClassDirective {
    constructor(elementRef, renderer) {
      this.elementRef = elementRef;
      this.renderer = renderer;
    }
    mouseover() {
      this.renderer.addClass(this.elementRef.nativeElement, this.rtl2HoverClass);
    }
    mouseout() {
      this.renderer.removeClass(this.elementRef.nativeElement, this.rtl2HoverClass);
    }
    static {
      this.ɵfac = function Rtl2HoverClassDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2HoverClassDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: Rtl2HoverClassDirective,
        selectors: [["", "rtl2HoverClass", ""]],
        hostBindings: function Rtl2HoverClassDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mouseover", function Rtl2HoverClassDirective_mouseover_HostBindingHandler() {
              return ctx.mouseover();
            })("mouseout", function Rtl2HoverClassDirective_mouseout_HostBindingHandler() {
              return ctx.mouseout();
            });
          }
        },
        inputs: {
          rtl2HoverClass: "rtl2HoverClass"
        }
      });
    }
  }
  return Rtl2HoverClassDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2QuoteMarksDeDirective = /*#__PURE__*/(() => {
  class Rtl2QuoteMarksDeDirective {
    constructor(elementRef, renderer) {
      this.elementRef = elementRef;
      this.renderer = renderer;
    }
    keyup() {
      const value = this.elementRef?.nativeElement?.value;
      const replacement = value?.replace(/\"(.*)\"/g, '„$1“');
      if (replacement !== value) {
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', replacement);
      }
    }
    static {
      this.ɵfac = function Rtl2QuoteMarksDeDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2QuoteMarksDeDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: Rtl2QuoteMarksDeDirective,
        selectors: [["", "rtl2QuoteMarksDE", ""]],
        hostBindings: function Rtl2QuoteMarksDeDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("input", function Rtl2QuoteMarksDeDirective_input_HostBindingHandler() {
              return ctx.keyup();
            });
          }
        }
      });
    }
  }
  return Rtl2QuoteMarksDeDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2MousedownOutsideDirective = /*#__PURE__*/(() => {
  class Rtl2MousedownOutsideDirective {
    constructor(_elementRef) {
      this._elementRef = _elementRef;
      this.rtl2MousedownOutside = new EventEmitter();
    }
    onMouseDown(event) {
      const mouseDownInside = this._elementRef.nativeElement.contains(event.target);
      if (!mouseDownInside) {
        this.rtl2MousedownOutside.emit({
          outside: true,
          event: event
        });
      }
    }
    static {
      this.ɵfac = function Rtl2MousedownOutsideDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2MousedownOutsideDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: Rtl2MousedownOutsideDirective,
        selectors: [["", "rtl2MousedownOutside", ""]],
        hostBindings: function Rtl2MousedownOutsideDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mousedown", function Rtl2MousedownOutsideDirective_mousedown_HostBindingHandler($event) {
              return ctx.onMouseDown($event);
            }, false, i0.ɵɵresolveDocument);
          }
        },
        outputs: {
          rtl2MousedownOutside: "rtl2MousedownOutside"
        }
      });
    }
  }
  return Rtl2MousedownOutsideDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2MouseclickOutsideDirective = /*#__PURE__*/(() => {
  class Rtl2MouseclickOutsideDirective {
    constructor(_elementRef) {
      this._elementRef = _elementRef;
      this.rtl2MouseclickOutside = new EventEmitter();
    }
    onMouseDown(event) {
      const mouseDownInside = this._elementRef.nativeElement.contains(event.target);
      if (!mouseDownInside) {
        this.rtl2MouseclickOutside.emit({
          outside: true,
          event: event
        });
      }
    }
    static {
      this.ɵfac = function Rtl2MouseclickOutsideDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2MouseclickOutsideDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: Rtl2MouseclickOutsideDirective,
        selectors: [["", "rtl2MouseclickOutside", ""]],
        hostBindings: function Rtl2MouseclickOutsideDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function Rtl2MouseclickOutsideDirective_click_HostBindingHandler($event) {
              return ctx.onMouseDown($event);
            }, false, i0.ɵɵresolveDocument);
          }
        },
        outputs: {
          rtl2MouseclickOutside: "rtl2MouseclickOutside"
        }
      });
    }
  }
  return Rtl2MouseclickOutsideDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2TrackVisibilityDirective = /*#__PURE__*/(() => {
  class Rtl2TrackVisibilityDirective {
    constructor(el, ngZone) {
      this.el = el;
      this.ngZone = ngZone;
      this.visibile = new EventEmitter();
    }
    ngOnInit() {
      this.ngZone.runOutsideAngular(() => {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(e => {
            this.visibile.emit(e.isIntersecting);
            e.isIntersecting ? this.el.nativeElement.classList.add('rtl2-visible') : this.el.nativeElement.classList.remove('rtl2-visible');
          });
        });
        this.observer.observe(this.el.nativeElement);
      });
    }
    ngOnDestroy() {
      this.observer.disconnect();
    }
    static {
      this.ɵfac = function Rtl2TrackVisibilityDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2TrackVisibilityDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: Rtl2TrackVisibilityDirective,
        selectors: [["", "rtl2TrackVisibility", ""]],
        outputs: {
          visibile: "visibile"
        }
      });
    }
  }
  return Rtl2TrackVisibilityDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const Rtl2UiDirectives = [Rtl2CollapseHeaderDirective, Rtl2FallbackImageDirective, Rtl2FocusClassDirective, Rtl2HoverClassDirective, Rtl2QuoteMarksDeDirective, Rtl2MousedownOutsideDirective, Rtl2MouseclickOutsideDirective, Rtl2TrackVisibilityDirective];
let Rtl2CamelPipeToDash = /*#__PURE__*/(() => {
  class Rtl2CamelPipeToDash {
    transform(value) {
      return Rtl2CamelPipeToDash.mutation(value);
    }
    static mutation(str) {
      if (typeof str !== 'string') return '';
      return str.replace(/[A-Z]/g, '-$&').replace(/-+/g, '-').toLowerCase();
    }
    static {
      this.ɵfac = function Rtl2CamelPipeToDash_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2CamelPipeToDash)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "rtl2CamelToDash",
        type: Rtl2CamelPipeToDash,
        pure: true
      });
    }
  }
  return Rtl2CamelPipeToDash;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2DashToCamelPipe = /*#__PURE__*/(() => {
  class Rtl2DashToCamelPipe {
    transform(value) {
      return Rtl2DashToCamelPipe.mutation(value);
    }
    static mutation(str) {
      if (typeof str !== 'string') return '';
      return str.replace(/-+/g, '-').replace(/-(.)/g, g => g[1].toUpperCase());
    }
    static {
      this.ɵfac = function Rtl2DashToCamelPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DashToCamelPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "rtl2DashToCamel",
        type: Rtl2DashToCamelPipe,
        pure: true
      });
    }
  }
  return Rtl2DashToCamelPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2DateCleanPipe = /*#__PURE__*/(() => {
  class Rtl2DateCleanPipe {
    constructor(datePipe) {
      this.datePipe = datePipe;
    }
    transform(value, format, timezone, locale) {
      if (!value) {
        return null;
      }
      const t = value.match(/^(\d{4})[\/.-](\d{2})[\/.-](\d{2})[ |T](\d{2}):(\d{2}).*?$/);
      if (t === null) {
        return null;
      }
      return this.datePipe.transform(new Date(+t[1], +t[2] - 1, +t[3], +t[4], +t[5]), format, timezone, locale);
    }
    static {
      this.ɵfac = function Rtl2DateCleanPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DateCleanPipe)(i0.ɵɵdirectiveInject(i2.DatePipe, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "rtl2DateClean",
        type: Rtl2DateCleanPipe,
        pure: true
      });
    }
  }
  return Rtl2DateCleanPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2DatesPipe = /*#__PURE__*/(() => {
  class Rtl2DatesPipe {
    constructor(translateService) {
      this.translateService = translateService;
      this.setTranslations();
    }
    transform(input, elapsed) {
      if (!input.date) {
        return '';
      }
      const date = input.date;
      const name = input.name ? input.name : '';
      const mode = elapsed ? elapsed : '';
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const formattedDate = `${this.cdd(day)}.${this.cdd(month)}.${year} ${this.cdd(hours)}:${this.cdd(minutes)}`;
      if (mode === '') {
        return `${this.lastChanged} ${name}, ${this.at} ${formattedDate}`;
      }
      const currentDate = new Date();
      const difference = this.timeDifference(currentDate.getTime(), date.getTime());
      const differenceTranslationKey = 'rtl2.datesPipe.' + difference.type;
      this.translateService.get(differenceTranslationKey).pipe(take(1)).subscribe(value => this.period = value);
      if (difference.value === 1) {
        return `${this.updated} ${difference.value} ${this.period.slice(0, -1)} ${this.ago}`;
      } else {
        return `${this.updated} ${difference.value} ${this.period} ${this.ago}`;
      }
    }
    setTranslations() {
      this.translateService.get('rtl2.datesPipe.lastChanged').pipe(take(1)).subscribe(value => this.lastChanged = value);
      this.translateService.get('rtl2.datesPipe.at').pipe(take(1)).subscribe(value => this.at = value);
      this.translateService.get('rtl2.datesPipe.updated').pipe(take(1)).subscribe(value => this.updated = value);
      this.translateService.get('rtl2.datesPipe.ago').pipe(take(1)).subscribe(value => this.ago = value);
    }
    timeDifference(current, previous) {
      const msPerMinute = 60 * 1000;
      const msPerHour = msPerMinute * 60;
      const msPerDay = msPerHour * 24;
      const msPerMonth = msPerDay * 30;
      const msPerYear = msPerDay * 365;
      const elapsed = current - previous;
      if (elapsed < msPerMinute) {
        return {
          value: Math.round(elapsed / 1000),
          type: 'seconds'
        };
      } else if (elapsed < msPerHour) {
        return {
          value: Math.round(elapsed / msPerMinute),
          type: 'minutes'
        };
      } else if (elapsed < msPerDay) {
        return {
          value: Math.round(elapsed / msPerHour),
          type: 'hours'
        };
      } else if (elapsed < msPerMonth) {
        return {
          value: Math.round(elapsed / msPerDay),
          type: 'days'
        };
      } else if (elapsed < msPerYear) {
        return {
          value: Math.round(elapsed / msPerMonth),
          type: 'months'
        };
      } else {
        return {
          value: Math.round(elapsed / msPerYear),
          type: 'years'
        };
      }
    }
    /**
     * Convert to double digit number
     * @param n
     * @returns
     */
    cdd(n) {
      return ('0' + n).slice(-2);
    }
    static {
      this.ɵfac = function Rtl2DatesPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DatesPipe)(i0.ɵɵdirectiveInject(i2$1.TranslateService, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "rtl2Dates",
        type: Rtl2DatesPipe,
        pure: true
      });
    }
  }
  return Rtl2DatesPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2XMLPipe = /*#__PURE__*/(() => {
  class Rtl2XMLPipe {
    transform(value) {
      let ar = value.replace(/>\s{0,}</g, '><').replace(/</g, '~::~<').replace(/\s*xmlns\:/g, '~::~xmlns:').replace(/\s*xmlns\=/g, '~::~xmlns=').split('~::~'),
        len = ar.length,
        inComment = false,
        deep = 0,
        str = '',
        ix = 0,
        shift = this.createShiftArr('  ');
      for (ix = 0; ix < len; ix++) {
        // start comment or <![CDATA[...]]> or <!DOCTYPE //
        if (ar[ix].search(/<!/) > -1) {
          str += shift[deep] + ar[ix];
          inComment = true;
          // end comment  or <![CDATA[...]]> //
          if (ar[ix].search(/-->/) > -1 || ar[ix].search(/\]>/) > -1 || ar[ix].search(/!DOCTYPE/) > -1) {
            inComment = false;
          }
        }
        // end comment  or <![CDATA[...]]> //
        else if (ar[ix].search(/-->/) > -1 || ar[ix].search(/\]>/) > -1) {
          str += ar[ix];
          inComment = false;
        }
        // <elm></elm> //
        else if (/^<\w/.exec(ar[ix - 1]) && /^<\/\w/.exec(ar[ix]) && /^<[\w:\-\.\,]+/.exec(ar[ix - 1]).toString() == /^<\/[\w:\-\.\,]+/.exec(ar[ix])[0].replace('/', '')) {
          str += ar[ix];
          if (!inComment) deep--;
        }
        // <elm> //
        else if (ar[ix].search(/<\w/) > -1 && ar[ix].search(/<\//) == -1 && ar[ix].search(/\/>/) == -1) {
          str = !inComment ? str += shift[deep++] + ar[ix] : str += ar[ix];
        }
        // <elm>...</elm> //
        else if (ar[ix].search(/<\w/) > -1 && ar[ix].search(/<\//) > -1) {
          str = !inComment ? str += shift[deep] + ar[ix] : str += ar[ix];
        }
        // </elm> //
        else if (ar[ix].search(/<\//) > -1) {
          str = !inComment ? str += shift[--deep] + ar[ix] : str += ar[ix];
        }
        // <elm/> //
        else if (ar[ix].search(/\/>/) > -1) {
          str = !inComment ? str += shift[deep] + ar[ix] : str += ar[ix];
        }
        // <? xml ... ?> //
        else if (ar[ix].search(/<\?/) > -1) {
          str += shift[deep] + ar[ix];
        }
        // xmlns //
        else if (ar[ix].search(/xmlns\:/) > -1 || ar[ix].search(/xmlns\=/) > -1) {
          str += shift[deep] + ar[ix];
        } else {
          str += ar[ix];
        }
      }
      return str[0] == '\n' ? str.slice(1) : str;
    }
    createShiftArr(step) {
      let space = '    ';
      if (isNaN(parseInt(step))) {
        // argument is string
        space = step;
      } else {
        // argument is integer
        switch (step) {
          case 1:
            space = ' ';
            break;
          case 2:
            space = '  ';
            break;
          case 3:
            space = '   ';
            break;
          case 4:
            space = '    ';
            break;
          case 5:
            space = '     ';
            break;
          case 6:
            space = '      ';
            break;
          case 7:
            space = '       ';
            break;
          case 8:
            space = '        ';
            break;
          case 9:
            space = '         ';
            break;
          case 10:
            space = '          ';
            break;
          case 11:
            space = '           ';
            break;
          case 12:
            space = '            ';
            break;
        }
      }
      const shift = ['\n']; // array of shifts
      for (let ix = 0; ix < 100; ix++) {
        shift.push(shift[ix] + space);
      }
      return shift;
    }
    static {
      this.ɵfac = function Rtl2XMLPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2XMLPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "rtl2Xml",
        type: Rtl2XMLPipe,
        pure: true
      });
    }
  }
  return Rtl2XMLPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Rtl2Util {
  static isObject(target) {
    return typeof target === 'object' && !Array.isArray(target) && target !== null;
  }
  static isEmpty(target) {
    switch (typeof target) {
      case 'string':
        return !target.length;
      case 'object':
        return Array.isArray(target) ? !target.length : target === null || !Object.keys(target)?.length;
      case 'number':
      case 'boolean':
        return false;
      default:
        return !target;
    }
  }
  static isStringNotEmpty(target) {
    return typeof target === 'string' && !!target.length;
  }
  static isArrayNotEmpty(target) {
    return Array.isArray(target) && !!target.length;
  }
  static isObjectNotEmpty(target) {
    return !!target && typeof target === 'object' && !Array.isArray(target) && !!Object.keys(target)?.length;
  }
  // get nested object value
  static objectPropertyValue(target, propertyPath, defaultValue = null) {
    if (!propertyPath?.length) return defaultValue;
    return propertyPath.split(/[\.\[\]\'\"]/).filter(p => p).reduce((o, p) => o ? o[p] : defaultValue, target);
  }
  // flatten nested object
  static objectFlatten(target, parentPath = '') {
    if (!(target instanceof Object)) return {
      [parentPath]: target
    };
    const separator = parentPath?.length ? '.' : '';
    return Object.keys(target).reduce((output, key) => target instanceof Array ? {
      ...output,
      ...Rtl2Util.objectFlatten(target[key], parentPath + '[' + key + ']')
    } : {
      ...output,
      ...Rtl2Util.objectFlatten(target[key], parentPath + separator + key)
    }, {});
  }
  // unflatten flattened nested object
  static objectUnflatten(target) {
    if (Object(target) !== target || Array.isArray(target)) return target;
    const data = {
      ...target
    };
    const regex = /\.?([^.\[\]]+)$|\[(\d+)\]$/;
    const props = Object.keys(data);
    let result, p;
    while (p = props.shift()) {
      const m = regex.exec(p);
      let target;
      if (m) {
        if (m.index) {
          const rest = p.slice(0, m.index);
          if (!(rest in data)) {
            data[rest] = m[2] ? [] : {};
            props.push(rest);
          }
          target = data[rest];
        } else {
          if (!result) {
            result = m[2] ? [] : {};
          }
          target = result;
        }
        target[m[2] || m[1]] = data[p];
      }
    }
    return result;
  }
  static arrayIntersect(a, b) {
    const bNotEmpty = Rtl2Util.isArrayNotEmpty(b);
    if (!Rtl2Util.isArrayNotEmpty(a)) return !bNotEmpty ? undefined : b;
    return !bNotEmpty ? a : a.filter(v => b.indexOf(v) !== -1);
  }
  static pathToId(path) {
    return path?.toLowerCase().replace(/[^a-z0-9]/, '-').replace(/-+/, '-').replace(/^-|-$/g, '');
  }
  static partsToUrl(parts) {
    return parts?.filter(v => !!v?.length).map(v => v.replace(/^\/|\/$/g, '')).join('/');
  }
  static sourceToUrl(source, base, path, replacements) {
    // if source is full url
    if (source?.indexOf('://') !== -1) return source;
    // if source is a path
    if (/\/.*/.test(source)) return Rtl2Util.partsToUrl([base, source]);
    // else if source is an "id"
    if (!replacements) replacements = {
      v: source
    };
    return Rtl2Util.partsToUrl([base, path?.replace(/\{[^}]+\}/g, m => replacements[m.replace(/[\{\}]/g, '')])]);
  }
}
class Rtl2ObjectUtil {
  static empty(target) {
    return Rtl2Util.isEmpty(target);
  }
  static propertyValue(target, path, value = null) {
    return Rtl2Util.objectPropertyValue(target, path, value);
  }
  static getProperty(target, path, value = null) {
    return Rtl2Util.objectPropertyValue(target, path, value);
  }
  static flatten(target) {
    return Rtl2Util.objectFlatten(target);
  }
  static unFlatten(target) {
    return Rtl2Util.objectUnflatten(target);
  }
}
let Rtl2SafePipe = /*#__PURE__*/(() => {
  class Rtl2SafePipe {
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
    }
    transform(value, type) {
      if (Rtl2Util.isEmpty(value)) return '';
      switch (type) {
        case 'html':
          return this.sanitizer.bypassSecurityTrustHtml(value);
        case 'style':
          return this.sanitizer.bypassSecurityTrustStyle(value);
        case 'script':
          return this.sanitizer.bypassSecurityTrustScript(value);
        case 'url':
          return this.sanitizer.bypassSecurityTrustUrl(value);
        case 'resourceUrl':
          return this.sanitizer.bypassSecurityTrustResourceUrl(value);
        default:
          return '';
      }
    }
    static {
      this.ɵfac = function Rtl2SafePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2SafePipe)(i0.ɵɵdirectiveInject(i1$1.DomSanitizer, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "rtl2Safe",
        type: Rtl2SafePipe,
        pure: true
      });
    }
  }
  return Rtl2SafePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2ExtractArrayPropertyPipe = /*#__PURE__*/(() => {
  class Rtl2ExtractArrayPropertyPipe {
    transform(value, property) {
      if (!Array.isArray(value)) return [];
      return value?.map(v => Rtl2Util.objectPropertyValue(v, property)) || [];
    }
    static {
      this.ɵfac = function Rtl2ExtractArrayPropertyPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ExtractArrayPropertyPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "rtl2ExtractArrayProperty",
        type: Rtl2ExtractArrayPropertyPipe,
        pure: true
      });
    }
  }
  return Rtl2ExtractArrayPropertyPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2ExtractPropertyPipe = /*#__PURE__*/(() => {
  class Rtl2ExtractPropertyPipe {
    transform(value, property) {
      return Rtl2Util.objectPropertyValue(value, property);
    }
    static {
      this.ɵfac = function Rtl2ExtractPropertyPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ExtractPropertyPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "rtl2ExtractProperty",
        type: Rtl2ExtractPropertyPipe,
        pure: true
      });
    }
  }
  return Rtl2ExtractPropertyPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const Rtl2UiPipes = [Rtl2CamelPipeToDash, Rtl2DashToCamelPipe, Rtl2DateCleanPipe, Rtl2DatesPipe, Rtl2XMLPipe, Rtl2SafePipe, Rtl2ExtractArrayPropertyPipe, Rtl2ExtractPropertyPipe];
let Rtl2UiModule = /*#__PURE__*/(() => {
  class Rtl2UiModule {
    static {
      this.ɵfac = function Rtl2UiModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2UiModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2UiModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return Rtl2UiModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Rtl2FormGroupTyped extends FormGroup {
  constructor(controls, validatorOrOpts, asyncValidator) {
    super(controls, validatorOrOpts, asyncValidator);
  }
  patchValue(value, options) {
    super.patchValue(value, options);
  }
  get(path) {
    return super.get(path);
  }
}
class Rtl2IdName {}
let Rtl2DashboardFocusDirective = /*#__PURE__*/(() => {
  class Rtl2DashboardFocusDirective {
    constructor(element, renderer) {
      this.element = element;
      this.renderer = renderer;
    }
    ngOnInit() {
      this.focusEvent.subscribe(event => {
        const firstChild = this.element.nativeElement.children[0].children[1];
        this.renderer.selectRootElement(firstChild).focus();
      });
    }
    static {
      this.ɵfac = function Rtl2DashboardFocusDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DashboardFocusDirective)(i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: Rtl2DashboardFocusDirective,
        selectors: [["", "focus", ""]],
        inputs: {
          focusEvent: [0, "focus", "focusEvent"]
        }
      });
    }
  }
  return Rtl2DashboardFocusDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Search field with optional autocomplete and dropdown functionality
 *
 * Example:
 * ```html
 * <rtl2-search
 *   foreground="dark"
 *   color="dark"
 *   [placeholder]="'Placeholder'"
 *   class="w-100"></rtl2-search>
 * ```
 */
let Rtl2SearchComponent = /*#__PURE__*/(() => {
  class Rtl2SearchComponent {
    constructor() {
      this.placeholder = '';
      this.outline = true;
      this.search = '';
      this.autocomplete = [];
      this.searchChange = new EventEmitter();
      this.dropdownOpened = false;
      this.autocompleteOpened = false;
      this.active = false;
    }
    ngOnInit() {}
    toggleDropdown() {
      this.dropdownOpened = !this.dropdownOpened;
      this.active = this.dropdownOpened;
      this.autocompleteOpened = false;
    }
    searchChanged() {
      this.searchChange.emit(this.search);
    }
    removeText() {
      this.search = '';
      this.autocompleteOpened = false;
      this.searchChange.emit(this.search);
    }
    closeDropdown() {
      this.active = true;
      this.dropdownOpened = false;
    }
    close() {
      this.active = false;
      this.dropdownOpened = false;
      this.autocompleteOpened = false;
    }
    openAutocomplete() {
      this.autocompleteOpened = true;
    }
    get filterHidden() {
      return !this.dropdownOpened || !!this.filter === false;
    }
    get expandHidden() {
      return !this.autocompleteOpened || !!this.expand === false;
    }
    get dark() {
      return this.foreground === 'dark';
    }
    get backgroundDark() {
      return this.color === 'dark';
    }
    get isSearchEmpty() {
      return !!this.search && !!this.search.length;
    }
    static {
      this.ɵfac = function Rtl2SearchComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2SearchComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2SearchComponent,
        selectors: [["rtl2-search"]],
        inputs: {
          disabled: "disabled",
          filter: "filter",
          expand: "expand",
          foreground: "foreground",
          color: "color",
          placeholder: "placeholder",
          outline: "outline",
          search: "search",
          autocomplete: "autocomplete"
        },
        outputs: {
          searchChange: "searchChange"
        },
        decls: 18,
        vars: 29,
        consts: [["auto", "matAutocomplete"], [1, "rtl2-search", "d-flex", 3, "rtl2MousedownOutside"], ["mat-mini-fab", "", 1, "search-button", 3, "click"], [1, "material-icons"], ["type", "text", 3, "ngModelChange", "keyup.enter", "focus", "placeholder", "ngModel", "matAutocomplete"], ["mat-mini-fab", "", 1, "remove-button", 3, "click"], ["class", "dropdown-button", "mat-mini-fab", "", 3, "click", 4, "ngIf"], [3, "value", 4, "ngFor", "ngForOf"], [1, "mat-elevation-z", "card"], [4, "ngTemplateOutlet"], ["mat-mini-fab", "", 1, "dropdown-button", 3, "click"], [3, "value"]],
        template: function Rtl2SearchComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("rtl2MousedownOutside", function Rtl2SearchComponent_Template_div_rtl2MousedownOutside_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.close());
            });
            i0.ɵɵelementStart(1, "button", 2);
            i0.ɵɵlistener("click", function Rtl2SearchComponent_Template_button_click_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.closeDropdown());
            });
            i0.ɵɵelementStart(2, "i", 3);
            i0.ɵɵtext(3, "search");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "input", 4);
            i0.ɵɵtwoWayListener("ngModelChange", function Rtl2SearchComponent_Template_input_ngModelChange_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.search, $event) || (ctx.search = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("ngModelChange", function Rtl2SearchComponent_Template_input_ngModelChange_4_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.searchChanged());
            })("keyup.enter", function Rtl2SearchComponent_Template_input_keyup_enter_4_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.searchChanged());
            })("focus", function Rtl2SearchComponent_Template_input_focus_4_listener() {
              i0.ɵɵrestoreView(_r1);
              ctx.closeDropdown();
              return i0.ɵɵresetView(ctx.openAutocomplete());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "button", 5);
            i0.ɵɵlistener("click", function Rtl2SearchComponent_Template_button_click_5_listener() {
              i0.ɵɵrestoreView(_r1);
              ctx.removeText();
              return i0.ɵɵresetView(ctx.closeDropdown());
            });
            i0.ɵɵelementStart(6, "i", 3);
            i0.ɵɵtext(7, "close");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(8, Rtl2SearchComponent_button_8_Template, 3, 3, "button", 6);
            i0.ɵɵelementStart(9, "mat-autocomplete", null, 0);
            i0.ɵɵtemplate(11, Rtl2SearchComponent_mat_option_11_Template, 2, 2, "mat-option", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "mat-card", 8)(13, "mat-card-content");
            i0.ɵɵtemplate(14, Rtl2SearchComponent_div_14_Template, 1, 0, "div", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(15, "mat-card", 8)(16, "mat-card-content");
            i0.ɵɵtemplate(17, Rtl2SearchComponent_div_17_Template, 1, 0, "div", 9);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            const auto_r5 = i0.ɵɵreference(10);
            i0.ɵɵclassProp("styleDark", ctx.backgroundDark)("active", ctx.active)("outline", ctx.outline);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("foregroundBlack", ctx.dark);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("foregroundBlack", ctx.dark)("noFilter", !ctx.filter);
            i0.ɵɵproperty("placeholder", ctx.placeholder);
            i0.ɵɵtwoWayProperty("ngModel", ctx.search);
            i0.ɵɵproperty("matAutocomplete", auto_r5);
            i0.ɵɵattribute("disabled", ctx.disabled);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("hidden", !ctx.isSearchEmpty);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("foregroundBlack", ctx.dark);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !!ctx.filter);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.autocomplete);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("filter-hidden", ctx.filterHidden);
            i0.ɵɵproperty("@filterAnimation", !ctx.filterHidden);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.filter);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("hidden", ctx.expandHidden);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.expand);
          }
        },
        dependencies: [i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgModel, i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i3.MatCard, i3.MatCardContent, i3$1.MatMiniFabButton, Rtl2MousedownOutsideDirective, i6.MatAutocomplete, i6$1.MatOption, i6.MatAutocompleteTrigger],
        styles: [".rtl2-search[_ngcontent-%COMP%]{width:100%;position:relative;border-radius:5px!important}.rtl2-search[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]{position:absolute;top:100%;width:100%;margin-top:-3px;padding:0;z-index:999999;border-radius:0 0 5px 5px}.rtl2-search[_ngcontent-%COMP%]   .hidden[_ngcontent-%COMP%]{visibility:hidden}.rtl2-search[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{flex-grow:1;border:none;outline:none;background:none;opacity:.7}.rtl2-search[_ngcontent-%COMP%]   input.noFilter[_ngcontent-%COMP%]{width:calc(100% - 120px)}.rtl2-search[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{box-shadow:none!important}.rtl2-search[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{opacity:.7}.rtl2-search[_ngcontent-%COMP%]   .search-button[_ngcontent-%COMP%], .rtl2-search[_ngcontent-%COMP%]   .remove-button[_ngcontent-%COMP%], .rtl2-search[_ngcontent-%COMP%]   .dropdown-button[_ngcontent-%COMP%]{margin:4px;background:none}.rtl2-search[_ngcontent-%COMP%]   input.foregroundBlack[_ngcontent-%COMP%]::-webkit-input-placeholder{opacity:.7;-webkit-transition:background-color .3s linear;-ms-transition:background-color .3s linear;transition:background-color .3s linear}.rtl2-search[_ngcontent-%COMP%]   [_ngcontent-%COMP%]::-webkit-input-placeholder{opacity:.7;-webkit-transition:background-color .3s linear;-ms-transition:background-color .3s linear;transition:background-color .3s linear}.rtl2-search.active[_ngcontent-%COMP%]   i[_ngcontent-%COMP%], .rtl2-search.active[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{opacity:1}.rtl2-search[_ngcontent-%COMP%]   .filter-hidden[_ngcontent-%COMP%]{z-index:-1}"],
        data: {
          animation: [trigger('rotateAnimation', [state('false', style({
            transform: 'rotate(0)'
          })), state('true', style({
            transform: 'rotate(-180deg)'
          })), transition('0 => 1', animate('200ms ease-in')), transition('1 => 0', animate('200ms ease-in'))]), trigger('filterAnimation', [state('false', style({
            opacity: 0
          })), state('true', style({
            opacity: 1
          })), transition('0 => 1', animate('200ms ease-in')), transition('1 => 0', animate('200ms ease-out'))])]
        }
      });
    }
  }
  return Rtl2SearchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2DashboardSearchComponent = /*#__PURE__*/(() => {
  class Rtl2DashboardSearchComponent {
    constructor() {
      this.setFocus = new EventEmitter();
      this.onSearchChanged = new EventEmitter(true);
    }
    ngOnInit() {}
    onkeyup(ev) {
      this.setFocus.emit(true);
    }
    // Search input is logged to state - Filter query
    searchChanged(newValue) {
      this.search = newValue;
      this.onSearchChanged.emit(this.search);
    }
    static {
      this.ɵfac = function Rtl2DashboardSearchComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DashboardSearchComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2DashboardSearchComponent,
        selectors: [["rtl2-dashboard-search"]],
        hostBindings: function Rtl2DashboardSearchComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function Rtl2DashboardSearchComponent_keydown_HostBindingHandler($event) {
              return ctx.onkeyup($event);
            }, false, i0.ɵɵresolveDocument);
          }
        },
        outputs: {
          onSearchChanged: "onSearchChanged"
        },
        decls: 2,
        vars: 4,
        consts: [["foreground", "dark", "color", "dark", 1, "margin-top", 3, "searchChange", "focus", "placeholder"]],
        template: function Rtl2DashboardSearchComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "rtl2-search", 0);
            i0.ɵɵpipe(1, "translate");
            i0.ɵɵlistener("searchChange", function Rtl2DashboardSearchComponent_Template_rtl2_search_searchChange_0_listener($event) {
              return ctx.searchChanged($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(1, 2, "rtl2.dashboardPopup.search.placeholder"));
            i0.ɵɵproperty("focus", ctx.setFocus);
          }
        },
        dependencies: [Rtl2SearchComponent, Rtl2DashboardFocusDirective, i2$1.TranslatePipe]
      });
    }
  }
  return Rtl2DashboardSearchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LocalService = /*#__PURE__*/(() => {
  class LocalService {
    constructor() {}
    setUser() {
      const storageUser = this.getUser();
      if (!storageUser) {
        const user = {
          language: this.getLanguageLocal(),
          favorites: []
        };
        const localUser = JSON.stringify(user);
        this.setUserLocal(localUser);
      }
    }
    setLanguage(value) {
      let favorites = this.getFavorites();
      const user = {
        language: value,
        favorites: favorites
      };
      const localUser = JSON.stringify(user);
      this.setUserLocal(localUser);
    }
    setFavorites(id) {
      const oldUser = this.getUser();
      const user = JSON.parse(oldUser);
      let elements = user.favorites;
      if (elements?.includes(id) || elements.length >= 5) return;
      const localUser = JSON.stringify(user);
      this.setUserLocal(localUser);
    }
    removeFavorites(id) {
      const oldUser = this.getUser();
      const user = JSON.parse(oldUser);
      let elements = user.favorites;
      const index = elements.indexOf(id);
      if (index === -1) return;
      const localUser = JSON.stringify(user);
      this.setUserLocal(localUser);
    }
    getUser() {
      return localStorage.getItem('local_user_profile');
    }
    setUserLocal(user) {
      return localStorage.setItem('local_user_profile', user);
    }
    getLanguageLocal() {
      return localStorage.getItem('selected_language');
    }
    userDetails() {
      return localStorage.getItem('sso_user_profile');
    }
    getFavorites() {
      const user = this.getUser();
      if (user == null) {
        this.setUser();
        const user = this.getUser();
        const currentUser = JSON.parse(user);
        return currentUser.favorites;
      }
      const currentUser = JSON.parse(user);
      return currentUser.favorites;
    }
    static {
      this.ɵfac = function LocalService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LocalService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: LocalService,
        factory: LocalService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return LocalService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DataParseService = /*#__PURE__*/(() => {
  class DataParseService {
    constructor(ui, local) {
      this.ui = ui;
      this.local = local;
    }
    getServices() {
      return this.ui.fetchMenu().pipe(map(result => {
        const links = result;
        const data = {};
        links.forEach(x => data[x.id] = x);
        return data;
      }));
    }
    static {
      this.ɵfac = function DataParseService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DataParseService)(i0.ɵɵinject(Rtl2UiInterface), i0.ɵɵinject(LocalService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DataParseService,
        factory: DataParseService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DataParseService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2DashboardFavoritesComponent = /*#__PURE__*/(() => {
  class Rtl2DashboardFavoritesComponent {
    constructor(local, data) {
      this.local = local;
      this.data = data;
      this.favourites$ = new BehaviorSubject([]);
      this.destroy$ = new Subject();
    }
    ngOnInit() {
      this.getFavorites();
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    // TODO: filter favorites
    getFavorites() {
      const favorites = this.local.getFavorites();
      this.data.getServices().pipe(takeUntil(this.destroy$), map(result => Object.values(result).filter(item => favorites.includes(item.id)))).subscribe(v => {
        this.favourites$.next(v);
      });
    }
    remove(id) {
      this.local.removeFavorites(id);
    }
    openUrl(url) {
      window.location.assign(url);
    }
    static {
      this.ɵfac = function Rtl2DashboardFavoritesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DashboardFavoritesComponent)(i0.ɵɵdirectiveInject(LocalService), i0.ɵɵdirectiveInject(DataParseService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2DashboardFavoritesComponent,
        selectors: [["rtl2-dashboard-favorites"]],
        decls: 4,
        vars: 4,
        consts: [["noResult", ""], [4, "ngIf", "ngIfElse"], [3, "innerHTML", "click", 4, "ngFor", "ngForOf"], [3, "click", "innerHTML"], [1, "text-muted", "pt-3", "px-3"]],
        template: function Rtl2DashboardFavoritesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, Rtl2DashboardFavoritesComponent_mat_nav_list_0_Template, 3, 3, "mat-nav-list", 1);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, Rtl2DashboardFavoritesComponent_ng_template_2_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            let tmp_1_0;
            const noResult_r4 = i0.ɵɵreference(3);
            i0.ɵɵproperty("ngIf", (tmp_1_0 = i0.ɵɵpipeBind1(1, 2, ctx.favourites$)) == null ? null : tmp_1_0.length)("ngIfElse", noResult_r4);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i4.MatNavList, i2.AsyncPipe, i2$1.TranslatePipe]
      });
    }
  }
  return Rtl2DashboardFavoritesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2DashboardServicesComponent = /*#__PURE__*/(() => {
  class Rtl2DashboardServicesComponent {
    constructor(data, translate) {
      this.data = data;
      this.translate = translate;
      this.visible$ = new BehaviorSubject([]);
      this.searchText$ = new BehaviorSubject('');
      this.destroy$ = new Subject();
    }
    ngOnInit() {
      combineLatest([this.data.getServices(), this.searchText$.asObservable()]).pipe(takeUntil(this.destroy$), map(([services, search]) => {
        const serviceArray = Object.values(services);
        return search == null || search === '' ? serviceArray : serviceArray.filter(item => this.translate.instant(item.name).toLowerCase().includes(search));
      })).subscribe(v => {
        this.visible$.next(v);
      });
    }
    ngOnChanges(changes) {
      this.searchText$.next(changes.searchText.currentValue);
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    openUrl(url) {
      window.location.assign(url);
    }
    static {
      this.ɵfac = function Rtl2DashboardServicesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DashboardServicesComponent)(i0.ɵɵdirectiveInject(DataParseService), i0.ɵɵdirectiveInject(i2$1.TranslateService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2DashboardServicesComponent,
        selectors: [["rtl2-dashboard-services"]],
        inputs: {
          searchText: "searchText"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 5,
        vars: 4,
        consts: [["noResult", ""], [4, "ngIf", "ngIfElse"], [3, "innerHTML", "click", 4, "ngFor", "ngForOf"], [3, "click", "innerHTML"], [1, "text-muted", "pt-3", "px-3"]],
        template: function Rtl2DashboardServicesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ng-scrollbar");
            i0.ɵɵtemplate(1, Rtl2DashboardServicesComponent_mat_nav_list_1_Template, 3, 3, "mat-nav-list", 1);
            i0.ɵɵpipe(2, "async");
            i0.ɵɵtemplate(3, Rtl2DashboardServicesComponent_ng_template_3_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_1_0;
            const noResult_r4 = i0.ɵɵreference(4);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (tmp_1_0 = i0.ɵɵpipeBind1(2, 2, ctx.visible$)) == null ? null : tmp_1_0.length)("ngIfElse", noResult_r4);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i4.MatNavList, i5.NgScrollbar, i2.AsyncPipe, i2$1.TranslatePipe],
        styles: ["ng-scrollbar[_ngcontent-%COMP%]{max-width:100vh;height:250px}"]
      });
    }
  }
  return Rtl2DashboardServicesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Dashboard menu popup
 *
 * Example:
 * ```html
 *  <div class="displayMenu">
 *    <button class="ml-auto" mat-button (click)="openDialog()">
 *      <mat-icon color="primary">apps</mat-icon>
 *    </button>
 *  </div>
 * ```
 *
 * ```typescript
 * constructor(public dialog: MatDialog) {}
 *
 *  openDialog(): void {
 *      const dialogRef = this.dialog.open(Rtl2PopUpComponent, {
 *      width: 'max-content'
 *    });
 *  }
 *
 *  ...........
 *
 *  @Component({
 *    selector: 'rtl2-doc-dashboard-dialog',
 *    template: '<rtl2-dashboard-popup></rtl2-dashboard-popup>'
 *  })
 *   export class Rtl2PopUpComponent {
 *    constructor() {}
 *  }
 * ```
 */
let Rtl2DashboardPopupComponent = /*#__PURE__*/(() => {
  class Rtl2DashboardPopupComponent {
    constructor(ui, local) {
      this.ui = ui;
      this.local = local;
    }
    ngOnInit() {}
    static {
      this.ɵfac = function Rtl2DashboardPopupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DashboardPopupComponent)(i0.ɵɵdirectiveInject(Rtl2UiInterface), i0.ɵɵdirectiveInject(LocalService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2DashboardPopupComponent,
        selectors: [["rtl2-dashboard-popup"]],
        decls: 4,
        vars: 1,
        consts: [[1, "search", "px-3", "pt-3"], [3, "onSearchChanged"], [1, "services"], [3, "searchText"]],
        template: function Rtl2DashboardPopupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "rtl2-dashboard-search", 1);
            i0.ɵɵlistener("onSearchChanged", function Rtl2DashboardPopupComponent_Template_rtl2_dashboard_search_onSearchChanged_1_listener($event) {
              return ctx.search = $event;
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵelement(3, "rtl2-dashboard-services", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("searchText", ctx.search);
          }
        },
        dependencies: [Rtl2DashboardSearchComponent, Rtl2DashboardServicesComponent],
        styles: ["[_nghost-%COMP%]{max-width:max-content}[_nghost-%COMP%]     a{text-decoration:none}[_nghost-%COMP%]     a:hover{text-decoration:underline}[_nghost-%COMP%]     mat-nav-list{padding:0}[_nghost-%COMP%]     mat-nav-list>a{display:block;padding:.5rem 1rem}[_nghost-%COMP%]     mat-nav-list>a:not(:first-child){border-top-width:1px;border-top-style:solid}.search[_ngcontent-%COMP%]{margin-bottom:20px}.title[_ngcontent-%COMP%]{margin-bottom:0}"]
      });
    }
  }
  return Rtl2DashboardPopupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const COMPONENTS$1 = [Rtl2SearchComponent];
let Rtl2SearchModule = /*#__PURE__*/(() => {
  class Rtl2SearchModule {
    static {
      this.ɵfac = function Rtl2SearchModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2SearchModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2SearchModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [FormsModule, CommonModule, MatCardModule, MatIconModule, MatButtonModule, Rtl2UiModule, MatAutocompleteModule]
      });
    }
  }
  return Rtl2SearchModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2DashboardPopupModule = /*#__PURE__*/(() => {
  class Rtl2DashboardPopupModule {
    static {
      this.ɵfac = function Rtl2DashboardPopupModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DashboardPopupModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2DashboardPopupModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, MatIconModule, MatListModule, MatRadioModule, Rtl2SearchModule, NgScrollbarModule]
      });
    }
  }
  return Rtl2DashboardPopupModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function toInteger(value) {
  return parseInt(`${value}`, 10);
}
function toString(value) {
  return value !== undefined && value !== null ? `${value}` : '';
}
function getValueInRange(value, max, min = 0) {
  return Math.max(Math.min(value, max), min);
}
function isString(value) {
  return typeof value === 'string';
}
function isNumber(value) {
  return !isNaN(toInteger(value));
}
function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
function isDefined(value) {
  return value !== undefined && value !== null;
}
function padNumber(value) {
  if (isNumber(value)) {
    return `0${value}`.slice(-2);
  } else {
    return '';
  }
}
function regExpEscape(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
class DayViewModel {}
class WeekViewModel {}
class MonthViewModel {}
var NavigationEvent = /*#__PURE__*/function (NavigationEvent) {
  NavigationEvent[NavigationEvent["PREV"] = 0] = "PREV";
  NavigationEvent[NavigationEvent["NEXT"] = 1] = "NEXT";
  return NavigationEvent;
}(NavigationEvent || {});
class Rtl2Date {
  static from(date) {
    return date ? new Rtl2Date(date.year, date.month, date.day ? date.day : 1) : null;
  }
  constructor(year, month, day) {
    this.year = year;
    this.month = month;
    this.day = day;
  }
  equals(other) {
    return other && this.year === other.year && this.month === other.month && this.day === other.day;
  }
  before(other) {
    if (!other) {
      return false;
    }
    if (this.year === other.year) {
      if (this.month === other.month) {
        return this.day === other.day ? false : this.day < other.day;
      } else {
        return this.month < other.month;
      }
    } else {
      return this.year < other.year;
    }
  }
  after(other) {
    if (!other) {
      return false;
    }
    if (this.year === other.year) {
      if (this.month === other.month) {
        return this.day === other.day ? false : this.day > other.day;
      } else {
        return this.month > other.month;
      }
    } else {
      return this.year > other.year;
    }
  }
  toString() {
    return `${this.year}-${this.month}-${this.day}`;
  }
}
class Rtl2Data {
  constructor(init = {}) {
    init.week = init.week || new Rtl2DataWeek();
    Object.assign(this, init);
  }
}
class Rtl2DataWeek {
  constructor(init = {}) {
    init.days = init.days || [];
    Object.assign(this, init);
  }
}
function fromJSDate(jsDate) {
  return new Rtl2Date(jsDate.getFullYear(), jsDate.getMonth() + 1, jsDate.getDate());
}
function toJSDate(date) {
  const jsDate = new Date(date.year, date.month - 1, date.day);
  // this is done avoid 30 -> 1930 conversion
  if (!isNaN(jsDate.getTime())) {
    jsDate.setFullYear(date.year);
  }
  return jsDate;
}
let Rtl2Calendar = /*#__PURE__*/(() => {
  class Rtl2Calendar {
    static {
      this.ɵfac = function Rtl2Calendar_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2Calendar)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: Rtl2Calendar,
        factory: Rtl2Calendar.ɵfac
      });
    }
  }
  return Rtl2Calendar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2CalendarGregorian = /*#__PURE__*/(() => {
  class Rtl2CalendarGregorian extends Rtl2Calendar {
    getDaysPerWeek() {
      return 7;
    }
    getMonths() {
      return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    }
    getWeeksPerMonth() {
      return 6;
    }
    getNext(date, period = 'd', number = 1) {
      let jsDate = toJSDate(date);
      switch (period) {
        case 'y':
          return new Rtl2Date(date.year + number, 1, 1);
        case 'm':
          jsDate = new Date(date.year, date.month + number - 1, 1);
          break;
        case 'd':
          jsDate.setDate(jsDate.getDate() + number);
          break;
        default:
          return date;
      }
      return fromJSDate(jsDate);
    }
    getPrev(date, period = 'd', number = 1) {
      return this.getNext(date, period, -number);
    }
    getWeekday(date) {
      const jsDate = toJSDate(date);
      const day = jsDate.getDay();
      // in JS Date Sun=0, in ISO 8601 Sun=7
      return day === 0 ? 7 : day;
    }
    getWeekNumber(week, firstDayOfWeek) {
      // in JS Date Sun=0, in ISO 8601 Sun=7
      if (firstDayOfWeek === 7) {
        firstDayOfWeek = 0;
      }
      const thursdayIndex = (4 + 7 - firstDayOfWeek) % 7;
      const date = week[thursdayIndex];
      const jsDate = toJSDate(date);
      jsDate.setDate(jsDate.getDate() + 4 - (jsDate.getDay() || 7)); // Thursday
      const time = jsDate.getTime();
      jsDate.setMonth(0); // Compare with Jan 1
      jsDate.setDate(1);
      return Math.floor(Math.round((time - jsDate.getTime()) / 86400000) / 7) + 1;
    }
    getToday() {
      return fromJSDate(new Date());
    }
    isValid(date) {
      if (!date || !isInteger(date.year) || !isInteger(date.month) || !isInteger(date.day)) {
        return false;
      }
      const jsDate = toJSDate(date);
      return !isNaN(jsDate.getTime()) && jsDate.getFullYear() === date.year && jsDate.getMonth() + 1 === date.month && jsDate.getDate() === date.day;
    }
    getDataWeekByDate(date, firstDayOfWeek) {
      firstDayOfWeek = firstDayOfWeek % 7;
      const week = new Rtl2DataWeek();
      let dateObject = new Date(date.year, date.month - 1, date.day);
      dateObject.setHours(12);
      // setting first day of week
      let weekStart = new Date(dateObject.valueOf());
      const weekEnd = new Date(dateObject.valueOf());
      // if firstDayOfWeek greater than Thursday, start of the week minuses
      let diff = dateObject.getDate() - dateObject.getDay() + (firstDayOfWeek > 4 ? firstDayOfWeek - 7 : firstDayOfWeek);
      weekStart.setDate(diff);
      weekEnd.setDate(diff + 6);
      if (dateObject.toISOString().slice(0, 10) < weekStart.toISOString().slice(0, 10)) {
        diff -= 7;
      } else if (dateObject.toISOString().slice(0, 10) > weekEnd.toISOString().slice(0, 10)) {
        diff += 7;
      }
      // setting week days
      for (let i = 0; i < 7; i++) {
        weekStart = new Date(dateObject.valueOf());
        weekStart.setDate(diff + i);
        week.days[i] = new Rtl2Date(weekStart.getFullYear(), weekStart.getMonth() + 1, weekStart.getDate());
      }
      // setting week number and year
      weekStart = new Date(dateObject.valueOf());
      weekStart.setDate(diff);
      dateObject = new Date(weekStart.valueOf());
      if (weekStart.getDay() !== 4) {
        dateObject.setDate(weekStart.getDate() + (4 - weekStart.getDay() + 7) % 7);
      }
      week.year = dateObject.getFullYear();
      const time = dateObject.valueOf();
      dateObject.setMonth(0, 1);
      if (dateObject.getDay() !== 4) {
        dateObject.setMonth(0, 1 + (4 - dateObject.getDay() + 7) % 7);
      }
      week.id = 1 + Math.ceil((time - dateObject.valueOf()) / 604800000);
      return week;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵRtl2CalendarGregorian_BaseFactory;
        return function Rtl2CalendarGregorian_Factory(__ngFactoryType__) {
          return (ɵRtl2CalendarGregorian_BaseFactory || (ɵRtl2CalendarGregorian_BaseFactory = i0.ɵɵgetInheritedFactory(Rtl2CalendarGregorian)))(__ngFactoryType__ || Rtl2CalendarGregorian);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: Rtl2CalendarGregorian,
        factory: Rtl2CalendarGregorian.ɵfac
      });
    }
  }
  return Rtl2CalendarGregorian;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2DatepickerService = /*#__PURE__*/(() => {
  class Rtl2DatepickerService {
    constructor(_calendar) {
      this._calendar = _calendar;
    }
    generateMonthViewModel(date, minDate, maxDate, firstDayOfWeek, markDisabled) {
      const month = {
        firstDate: null,
        number: date.month,
        year: date.year,
        weeks: [],
        weekdays: []
      };
      date = this._getFirstViewDate(date, firstDayOfWeek);
      // month has weeks
      for (let w = 0; w < this._calendar.getWeeksPerMonth(); w++) {
        const days = [];
        // week has days
        for (let d = 0; d < this._calendar.getDaysPerWeek(); d++) {
          if (w === 0) {
            month.weekdays.push(this._calendar.getWeekday(date));
          }
          const newDate = new Rtl2Date(date.year, date.month, date.day);
          let disabled = minDate && newDate.before(minDate) || maxDate && newDate.after(maxDate);
          if (!disabled && markDisabled) {
            disabled = markDisabled(newDate, {
              month: month.number,
              year: month.year
            });
          }
          // saving first date of the month
          if (month.firstDate === null && date.month === month.number) {
            month.firstDate = newDate;
          }
          days.push({
            date: newDate,
            disabled: disabled
          });
          date = this._calendar.getNext(date);
        }
        month.weeks.push({
          number: this._calendar.getWeekNumber(days.map(day => Rtl2Date.from(day.date)), firstDayOfWeek),
          days: days
        });
      }
      return month;
    }
    toValidDate(date, defaultValue) {
      const rtl2Date = Rtl2Date.from(date);
      if (defaultValue === undefined) {
        defaultValue = this._calendar.getToday();
      }
      return this._calendar.isValid(rtl2Date) ? rtl2Date : defaultValue;
    }
    toValidData(data, firstDayOfWeek = 0) {
      if (data) {
        if (!data.date && data.week) {
          data.date = data.week.days[0];
        }
      } else {
        data = new Rtl2Data();
        data.date = this._calendar.getToday();
      }
      data.week = this._calendar.getDataWeekByDate(data.date, firstDayOfWeek);
      return data.date && this._calendar.isValid(data.date) ? data : null;
    }
    _getFirstViewDate(date, firstDayOfWeek) {
      const currentMonth = date.month;
      let today = new Rtl2Date(date.year, date.month, date.day);
      let yesterday = this._calendar.getPrev(today);
      const firstDayOfCurrentMonthIsAlsoFirstDayOfWeek = () => {
        return today.month !== yesterday.month && firstDayOfWeek === this._calendar.getWeekday(today);
      };
      const reachedTheFirstDayOfTheLastWeekOfPreviousMonth = () => {
        return today.month !== currentMonth && firstDayOfWeek === this._calendar.getWeekday(today);
      };
      // going back in time
      while (!reachedTheFirstDayOfTheLastWeekOfPreviousMonth() && !firstDayOfCurrentMonthIsAlsoFirstDayOfWeek()) {
        today = new Rtl2Date(yesterday.year, yesterday.month, yesterday.day);
        yesterday = this._calendar.getPrev(yesterday);
      }
      return today;
    }
    static {
      this.ɵfac = function Rtl2DatepickerService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DatepickerService)(i0.ɵɵinject(Rtl2Calendar));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: Rtl2DatepickerService,
        factory: Rtl2DatepickerService.ɵfac
      });
    }
  }
  return Rtl2DatepickerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const WEEKDAYS_SHORT = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const MONTHS_FULL = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
/**
 * Type of the service supplying month and weekday names to to Rtl2Datepicker component.
 * See the i18n demo for how to extend this class and define a custom provider for i18n.
 */
let Rtl2DatepickerI18n = /*#__PURE__*/(() => {
  class Rtl2DatepickerI18n {
    static {
      this.ɵfac = function Rtl2DatepickerI18n_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DatepickerI18n)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: Rtl2DatepickerI18n,
        factory: Rtl2DatepickerI18n.ɵfac
      });
    }
  }
  return Rtl2DatepickerI18n;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2DatepickerI18nDefault = /*#__PURE__*/(() => {
  class Rtl2DatepickerI18nDefault extends Rtl2DatepickerI18n {
    constructor() {
      super();
    }
    getWeekdayShortName(weekday) {
      return 'rtl2.datepicker.' + WEEKDAYS_SHORT[weekday - 1];
    }
    getMonthShortName(month) {
      return 'rtl2.datepicker.' + MONTHS_SHORT[month - 1];
    }
    getMonthFullName(month) {
      return 'rtl2.datepicker.' + MONTHS_FULL[month - 1];
    }
    static {
      this.ɵfac = function Rtl2DatepickerI18nDefault_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DatepickerI18nDefault)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: Rtl2DatepickerI18nDefault,
        factory: Rtl2DatepickerI18nDefault.ɵfac
      });
    }
  }
  return Rtl2DatepickerI18nDefault;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Configuration service for the Rtl2Datepicker component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the datepickers used in the application.
 */
let Rtl2DatepickerConfig = /*#__PURE__*/(() => {
  class Rtl2DatepickerConfig {
    constructor() {
      this.displayMonths = 1;
      this.firstDayOfWeek = 6;
      this.navigation = 'select';
      this.outsideDays = 'visible';
      this.showWeekdays = true;
      this.showWeekNumbers = false;
      this.weeksSelectable = false;
      this.initDate = false;
    }
    static {
      this.ɵfac = function Rtl2DatepickerConfig_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DatepickerConfig)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: Rtl2DatepickerConfig,
        factory: Rtl2DatepickerConfig.ɵfac
      });
    }
  }
  return Rtl2DatepickerConfig;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2DatepickerMonthView = /*#__PURE__*/(() => {
  class Rtl2DatepickerMonthView {
    constructor(i18n) {
      this.i18n = i18n;
      this.select = new EventEmitter();
    }
    doSelect(week, day) {
      if (day && (this.isDisabled(day) || this.isHidden(day))) {
        return;
      }
      if (!day && week && !this.weeksSelectable) {
        return;
      }
      const data = new Rtl2Data();
      data.week.id = week.number;
      if (day) {
        data.type = 'day';
        data.date = day.date;
        for (const dayItem of week.days) {
          data.week.days.push(dayItem.date);
        }
      } else {
        data.type = 'week';
        for (const dayItem of week.days) {
          if (!data.date && !this.isDisabled(dayItem) && !this.isHidden(dayItem)) {
            data.date = dayItem.date;
          }
          data.week.days.push(dayItem.date);
        }
      }
      if (!data.date) {
        return;
      }
      if (data.date.month === 12 && week.number < 2) {
        data.week.year = data.date.year + 1;
      } else if (data.date.month === 1 && week.number > 1) {
        data.week.year = data.date.year - 1;
      } else {
        data.week.year = data.date.year;
      }
      this.select.emit(data);
    }
    isDisabled(day) {
      return this.disabled || day.disabled;
    }
    isDisabledWeek(week) {
      let count = 0;
      for (const day of week.days) {
        if (this.disabled || day.disabled) {
          count++;
        }
      }
      return count === 7;
    }
    isSelected(date) {
      if (this.selectedData && this.selectedData.date) {
        const rtl2Date = new Rtl2Date(this.selectedData.date.year, this.selectedData.date.month, this.selectedData.date.day);
        return rtl2Date.equals(date);
      }
      return false;
    }
    isSelectedWeek(week) {
      if (!this.selectedData || !this.selectedData.week) {
        return false;
      }
      return this.selectedData.type === 'week' && this.selectedData.week.id === week.number;
    }
    isSelectedWeekDay(week) {
      if (!this.selectedData || !this.selectedData.week || !this.selectedData.week.days) {
        return false;
      }
      for (const day of week.days) {
        if (this.isSelected(day.date)) {
          return true;
        }
      }
      return false;
    }
    isCollapsed(week) {
      return this.outsideDays === 'collapsed' && week.days[0].date.month !== this.month.number && week.days[week.days.length - 1].date.month !== this.month.number;
    }
    isHidden(day) {
      return (this.outsideDays === 'hidden' || this.outsideDays === 'collapsed') && this.month.number !== day.date.month;
    }
    static {
      this.ɵfac = function Rtl2DatepickerMonthView_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DatepickerMonthView)(i0.ɵɵdirectiveInject(Rtl2DatepickerI18n));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2DatepickerMonthView,
        selectors: [["rtl2-datepicker-month-view"]],
        hostAttrs: [1, "d-block"],
        inputs: {
          dayTemplate: "dayTemplate",
          weekNumberTemplate: "weekNumberTemplate",
          disabled: "disabled",
          month: "month",
          outsideDays: "outsideDays",
          selectedData: "selectedData",
          showWeekdays: "showWeekdays",
          showWeekNumbers: "showWeekNumbers",
          weeksSelectable: "weeksSelectable"
        },
        outputs: {
          select: "select"
        },
        decls: 2,
        vars: 2,
        consts: [["class", "ngb-dp-week d-flex", 4, "ngIf"], ["ngFor", "", 3, "ngForOf"], [1, "ngb-dp-week", "d-flex"], ["class", "ngb-dp-weekday small text-center", 4, "ngIf"], ["class", "ngb-dp-weekday small text-center", 4, "ngFor", "ngForOf"], [1, "ngb-dp-weekday", "small", "text-center"], ["class", "ngb-dp-week d-flex", 3, "week-selected", "item-selected", 4, "ngIf"], ["class", "ngb-dp-day ngb-dp-week-number", 3, "non-selectable", "selected", "disabled", "click", 4, "ngIf"], ["class", "ngb-dp-day", 3, "selected", "disabled", "hidden", "click", 4, "ngFor", "ngForOf"], [1, "ngb-dp-day", "ngb-dp-week-number", 3, "click"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "ngb-dp-day", 3, "click"], [3, "ngIf"]],
        template: function Rtl2DatepickerMonthView_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, Rtl2DatepickerMonthView_div_0_Template, 3, 2, "div", 0)(1, Rtl2DatepickerMonthView_ng_template_1_Template, 1, 1, "ng-template", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.showWeekdays);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.month.weeks);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2$1.TranslatePipe],
        styles: [".ngb-dp-weekday[_ngcontent-%COMP%], .ngb-dp-week-number[_ngcontent-%COMP%]{line-height:2rem}.ngb-dp-day[_ngcontent-%COMP%], .ngb-dp-weekday[_ngcontent-%COMP%], .ngb-dp-week-number[_ngcontent-%COMP%]{width:2rem;height:2rem}.ngb-dp-day[_ngcontent-%COMP%]{cursor:pointer}.ngb-dp-day.disabled[_ngcontent-%COMP%], .ngb-dp-day.hidden[_ngcontent-%COMP%], .ngb-dp-day.non-selectable[_ngcontent-%COMP%]{cursor:default}"]
      });
    }
  }
  return Rtl2DatepickerMonthView;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2DatepickerNavigationSelect = /*#__PURE__*/(() => {
  class Rtl2DatepickerNavigationSelect {
    constructor(i18n, calendar) {
      this.i18n = i18n;
      this.calendar = calendar;
      this.years = [];
      this.select = new EventEmitter();
      this.months = calendar.getMonths();
    }
    ngOnChanges(changes) {
      if (changes['maxDate'] || changes['minDate'] || changes['date']) {
        this._generateYears();
        this._generateMonths();
      }
    }
    changeMonth(month) {
      this.select.emit(new Rtl2Date(this.date.year, toInteger(month), 1));
    }
    changeYear(year) {
      this.select.emit(new Rtl2Date(toInteger(year), this.date.month, 1));
    }
    _generateMonths() {
      this.months = this.calendar.getMonths();
      if (this.date && this.date.year === this.minDate.year) {
        const index = this.months.findIndex(month => month === this.minDate.month);
        this.months = this.months.slice(index);
      }
      if (this.date && this.date.year === this.maxDate.year) {
        const index = this.months.findIndex(month => month === this.maxDate.month);
        this.months = this.months.slice(0, index + 1);
      }
    }
    _generateYears() {
      this.years = Array.from({
        length: this.maxDate.year - this.minDate.year + 1
      }, (e, i) => this.minDate.year + i);
    }
    static {
      this.ɵfac = function Rtl2DatepickerNavigationSelect_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DatepickerNavigationSelect)(i0.ɵɵdirectiveInject(Rtl2DatepickerI18n), i0.ɵɵdirectiveInject(Rtl2Calendar));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2DatepickerNavigationSelect,
        selectors: [["rtl2-datepicker-navigation-select"]],
        inputs: {
          date: "date",
          disabled: "disabled",
          maxDate: "maxDate",
          minDate: "minDate"
        },
        outputs: {
          select: "select"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 4,
        vars: 4,
        consts: [[1, "custom-select", "d-inline-block", 3, "change", "disabled"], [3, "value", "selected", 4, "ngFor", "ngForOf"], [3, "value", "selected"]],
        template: function Rtl2DatepickerNavigationSelect_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "select", 0);
            i0.ɵɵlistener("change", function Rtl2DatepickerNavigationSelect_Template_select_change_0_listener($event) {
              return ctx.changeMonth($event.target.value);
            });
            i0.ɵɵtemplate(1, Rtl2DatepickerNavigationSelect_option_1_Template, 3, 5, "option", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "select", 0);
            i0.ɵɵlistener("change", function Rtl2DatepickerNavigationSelect_Template_select_change_2_listener($event) {
              return ctx.changeYear($event.target.value);
            });
            i0.ɵɵtemplate(3, Rtl2DatepickerNavigationSelect_option_3_Template, 2, 3, "option", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.months);
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.disabled);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.years);
          }
        },
        dependencies: [i2.NgForOf, i1$2.NgSelectOption, i1$2.ɵNgSelectMultipleOption, i2$1.TranslatePipe],
        styles: ["select[_ngcontent-%COMP%]{padding:.25rem .5rem;font-size:.875rem;line-height:1.25;height:inherit;width:50%}"]
      });
    }
  }
  return Rtl2DatepickerNavigationSelect;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2DatepickerNavigation = /*#__PURE__*/(() => {
  class Rtl2DatepickerNavigation {
    constructor(_calendar) {
      this._calendar = _calendar;
      this.navigation = NavigationEvent;
      this.navigate = new EventEmitter();
      this.select = new EventEmitter();
    }
    doNavigate(event, clickEvent) {
      this.navigate.emit(event);
      clickEvent.stopImmediatePropagation();
    }
    nextDisabled() {
      return this.disabled || this.maxDate && this._calendar.getNext(this.date, 'm').after(this.maxDate);
    }
    prevDisabled() {
      const prevDate = this._calendar.getPrev(this.date, 'm');
      return this.disabled || this.minDate && prevDate.year <= this.minDate.year && prevDate.month < this.minDate.month;
    }
    selectDate(date) {
      this.select.emit(date);
    }
    static {
      this.ɵfac = function Rtl2DatepickerNavigation_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DatepickerNavigation)(i0.ɵɵdirectiveInject(Rtl2Calendar));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2DatepickerNavigation,
        selectors: [["rtl2-datepicker-navigation"]],
        hostAttrs: [1, "d-flex", "justify-content-between"],
        hostVars: 2,
        hostBindings: function Rtl2DatepickerNavigation_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("collapsed", !ctx.showSelect);
          }
        },
        inputs: {
          date: "date",
          disabled: "disabled",
          maxDate: "maxDate",
          minDate: "minDate",
          months: "months",
          showSelect: "showSelect",
          showWeekNumbers: "showWeekNumbers"
        },
        outputs: {
          navigate: "navigate",
          select: "select"
        },
        decls: 5,
        vars: 3,
        consts: [["class", "d-block", 3, "width", "date", "minDate", "maxDate", "disabled", "select", 4, "ngIf"], ["type", "button", 1, "btn-link", "ml-auto", 3, "click", "disabled"], [1, "ngb-dp-navigation-chevron"], ["type", "button", 1, "btn-link", 3, "click", "disabled"], [1, "ngb-dp-navigation-chevron", "right"], [1, "d-block", 3, "select", "date", "minDate", "maxDate", "disabled"]],
        template: function Rtl2DatepickerNavigation_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, Rtl2DatepickerNavigation_rtl2_datepicker_navigation_select_0_Template, 1, 6, "rtl2-datepicker-navigation-select", 0);
            i0.ɵɵelementStart(1, "button", 1);
            i0.ɵɵlistener("click", function Rtl2DatepickerNavigation_Template_button_click_1_listener($event) {
              return ctx.doNavigate(ctx.navigation.PREV, $event);
            });
            i0.ɵɵelement(2, "span", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "button", 3);
            i0.ɵɵlistener("click", function Rtl2DatepickerNavigation_Template_button_click_3_listener($event) {
              return ctx.doNavigate(ctx.navigation.NEXT, $event);
            });
            i0.ɵɵelement(4, "span", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.showSelect);
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.prevDisabled());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.nextDisabled());
          }
        },
        dependencies: [i2.NgIf, Rtl2DatepickerNavigationSelect],
        styles: ["[_nghost-%COMP%]{height:2rem;line-height:1.85rem}.collapsed[_nghost-%COMP%]{margin-bottom:-2rem}.ngb-dp-navigation-chevron[_ngcontent-%COMP%]:before{border-style:solid;border-width:.2em .2em 0 0;content:\"\";display:inline-block;height:.75em;transform:rotate(-135deg);-webkit-transform:rotate(-135deg);-ms-transform:rotate(-135deg);width:.75em;margin:0 0 0 .5rem}.ngb-dp-navigation-chevron.right[_ngcontent-%COMP%]:before{-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);margin:0 .5rem 0 0}.btn-link[_ngcontent-%COMP%]{cursor:pointer;outline:0}.btn-link[disabled][_ngcontent-%COMP%]{cursor:not-allowed;opacity:.65}"]
      });
    }
  }
  return Rtl2DatepickerNavigation;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2DatepickerDayView = /*#__PURE__*/(() => {
  class Rtl2DatepickerDayView {
    isMuted() {
      return !this.selected && (this.date.month !== this.currentMonth || this.disabled);
    }
    static {
      this.ɵfac = function Rtl2DatepickerDayView_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DatepickerDayView)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2DatepickerDayView,
        selectors: [["", "rtl2DatepickerDayView", ""]],
        hostVars: 10,
        hostBindings: function Rtl2DatepickerDayView_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("bg-primary", ctx.selected)("text-white", ctx.selected)("text-muted", ctx.isMuted())("outside", ctx.isMuted())("btn-secondary", !ctx.disabled);
          }
        },
        inputs: {
          currentMonth: "currentMonth",
          date: "date",
          disabled: "disabled",
          selected: "selected"
        },
        attrs: _c3,
        decls: 1,
        vars: 1,
        template: function Rtl2DatepickerDayView_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtext(0);
          }
          if (rf & 2) {
            i0.ɵɵtextInterpolate(ctx.date.day);
          }
        },
        styles: ["[_nghost-%COMP%]{text-align:center;width:2rem;height:2rem;line-height:2rem;border-radius:.25rem}.outside[_nghost-%COMP%]{opacity:.5}"]
      });
    }
  }
  return Rtl2DatepickerDayView;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2DatepickerWeekNumberView = /*#__PURE__*/(() => {
  class Rtl2DatepickerWeekNumberView {
    static {
      this.ɵfac = function Rtl2DatepickerWeekNumberView_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DatepickerWeekNumberView)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2DatepickerWeekNumberView,
        selectors: [["", "rtl2DatepickerWeekNumberView", ""]],
        hostVars: 10,
        hostBindings: function Rtl2DatepickerWeekNumberView_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("bg-primary", ctx.selected)("text-white", ctx.selected)("text-muted", ctx.disabled)("outside", ctx.disabled)("btn-secondary", !ctx.disabled);
          }
        },
        inputs: {
          week: "week",
          disabled: "disabled",
          selected: "selected"
        },
        attrs: _c4,
        decls: 1,
        vars: 1,
        template: function Rtl2DatepickerWeekNumberView_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtext(0);
          }
          if (rf & 2) {
            i0.ɵɵtextInterpolate(ctx.week.number);
          }
        },
        styles: ["[_nghost-%COMP%]{text-align:center;width:2rem;height:2rem;line-height:2rem;border-radius:.25rem;font-size:.8rem}.outside[_nghost-%COMP%]{opacity:.5}"]
      });
    }
  }
  return Rtl2DatepickerWeekNumberView;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const NGB_DATEPICKER_VALUE_ACCESSOR$1 = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => Rtl2Datepicker),
  multi: true
};
/**
 * A lightweight and highly configurable datepicker directive
 *
 * Example:
 * ```html
 * // Single day selection, week starts Monday
 *  <rtl2-datepicker
 *    [(ngModel)]="model1"
 *    [initDate]="true"
 *    [firstDayOfWeek]="1"
 *    ></rtl2-datepicker>
 *
 * // Single day or week selection, week starts Monday
 *  <rtl2-datepicker
 *    [(ngModel)]="model2"
 *    [initDate]="true"
 *    [showWeekNumbers]="true"
 *    [weeksSelectable]="true"
 *    [firstDayOfWeek]="1"
 *    ></rtl2-datepicker>
 *
 * // Week selection, week starts Monday
 *  <rtl2-datepicker
 *    [(ngModel)]="model3"
 *    [showWeekNumbers]="true"
 *    [weeksSelectable]="true"
 *    [initDate]="true"
 *    [firstDayOfWeek]="1"
 *    (ngModelChange)="$event.type='week'"
 *    ></rtl2-datepicker>
 * ```
 *
 * ```typescript
 *  model1: Rtl2Data;
 *  model2: Rtl2Data;
 *  model3: Rtl2Data;
 *
 *  constructor() {
 *     const [y, m, d] = new Date().toISOString().split('T')[0].split('-');
 *     this.model1 = this.model2 = this.model3 = new Rtl2Data({
 *       date: new Rtl2Date(+y, +m, +d),
 *       type: 'day'
 *     });
 *     this.model3.type = 'week';
 *   }
 * ```
 */
let Rtl2Datepicker = /*#__PURE__*/(() => {
  class Rtl2Datepicker {
    constructor(_service, _calendar, i18n, config) {
      this._service = _service;
      this._calendar = _calendar;
      this.i18n = i18n;
      this.months = [];
      /**
       * First day of the week. With default calendar we use ISO 8601: 'weekday' is 1=Mon ... 7=Sun
       */
      this.firstDayOfWeek = 6;
      /**
       * An event fired when navigation happens and currently displayed month changes.
       * See Rtl2DatepickerNavigateEvent for the payload info.
       */
      this.navigate = new EventEmitter();
      this.selected = new EventEmitter();
      this.disabled = false;
      this.onChange = _ => {};
      this.onTouched = () => {};
      this.classWeekDays = false;
      this.classWeekNumbers = false;
      this.classWeeksSelectable = false;
      this.dayTemplate = config.dayTemplate;
      this.displayMonths = config.displayMonths;
      this.firstDayOfWeek = config.firstDayOfWeek;
      this.markDisabled = config.markDisabled;
      this.minDate = config.minDate;
      this.maxDate = config.maxDate;
      this.navigation = config.navigation;
      this.outsideDays = config.outsideDays;
      this.showWeekdays = config.showWeekdays;
      this.showWeekNumbers = config.showWeekNumbers;
      this.startDate = config.startDate;
      this.weeksSelectable = config.weeksSelectable;
      this.initDate = config.initDate;
    }
    getHeaderHeight() {
      const h = this.showWeekdays ? 6.25 : 4.25;
      return this.displayMonths === 1 || this.navigation !== 'select' ? h - 2 : h;
    }
    getHeaderMargin() {
      const m = this.showWeekdays ? 2 : 0;
      return this.displayMonths !== 1 || this.navigation !== 'select' ? m + 2 : m;
    }
    /**
     * Navigates current view to provided date.
     * With default calendar we use ISO 8601: 'month' is 1=Jan ... 12=Dec.
     * If nothing or invalid date provided calendar will open current month.
     * Use 'startDate' input as an alternative
     */
    navigateTo(date) {
      this._setViewWithinLimits(this._service.toValidDate(date));
      this._updateData();
    }
    ngOnInit() {
      this.classWeekDays = this.showWeekdays;
      this.classWeekNumbers = this.showWeekNumbers;
      this.classWeeksSelectable = this.weeksSelectable;
      if (!!this.initDate) {
        this.setInit();
      }
      this._setDates();
      this.navigateTo(this._date);
    }
    ngOnChanges(changes) {
      if (changes['initDate']) {
        this.setInit();
      }
      this._setDates();
      this._setViewWithinLimits(this._date);
      if (changes['displayMonths']) {
        this.displayMonths = toInteger(this.displayMonths);
      }
      // we have to force rebuild all months only if any of these inputs changes
      if (['startDate', 'minDate', 'maxDate', 'navigation', 'firstDayOfWeek', 'markDisabled', 'displayMonths'].some(input => !!changes[input])) {
        this._updateData(true);
      }
    }
    onDateSelect(input) {
      const date = input.date || input.week.days[0];
      this._setViewWithinLimits(date);
      this.onTouched();
      this.writeValue(input);
      this.onChange(input);
      // switch current month
      if (this._date.month !== this.months[0].number && this.displayMonths === 1) {
        this._updateData();
      }
      this.selected.emit(input);
    }
    onNavigateDateSelect(date) {
      this._setViewWithinLimits(date);
      this._updateData();
    }
    onNavigateEvent(event) {
      switch (event) {
        case NavigationEvent.PREV:
          this._setViewWithinLimits(this._calendar.getPrev(this.months[0].firstDate, 'm'));
          break;
        case NavigationEvent.NEXT:
          this._setViewWithinLimits(this._calendar.getNext(this.months[0].firstDate, 'm'));
          break;
      }
      this._updateData();
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    writeValue(value) {
      this.model = this._service.toValidData(value, this.firstDayOfWeek);
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    _setDates() {
      this._maxDate = Rtl2Date.from(this.maxDate);
      this._minDate = Rtl2Date.from(this.minDate);
      this._date = this._service.toValidDate(this.startDate);
      if (!this._calendar.isValid(this._minDate)) {
        this._minDate = this._calendar.getPrev(this._date, 'y', 10);
        this.minDate = {
          year: this._minDate.year,
          month: this._minDate.month,
          day: this._minDate.day
        };
      }
      if (!this._calendar.isValid(this._maxDate)) {
        this._maxDate = this._calendar.getNext(this._date, 'y', 11);
        this._maxDate = this._calendar.getPrev(this._maxDate);
        this.maxDate = {
          year: this._maxDate.year,
          month: this._maxDate.month,
          day: this._maxDate.day
        };
      }
      if (this._minDate && this._maxDate && this._maxDate.before(this._minDate)) {
        throw new Error(`'maxDate' ${this._maxDate} should be greater than 'minDate' ${this._minDate}`);
      }
    }
    _setViewWithinLimits(date) {
      if (this._minDate && date.before(this._minDate)) {
        this._date = new Rtl2Date(this._minDate.year, this._minDate.month, 1);
      } else if (this._maxDate && date.after(this._maxDate)) {
        this._date = new Rtl2Date(this._maxDate.year, this._maxDate.month, 1);
      } else {
        this._date = new Rtl2Date(date.year, date.month, 1);
      }
    }
    _updateData(force = false) {
      const newMonths = [];
      for (let i = 0; i < this.displayMonths; i++) {
        const date = this._calendar.getNext(this._date, 'm', i);
        const index = this.months.findIndex(month => month.firstDate.equals(date));
        if (force || index === -1) {
          newMonths.push(this._service.generateMonthViewModel(date, this._minDate, this._maxDate, toInteger(this.firstDayOfWeek), this.markDisabled));
        } else {
          newMonths.push(this.months[index]);
        }
      }
      const newDate = newMonths[0].firstDate;
      const oldDate = this.months[0] ? this.months[0].firstDate : null;
      this.months = newMonths;
      // emitting navigation event if the first month changes
      if (!newDate.equals(oldDate)) {
        this.navigate.emit({
          current: oldDate ? {
            year: oldDate.year,
            month: oldDate.month
          } : null,
          next: {
            year: newDate.year,
            month: newDate.month
          }
        });
      }
    }
    setInit() {
      const interval = setInterval(() => {
        if (this.months.length) {
          clearInterval(interval);
          if (typeof this.initDate === 'object') {
            this.setInitData(this.initDate);
          } else {
            this.setInitData();
          }
        }
      }, 200);
    }
    setInitData(date) {
      // Default date - today
      if (!date) {
        const d = new Date();
        date = new Rtl2Date(d.getFullYear(), d.getMonth() + 1, d.getDate());
      }
      const model = new Rtl2Data();
      model.date = date;
      model.type = 'day';
      model.week = this._calendar.getDataWeekByDate(date, this.firstDayOfWeek);
      this.onTouched();
      this.writeValue(model);
      this.onChange(model);
    }
    static {
      this.ɵfac = function Rtl2Datepicker_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2Datepicker)(i0.ɵɵdirectiveInject(Rtl2DatepickerService), i0.ɵɵdirectiveInject(Rtl2Calendar), i0.ɵɵdirectiveInject(Rtl2DatepickerI18n), i0.ɵɵdirectiveInject(Rtl2DatepickerConfig));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2Datepicker,
        selectors: [["rtl2-datepicker"]],
        hostAttrs: [1, "d-inline-block", "rounded"],
        hostVars: 6,
        hostBindings: function Rtl2Datepicker_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("week-days", ctx.classWeekDays)("week-numbers", ctx.classWeekNumbers)("week-selectable", ctx.classWeeksSelectable);
          }
        },
        inputs: {
          dayTemplate: "dayTemplate",
          weekNumberTemplate: "weekNumberTemplate",
          displayMonths: "displayMonths",
          firstDayOfWeek: "firstDayOfWeek",
          markDisabled: "markDisabled",
          minDate: "minDate",
          maxDate: "maxDate",
          navigation: "navigation",
          outsideDays: "outsideDays",
          showWeekdays: "showWeekdays",
          showWeekNumbers: "showWeekNumbers",
          weeksSelectable: "weeksSelectable",
          initDate: "initDate",
          startDate: "startDate"
        },
        outputs: {
          navigate: "navigate",
          selected: "selected"
        },
        exportAs: ["rtl2Datepicker"],
        features: [i0.ɵɵProvidersFeature([NGB_DATEPICKER_VALUE_ACCESSOR$1, Rtl2DatepickerService]), i0.ɵɵNgOnChangesFeature],
        decls: 8,
        vars: 6,
        consts: [["dt", ""], ["wt", ""], [1, "ngb-dp-header", "bg-faded", "pt-1", "rounded-top"], [3, "date", "minDate", "maxDate", "months", "disabled", "showWeekNumbers", "showSelect", "navigate", "select", 4, "ngIf"], [1, "ngb-dp-months", "d-flex", "px-1", "pb-1"], ["ngFor", "", 3, "ngForOf"], ["rtl2DatepickerDayView", "", 3, "date", "currentMonth", "selected", "disabled"], ["rtl2DatepickerWeekNumberView", "", 3, "week", "selected", "disabled"], [3, "navigate", "select", "date", "minDate", "maxDate", "months", "disabled", "showWeekNumbers", "showSelect"], [1, "ngb-dp-month", "d-block", "ml-3"], ["class", "ngb-dp-month-name text-center", 4, "ngIf"], [3, "select", "month", "selectedData", "dayTemplate", "weekNumberTemplate", "showWeekdays", "showWeekNumbers", "weeksSelectable", "disabled", "outsideDays"], [1, "ngb-dp-month-name", "text-center"]],
        template: function Rtl2Datepicker_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, Rtl2Datepicker_ng_template_0_Template, 1, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, Rtl2Datepicker_ng_template_2_Template, 1, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(4, "div", 2);
            i0.ɵɵtemplate(5, Rtl2Datepicker_rtl2_datepicker_navigation_5_Template, 1, 7, "rtl2-datepicker-navigation", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 4);
            i0.ɵɵtemplate(7, Rtl2Datepicker_ng_template_7_Template, 3, 10, "ng-template", 5);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵstyleProp("height", ctx.getHeaderHeight(), "rem")("margin-bottom", -ctx.getHeaderMargin(), "rem");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.navigation !== "none");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.months);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, Rtl2DatepickerMonthView, Rtl2DatepickerNavigation, Rtl2DatepickerDayView, Rtl2DatepickerWeekNumberView, i2$1.TranslatePipe],
        styles: ["[_nghost-%COMP%]{border:0}.week-numbers[_nghost-%COMP%] > .ngb-dp-header[_ngcontent-%COMP%]{position:relative;z-index:1}.week-numbers[_nghost-%COMP%] > .ngb-dp-months[_ngcontent-%COMP%]{position:relative;z-index:0}.week-numbers[_nghost-%COMP%] > .ngb-dp-months[_ngcontent-%COMP%]:before{position:absolute;content:\"\";top:0;bottom:2px;left:2px;width:2.25rem;z-index:-1}[_nghost-%COMP%]     rtl2-datepicker-navigation>.btn-link{border-color:transparent;background:transparent}[_nghost-%COMP%]     rtl2-datepicker-navigation>.btn-link[disabled]{opacity:.1;cursor:inherit}[_nghost-%COMP%]     .custom-select{background-color:transparent;border:0}[_nghost-%COMP%]     .text-info{font-style:normal}[_nghost-%COMP%]     .ngb-dp-week.week-selected .ngb-dp-day>div{border-radius:0}[_nghost-%COMP%]     .ngb-dp-week.week-selected .ngb-dp-day:first-child>div{border-radius:20px 0 0 20px}[_nghost-%COMP%]     .ngb-dp-week.week-selected .ngb-dp-day:last-child>div{border-radius:0 20px 20px 0}[_nghost-%COMP%]     .ngb-dp-week.week-selected .ngb-dp-day:not(.ngb-dp-week-number)>div{box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f;opacity:.5}[_nghost-%COMP%]     .ngb-dp-week.week-selected .ngb-dp-day:not(.ngb-dp-week-number)>div:hover{opacity:1}[_nghost-%COMP%]     .ngb-dp-day{width:calc(2rem - 2px)!important;height:calc(2rem - 2px)!important;margin:1px}[_nghost-%COMP%]     .ngb-dp-day [rtl2datepickerweeknumberview], [_nghost-%COMP%]     .ngb-dp-day [rtl2datepickerdayview]{width:calc(2rem - 2px)!important;height:calc(2rem - 2px)!important;line-height:calc(2rem - 2px)!important;background-color:transparent;border-radius:20px;transition:all .2s ease-in-out}[_nghost-%COMP%]     .ngb-dp-day .bg-primary{box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}[_nghost-%COMP%]     .ngb-dp-day:not(.non-selectable):not(.disabled) .bg-primary:hover, [_nghost-%COMP%]     .ngb-dp-day:not(.non-selectable):not(.disabled) .btn-secondary:hover, [_nghost-%COMP%]     .ngb-dp-day:not(.non-selectable):not(.disabled) .outside:hover{box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}[_nghost-%COMP%]     .ngb-dp-day.non-selectable .bg-primary:hover, [_nghost-%COMP%]     .ngb-dp-day.non-selectable .bg-primary:active, [_nghost-%COMP%]     .ngb-dp-day.non-selectable .btn-secondary:hover, [_nghost-%COMP%]     .ngb-dp-day.non-selectable .btn-secondary:active, [_nghost-%COMP%]     .ngb-dp-day.non-selectable .outside:hover, [_nghost-%COMP%]     .ngb-dp-day.non-selectable .outside:active, [_nghost-%COMP%]     .ngb-dp-day.disabled .bg-primary:hover, [_nghost-%COMP%]     .ngb-dp-day.disabled .bg-primary:active, [_nghost-%COMP%]     .ngb-dp-day.disabled .btn-secondary:hover, [_nghost-%COMP%]     .ngb-dp-day.disabled .btn-secondary:active, [_nghost-%COMP%]     .ngb-dp-day.disabled .outside:hover, [_nghost-%COMP%]     .ngb-dp-day.disabled .outside:active{background-color:transparent!important}[_nghost-%COMP%]     .ngb-dp-day.ngb-dp-week-number{position:relative}[_nghost-%COMP%]     .ngb-dp-day.ngb-dp-week-number:before{content:\"\";position:absolute;inset:-2px;z-index:-1}.ngb-dp-header[_ngcontent-%COMP%]{background-color:transparent}.ngb-dp-month[_ngcontent-%COMP%]{pointer-events:none}rtl2-datepicker-month-view[_ngcontent-%COMP%]{pointer-events:auto}.ngb-dp-month[_ngcontent-%COMP%]:first-child{margin-left:0!important}.ngb-dp-month-name[_ngcontent-%COMP%]{font-size:larger;height:2rem;line-height:2rem}"]
      });
    }
  }
  return Rtl2Datepicker;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// previous version:
// https://github.com/angular-ui/bootstrap/blob/07c31d0731f7cb068a1932b8e01d2312b796b4ec/src/position/position.js
class Positioning {
  getStyle(element, prop) {
    return window.getComputedStyle(element)[prop];
  }
  isStaticPositioned(element) {
    return (this.getStyle(element, 'position') || 'static') === 'static';
  }
  offsetParent(element) {
    let offsetParentEl = element.offsetParent || document.documentElement;
    while (offsetParentEl && offsetParentEl !== document.documentElement && this.isStaticPositioned(offsetParentEl)) {
      offsetParentEl = offsetParentEl.offsetParent;
    }
    return offsetParentEl || document.documentElement;
  }
  position(element, round = true) {
    let elPosition = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
    let parentOffset = {
      top: 0,
      left: 0
    };
    if (this.getStyle(element, 'position') === 'fixed') {
      elPosition = element.getBoundingClientRect();
    } else {
      const offsetParentEl = this.offsetParent(element);
      elPosition = this.offset(element, false);
      if (offsetParentEl !== document.documentElement) {
        parentOffset = this.offset(offsetParentEl, false);
      }
      parentOffset.top += offsetParentEl.clientTop;
      parentOffset.left += offsetParentEl.clientLeft;
    }
    elPosition.top -= parentOffset.top;
    elPosition.bottom -= parentOffset.top;
    elPosition.left -= parentOffset.left;
    elPosition.right -= parentOffset.left;
    if (round) {
      elPosition.top = Math.round(elPosition.top);
      elPosition.bottom = Math.round(elPosition.bottom);
      elPosition.left = Math.round(elPosition.left);
      elPosition.right = Math.round(elPosition.right);
    }
    return elPosition;
  }
  offset(element, round = true) {
    const elBcr = element.getBoundingClientRect();
    const viewportOffset = {
      top: window.pageYOffset - document.documentElement.clientTop,
      left: window.pageXOffset - document.documentElement.clientLeft
    };
    let elOffset = {
      height: elBcr.height || element.offsetHeight,
      width: elBcr.width || element.offsetWidth,
      top: elBcr.top + viewportOffset.top,
      bottom: elBcr.bottom + viewportOffset.top,
      left: elBcr.left + viewportOffset.left,
      right: elBcr.right + viewportOffset.left
    };
    if (round) {
      elOffset.height = Math.round(elOffset.height);
      elOffset.width = Math.round(elOffset.width);
      elOffset.top = Math.round(elOffset.top);
      elOffset.bottom = Math.round(elOffset.bottom);
      elOffset.left = Math.round(elOffset.left);
      elOffset.right = Math.round(elOffset.right);
    }
    return elOffset;
  }
  positionElements(hostElement, targetElement, placement, appendToBody) {
    const hostElPosition = appendToBody ? this.offset(hostElement, false) : this.position(hostElement, false);
    const targetElBCR = targetElement.getBoundingClientRect();
    const placementPrimary = placement.split('-')[0] || 'top';
    const placementSecondary = placement.split('-')[1] || 'center';
    let targetElPosition = {
      height: targetElBCR.height || targetElement.offsetHeight,
      width: targetElBCR.width || targetElement.offsetWidth,
      top: 0,
      bottom: targetElBCR.height || targetElement.offsetHeight,
      left: 0,
      right: targetElBCR.width || targetElement.offsetWidth
    };
    switch (placementPrimary) {
      case 'top':
        targetElPosition.top = hostElPosition.top - targetElement.offsetHeight;
        break;
      case 'bottom':
        targetElPosition.top = hostElPosition.top + hostElPosition.height;
        break;
      case 'left':
        targetElPosition.left = hostElPosition.left - targetElement.offsetWidth;
        break;
      case 'right':
        targetElPosition.left = hostElPosition.left + hostElPosition.width;
        break;
    }
    switch (placementSecondary) {
      case 'top':
        targetElPosition.top = hostElPosition.top;
        break;
      case 'bottom':
        targetElPosition.top = hostElPosition.top + hostElPosition.height - targetElement.offsetHeight;
        break;
      case 'left':
        targetElPosition.left = hostElPosition.left;
        break;
      case 'right':
        targetElPosition.left = hostElPosition.left + hostElPosition.width - targetElement.offsetWidth;
        break;
      case 'center':
        if (placementPrimary === 'top' || placementPrimary === 'bottom') {
          targetElPosition.left = hostElPosition.left + hostElPosition.width / 2 - targetElement.offsetWidth / 2;
        } else {
          targetElPosition.top = hostElPosition.top + hostElPosition.height / 2 - targetElement.offsetHeight / 2;
        }
        break;
    }
    targetElPosition.top = Math.round(targetElPosition.top);
    targetElPosition.bottom = Math.round(targetElPosition.bottom);
    targetElPosition.left = Math.round(targetElPosition.left);
    targetElPosition.right = Math.round(targetElPosition.right);
    return targetElPosition;
  }
}
const positionService = new Positioning();
function positionElements(hostElement, targetElement, placement, appendToBody) {
  const pos = positionService.positionElements(hostElement, targetElement, placement, appendToBody);
  targetElement.style.top = `${pos.top}px`;
  targetElement.style.left = `${pos.left}px`;
}

/**
 * Abstract type serving as a DI token for the service parsing and formatting dates for the Rtl2InputDatepicker
 * directive. A default implementation using the ISO 8601 format is provided, but you can provide another implementation
 * to use an alternative format.
 */
class Rtl2DateParserFormatter {}
class Rtl2DateISOParserFormatter extends Rtl2DateParserFormatter {
  constructor() {
    super(...arguments);
    this.datePipe = new DatePipe('en-US');
  }
  parse(value) {
    if (value) {
      const dateParts = value.trim().split('.').reverse();
      if (dateParts.length === 1 && isNumber(dateParts[0])) {
        return {
          year: toInteger(dateParts[0]),
          month: null,
          day: null
        };
      } else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
        return {
          year: toInteger(dateParts[0]),
          month: toInteger(dateParts[1]),
          day: null
        };
      } else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
        return {
          year: toInteger(dateParts[0]),
          month: toInteger(dateParts[1]),
          day: toInteger(dateParts[2])
        };
      }
    }
    return null;
  }
  format(date) {
    if (date === null) {
      return '';
    }
    try {
      return this.datePipe.transform(new Date(date.year, date.month - 1, date.day), 'dd.MM.y');
    } catch (e) {
      return '';
    }
  }
}
const NGB_DATEPICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => Rtl2InputDatepicker),
  multi: true
};
const NGB_DATEPICKER_VALIDATOR = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => Rtl2InputDatepicker),
  multi: true
};
/**
 * A directive that makes it possible to have datepickers on input fields.
 * Manages integration with the input field itself (data entry) and ngModel (validation etc.).
 *
 * Example:
 * ```html
 * // Single day selection, week starts Monday
 * <input
 *   class="align-self-start"
 *   rtl2Datepicker
 *   #d1="rtl2Datepicker"
 *   [(ngModel)]="model1"
 *   [firstDayOfWeek]="1"
 *   (focus)="d1.open()"
 *   (mousedown)="d1.toggle()"
 *   (blur)="close(d1)"/>
 *
 * // Single day or week selection, week starts Monday
 * <input
 *   class="align-self-start"
 *   rtl2Datepicker
 *   #d2="rtl2Datepicker"
 *   [(ngModel)]="model2"
 *   [firstDayOfWeek]="1"
 *   [showWeekNumbers]="true"
 *   [weeksSelectable]="true"
 *   (focus)="d2.open()"
 *   (mousedown)="d2.toggle()"
 *   (blur)="close(d2)"/>
 * ```
 *
 * ```typescript
 * model1: Rtl2Data;
 * model2: Rtl2Data;
 *
 * constructor() {
 *   const [y, m, d] = new Date().toISOString().split('T')[0].split('-');
 *   this.model1 = this.model2 = new Rtl2Data({
 *     date: new Rtl2Date(+y, +m, +d),
 *     type: 'day'
 *   });
 * }
 *
 * close(datepicker: any) {
 *   setTimeout(() => {
 *     datepicker.close();
 *   }, 100);
 * }
 * ```
 */
let Rtl2InputDatepicker = /*#__PURE__*/(() => {
  class Rtl2InputDatepicker {
    constructor(_parserFormatter, _elRef, _vcRef, _renderer, _cfr, ngZone, _service, _calendar) {
      this._parserFormatter = _parserFormatter;
      this._elRef = _elRef;
      this._vcRef = _vcRef;
      this._renderer = _renderer;
      this._cfr = _cfr;
      this._service = _service;
      this._calendar = _calendar;
      this._cRef = null;
      /**
       * First day of the week. With default calendar we use ISO 8601: 1=Mon ... 7=Sun
       */
      this.firstDayOfWeek = 6;
      /**
       * Placement of a datepicker popup. Accepts: "top", "bottom", "left", "right", "bottom-left",
       * "bottom-right" etc.
       */
      this.placement = 'bottom-left';
      /**
       * An event fired when navigation happens and currently displayed month changes.
       * See Rtl2DatepickerNavigateEvent for the payload info.
       */
      this.navigate = new EventEmitter();
      this._onChange = _ => {};
      this._onTouched = () => {};
      this._validatorChange = () => {};
      this._zoneSubscription = ngZone.onStable.subscribe(() => {
        if (this._cRef) {
          positionElements(this._elRef.nativeElement, this._cRef.location.nativeElement, this.placement);
        }
      });
    }
    registerOnChange(fn) {
      this._onChange = fn;
    }
    registerOnTouched(fn) {
      this._onTouched = fn;
    }
    registerOnValidatorChange(fn) {
      this._validatorChange = fn;
    }
    setDisabledState(isDisabled) {
      this._renderer.setProperty(this._elRef.nativeElement, 'disabled', isDisabled);
      if (this.isOpen()) {
        this._cRef.instance.setDisabledState(isDisabled);
      }
    }
    validate(c) {
      const value = c.value;
      if (value === null || value === undefined) {
        return null;
      }
      if (!this._calendar.isValid(value)) {
        return {
          rtl2Date: {
            invalid: c.value
          }
        };
      }
      if (this.minDate && Rtl2Date.from(value).before(Rtl2Date.from(this.minDate))) {
        return {
          rtl2Date: {
            requiredBefore: this.minDate
          }
        };
      }
      if (this.maxDate && Rtl2Date.from(value).after(Rtl2Date.from(this.maxDate))) {
        return {
          rtl2Date: {
            requiredAfter: this.maxDate
          }
        };
      }
    }
    writeValue(value) {
      if (!value && this.initDate) {
        value = new Rtl2Data();
        value.date = this.initDate;
      }
      this._model = this._service.toValidData(value, this.firstDayOfWeek);
      this._writeModelValue(this._model);
    }
    manualDateChange(value) {
      if (this._cRef) {
        const date = this._parserFormatter.parse(value);
        this._cRef.instance.setInitData(date);
        this._model = this._cRef.instance.model;
        this._writeModelValue(this._model);
      }
    }
    isOpen() {
      return !!this._cRef;
    }
    /**
     * Opens the datepicker with the selected date indicated by the ngModel value.
     */
    open() {
      if (!this.isOpen()) {
        if (!this._model) {
          this.setInit();
        }
        const cf = this._cfr.resolveComponentFactory(Rtl2Datepicker);
        this._cRef = this._vcRef.createComponent(cf);
        this._applyPopupStyling(this._cRef.location.nativeElement);
        this._applyDatepickerInputs(this._cRef.instance);
        this._cRef.instance.writeValue(this._model);
        this._subscribeForDatepickerOutputs(this._cRef.instance);
        this._cRef.instance.ngOnInit();
        // date selection event handling
        this._cRef.instance.registerOnChange(selectedDate => {
          this.writeValue(selectedDate);
          this.close();
        });
      }
    }
    /**
     * Closes the datepicker popup.
     */
    close() {
      if (this.isOpen()) {
        this._vcRef.remove(this._vcRef.indexOf(this._cRef.hostView));
        this._cRef = null;
      }
    }
    /**
     * Toggles the datepicker popup (opens when closed and closes when opened).
     */
    toggle() {
      if (this.isOpen()) {
        this.close();
      } else {
        this.open();
      }
    }
    /**
     * Navigates current view to provided date.
     * With default calendar we use ISO 8601: 'month' is 1=Jan ... 12=Dec.
     * If nothing or invalid date provided calendar will open current month.
     * Use 'startDate' input as an alternative
     */
    navigateTo(date) {
      if (this.isOpen()) {
        this._cRef.instance.navigateTo(date);
      }
    }
    onBlur() {
      this._onTouched();
    }
    ngOnChanges(changes) {
      if (changes['minDate'] || changes['maxDate']) {
        this._validatorChange();
      }
    }
    ngOnDestroy() {
      this.close();
      this._zoneSubscription.unsubscribe();
    }
    _applyDatepickerInputs(datepickerInstance) {
      ['dayTemplate', 'displayMonths', 'firstDayOfWeek', 'markDisabled', 'minDate', 'maxDate', 'navigation', 'outsideDays', 'showNavigation', 'showWeekdays', 'showWeekNumbers', 'weeksSelectable'].forEach(optionName => {
        if (this[optionName] !== undefined) {
          datepickerInstance[optionName] = this[optionName];
        }
      });
      datepickerInstance.startDate = this._model.date || this.startDate;
    }
    _applyPopupStyling(nativeElement) {
      this._renderer.addClass(nativeElement, 'dropdown-menu');
      this._renderer.setStyle(nativeElement, 'padding', '0');
    }
    _subscribeForDatepickerOutputs(datepickerInstance) {
      datepickerInstance.navigate.subscribe(date => this.navigate.emit(date));
    }
    _writeModelValue(model) {
      this._renderer.setProperty(this._elRef.nativeElement, 'value', this._parserFormatter.format(model.date));
      if (this.isOpen()) {
        this._cRef.instance.writeValue(model);
        this._onTouched();
      }
      this._onChange(model);
    }
    setInit() {
      if (typeof this.initDate === 'object') {
        this.setInitData(this.initDate);
      } else {
        this.setInitData();
      }
    }
    setInitData(date) {
      // Default date - today
      if (!date) {
        const d = new Date();
        date = new Rtl2Date(d.getFullYear(), d.getMonth() + 1, d.getDate());
      }
      const model = new Rtl2Data();
      model.date = date;
      model.type = 'day';
      model.week = this._calendar.getDataWeekByDate(date, this.firstDayOfWeek);
      this.writeValue(model);
    }
    static {
      this.ɵfac = function Rtl2InputDatepicker_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2InputDatepicker)(i0.ɵɵdirectiveInject(Rtl2DateParserFormatter), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(Rtl2DatepickerService), i0.ɵɵdirectiveInject(Rtl2Calendar));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: Rtl2InputDatepicker,
        selectors: [["input", "rtl2Datepicker", ""]],
        hostBindings: function Rtl2InputDatepicker_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("change", function Rtl2InputDatepicker_change_HostBindingHandler($event) {
              return ctx.manualDateChange($event.target.value);
            })("keyup.esc", function Rtl2InputDatepicker_keyup_esc_HostBindingHandler() {
              return ctx.close();
            })("blur", function Rtl2InputDatepicker_blur_HostBindingHandler() {
              return ctx.onBlur();
            });
          }
        },
        inputs: {
          dayTemplate: "dayTemplate",
          displayMonths: "displayMonths",
          weekNumberTemplate: "weekNumberTemplate",
          firstDayOfWeek: "firstDayOfWeek",
          markDisabled: "markDisabled",
          minDate: "minDate",
          maxDate: "maxDate",
          navigation: "navigation",
          outsideDays: "outsideDays",
          placement: "placement",
          showWeekdays: "showWeekdays",
          showWeekNumbers: "showWeekNumbers",
          weeksSelectable: "weeksSelectable",
          initDate: "initDate",
          startDate: "startDate"
        },
        outputs: {
          navigate: "navigate"
        },
        exportAs: ["rtl2Datepicker"],
        features: [i0.ɵɵProvidersFeature([NGB_DATEPICKER_VALUE_ACCESSOR, NGB_DATEPICKER_VALIDATOR, Rtl2DatepickerService]), i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return Rtl2InputDatepicker;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2DatepickerModule = /*#__PURE__*/(() => {
  class Rtl2DatepickerModule {
    static forRoot() {
      return {
        ngModule: Rtl2DatepickerModule,
        providers: [{
          provide: Rtl2Calendar,
          useClass: Rtl2CalendarGregorian
        }, {
          provide: Rtl2DatepickerI18n,
          useClass: Rtl2DatepickerI18nDefault
        }, {
          provide: Rtl2DateParserFormatter,
          useClass: Rtl2DateISOParserFormatter
        }, Rtl2DatepickerConfig]
      };
    }
    static {
      this.ɵfac = function Rtl2DatepickerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2DatepickerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2DatepickerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, TranslateModule]
      });
    }
  }
  return Rtl2DatepickerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2FabSpeedDialService = /*#__PURE__*/(() => {
  class Rtl2FabSpeedDialService {
    constructor() {
      this.fabActionsOpen = new BehaviorSubject(false);
      // Can be 'up', 'down', 'left' or 'right'
      this.fabExpandDirection = new BehaviorSubject('down');
      // fling or scale
      this.fabAnimationMode = new BehaviorSubject('fling');
    }
    getTranslateFunction(value) {
      const dir = this.fabExpandDirection.getValue();
      const translateFn = dir === 'up' || dir === 'down' ? 'translateY' : 'translateX';
      const sign = dir === 'down' || dir === 'right' ? '-' : '';
      return translateFn + '(' + sign + value + ')';
    }
    setActionsVisibility(value) {
      if (value == null) {
        value = !this.fabActionsOpen.getValue();
      }
      this.fabActionsOpen.next(value);
    }
    setDirection(direction) {
      this.fabExpandDirection.next(direction);
    }
    static {
      this.ɵfac = function Rtl2FabSpeedDialService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2FabSpeedDialService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: Rtl2FabSpeedDialService,
        factory: Rtl2FabSpeedDialService.ɵfac
      });
    }
  }
  return Rtl2FabSpeedDialService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const Z_INDEX_ITEM = 23;
let Rtl2FabSpeedDialActionsComponent = /*#__PURE__*/(() => {
  class Rtl2FabSpeedDialActionsComponent {
    constructor(element, renderer, contentObserver, fabService) {
      this.element = element;
      this.renderer = renderer;
      this.contentObserver = contentObserver;
      this.fabService = fabService;
      this.destroy$ = new Subject();
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    ngOnInit() {
      this.fabService.fabActionsOpen.pipe(takeUntil$1(this.destroy$), tap(o => !o ? this.hide() : this.show())).subscribe();
    }
    ngAfterContentInit() {
      this.initButtonStates();
      this.observeChanges();
    }
    observeChanges() {
      if (!this.element?.nativeElement) return;
      this.contentObserver.observe(this.element.nativeElement).pipe(takeUntil$1(this.destroy$), debounceTime(200),
      // filter out button added or removed changes
      filter(event => event?.some(e => [...(Array.from(e?.addedNodes) || []), ...(Array.from(e?.removedNodes) || [])].some(i => i?.nodeName === 'BUTTON'))), tap(() => {
        this.initButtonStates();
        this.fabService.setActionsVisibility(false);
      })).subscribe();
    }
    initButtonStates() {
      this.buttons = this.element?.nativeElement?.querySelectorAll('[md-mini-fab], [mat-mini-fab]');
      if (this.buttons?.length) this.buttons.forEach((button, i) => {
        this.renderer.addClass(button, 'rtl2-fab-action-item');
        this.changeElementStyle(button, 'z-index', '' + (Z_INDEX_ITEM - i));
      });
      this.hide();
    }
    show() {
      if (!this.buttons?.length) return;
      this.buttons.forEach((button, i) => {
        let transitionDelay = 0;
        let transform;
        if (this.fabService.fabAnimationMode.getValue() === 'scale') {
          // Incremental transition delay of 65ms for each action button
          transitionDelay = 3 + 65 * i;
          transform = 'scale(1)';
        } else {
          transform = this.fabService.getTranslateFunction('0');
        }
        this.changeElementTransition(button, transitionDelay, '1', transform);
      });
    }
    hide() {
      if (!this.buttons?.length) return;
      this.buttons.forEach((button, i) => {
        let opacity = '1';
        let transitionDelay = 0;
        let transform;
        if (this.fabService.fabAnimationMode.getValue() === 'scale') {
          transitionDelay = 3 - 65 * i;
          transform = 'scale(0)';
          opacity = '0';
        } else {
          transform = this.fabService.getTranslateFunction(55 * (i + 1) - i * 5 + 'px');
        }
        this.changeElementTransition(button, transitionDelay, opacity, transform);
      });
    }
    changeElementTransition(elem, delay, opacity, transform) {
      this.changeElementStyle(elem, 'transition-delay', delay + 'ms');
      this.changeElementStyle(elem, 'opacity', opacity);
      this.changeElementStyle(elem, 'transform', transform);
    }
    changeElementStyle(elem, style, value) {
      this.renderer.setStyle(elem, style, value);
    }
    static {
      this.ɵfac = function Rtl2FabSpeedDialActionsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2FabSpeedDialActionsComponent)(i0.ɵɵdirectiveInject(i0.ElementRef, 2), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1$3.ContentObserver), i0.ɵɵdirectiveInject(Rtl2FabSpeedDialService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2FabSpeedDialActionsComponent,
        selectors: [["rtl2-fab-actions"]],
        ngContentSelectors: _c6,
        decls: 1,
        vars: 0,
        template: function Rtl2FabSpeedDialActionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c5);
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return Rtl2FabSpeedDialActionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2FabSpeedDialTriggerComponent = /*#__PURE__*/(() => {
  class Rtl2FabSpeedDialTriggerComponent {
    constructor(fabService) {
      this.fabService = fabService;
      /**
       * Whether this trigger should spin (360dg) while opening the speed dial
       */
      this.spin = false;
    }
    _onClick(event) {
      this.fabService.setActionsVisibility();
      event.stopPropagation();
    }
    static {
      this.ɵfac = function Rtl2FabSpeedDialTriggerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2FabSpeedDialTriggerComponent)(i0.ɵɵdirectiveInject(Rtl2FabSpeedDialService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2FabSpeedDialTriggerComponent,
        selectors: [["rtl2-fab-trigger"]],
        hostVars: 2,
        hostBindings: function Rtl2FabSpeedDialTriggerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function Rtl2FabSpeedDialTriggerComponent_click_HostBindingHandler($event) {
              return ctx._onClick($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("rtl2-spin", ctx.spin);
          }
        },
        inputs: {
          spin: "spin"
        },
        ngContentSelectors: _c8,
        decls: 1,
        vars: 0,
        template: function Rtl2FabSpeedDialTriggerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c7);
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return Rtl2FabSpeedDialTriggerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * In-place menu
 *
 * Example:
 * ```html
 * <rtl2-fab-speed-dial direction="down" animationMode="fling">
 *   <rtl2-fab-trigger>
 *     <button mat-fab color="accent" (click)="false">
 *     <mat-icon>more_vert</mat-icon>
 *     </button>
 *   </rtl2-fab-trigger>
 *
 *   <rtl2-fab-actions>
 *     <button mat-mini-fab
 *       color="primary"
 *       (click)="clicked('Details', 'info')"
 *       matTooltipPosition="right"
 *       matTooltip="Details"
 *       matTooltipClass="primary">
 *         <mat-icon>info</mat-icon>
 *     </button>
 *     <button mat-mini-fab
 *       color="warn"
 *       (click)="clicked('Remove', 'error')"
 *       matTooltipPosition="right"
 *       matTooltip="Remove"
 *       matTooltipClass="warn">
 *         <mat-icon>delete</mat-icon>
 *     </button>
 *     <button mat-mini-fab
 *       color="notice"
 *       (click)="clicked('Archive', 'warn')"
 *       matTooltipPosition="right"
 *       matTooltip="Archive"
 *       matTooltipClass="notice">
 *         <mat-icon>archive</mat-icon>
 *     </button>
 *   </rtl2-fab-actions>
 * </rtl2-fab-speed-dial>
 * ```
 *
 * ```typescript
 * constructor(private note: Rtl2NotificationService) {}
 *
 * clicked(name: string, type: string) {
 *   this.note.callSnackBar(`"${name}" clicked!`, type);
 * }
 * ```
 * */
let Rtl2FabSpeedDialComponent = /*#__PURE__*/(() => {
  class Rtl2FabSpeedDialComponent {
    /**
     * Whether this speed dial is opened
     */
    get open() {
      return this._open;
    }
    set open(open) {
      const previousOpen = this._open;
      this._open = open;
      if (previousOpen !== this._open) {
        this.openChange.emit(this._open);
        if (this.isInitialized) {
          this.fabService.setActionsVisibility(this._open);
        }
      }
    }
    /**
     * The direction of the speed dial. Can be 'up', 'down', 'left' or 'right'
     */
    get direction() {
      return this.fabService.fabExpandDirection.getValue();
    }
    set direction(direction) {
      const previousDir = this.fabService.fabExpandDirection.getValue();
      this.fabService.setDirection(direction);
      if (previousDir !== this.direction) {
        this._setElementClass(previousDir, false);
        this._setElementClass(this.direction, true);
        if (this.isInitialized) {
          this.fabService.setActionsVisibility(this._open);
        }
      }
    }
    /**
     * The animation mode to open the speed dial. Can be 'fling' or 'scale'
     */
    get animationMode() {
      return this.fabService.fabAnimationMode.getValue();
    }
    set animationMode(animationMode) {
      const previousAnimationMode = this.fabService.fabAnimationMode.getValue();
      this.fabService.fabAnimationMode.next(animationMode);
      if (previousAnimationMode !== this.fabService.fabAnimationMode.getValue()) {
        this._setElementClass(previousAnimationMode, false);
        this._setElementClass(this.animationMode, true);
        if (this.isInitialized) {
          // To start another detect lifecycle and force the "close" on the action buttons
          this.fabService.setActionsVisibility(false);
        }
      }
    }
    constructor(elementRef, renderer, fabService) {
      this.elementRef = elementRef;
      this.renderer = renderer;
      this.fabService = fabService;
      this.isInitialized = false;
      this._open = false;
      /**
       * Whether this speed dial is fixed on screen (user cannot change it by clicking)
       */
      this.fixed = false;
      this.openChange = new EventEmitter();
    }
    ngAfterContentInit() {
      this.isInitialized = true;
      this._setElementClass(this.direction, true);
      this._setElementClass(this.animationMode, true);
    }
    _onClick() {
      if (!this.fixed) {
        this.fabService.setActionsVisibility();
      }
    }
    _setElementClass(elemClass, isAdd) {
      isAdd ? this.renderer.addClass(this.elementRef.nativeElement, `rtl2-${elemClass}`) : this.renderer.removeClass(this.elementRef.nativeElement, `rtl2-${elemClass}`);
    }
    static {
      this.ɵfac = function Rtl2FabSpeedDialComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2FabSpeedDialComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(Rtl2FabSpeedDialService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2FabSpeedDialComponent,
        selectors: [["rtl2-fab-speed-dial"]],
        contentQueries: function Rtl2FabSpeedDialComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, Rtl2FabSpeedDialActionsComponent, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._childActions = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function Rtl2FabSpeedDialComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function Rtl2FabSpeedDialComponent_click_HostBindingHandler() {
              return ctx._onClick();
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("rtl2-opened", ctx.open);
          }
        },
        inputs: {
          fixed: "fixed",
          open: "open",
          direction: "direction",
          animationMode: "animationMode"
        },
        outputs: {
          openChange: "openChange"
        },
        features: [i0.ɵɵProvidersFeature([Rtl2FabSpeedDialService])],
        ngContentSelectors: _c10,
        decls: 3,
        vars: 0,
        consts: [[1, "rtl2-fab-speed-dial-container"]],
        template: function Rtl2FabSpeedDialComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c9);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵprojection(2, 1);
            i0.ɵɵelementEnd();
          }
        },
        styles: ["rtl2-fab-speed-dial{display:inline-block}rtl2-fab-speed-dial.rtl2-opened .rtl2-fab-speed-dial-container rtl2-fab-trigger.rtl2-spin{-webkit-transform:rotate(360deg);transform:rotate(360deg)}rtl2-fab-speed-dial .rtl2-fab-speed-dial-container{position:relative;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;z-index:20}rtl2-fab-speed-dial .rtl2-fab-speed-dial-container rtl2-fab-trigger{pointer-events:auto;z-index:24}rtl2-fab-speed-dial .rtl2-fab-speed-dial-container rtl2-fab-trigger.rtl2-spin{-webkit-transition:all .6s cubic-bezier(.4,0,.2,1);transition:all .6s cubic-bezier(.4,0,.2,1)}rtl2-fab-speed-dial .rtl2-fab-speed-dial-container rtl2-fab-actions{display:-webkit-box;display:-webkit-flex;display:flex;height:auto}rtl2-fab-speed-dial.rtl2-fling .rtl2-fab-speed-dial-container rtl2-fab-actions .rtl2-fab-action-item{display:block;opacity:0;-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2)}rtl2-fab-speed-dial.rtl2-scale .rtl2-fab-speed-dial-container rtl2-fab-actions .rtl2-fab-action-item{-webkit-transform:scale(0);transform:scale(0);-webkit-transition:all .3s cubic-bezier(.55,0,.55,.2);transition:all .3s cubic-bezier(.55,0,.55,.2);-webkit-transition-duration:.14286s;transition-duration:.14286s}rtl2-fab-speed-dial.rtl2-down .rtl2-fab-speed-dial-container{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}rtl2-fab-speed-dial.rtl2-down .rtl2-fab-speed-dial-container rtl2-fab-trigger{-webkit-box-ordinal-group:2;-webkit-order:1;order:1}rtl2-fab-speed-dial.rtl2-down .rtl2-fab-speed-dial-container rtl2-fab-actions{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;-webkit-box-ordinal-group:3;-webkit-order:2;order:2}rtl2-fab-speed-dial.rtl2-down .rtl2-fab-speed-dial-container rtl2-fab-actions .rtl2-fab-action-item{margin-top:10px}rtl2-fab-speed-dial.rtl2-down .rtl2-fab-speed-dial-container rtl2-fab-actions button{font-size:revert;line-height:revert;font-family:revert}rtl2-fab-speed-dial.rtl2-up .rtl2-fab-speed-dial-container{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column}rtl2-fab-speed-dial.rtl2-up .rtl2-fab-speed-dial-container rtl2-fab-trigger{-webkit-box-ordinal-group:3;-webkit-order:2;order:2}rtl2-fab-speed-dial.rtl2-up .rtl2-fab-speed-dial-container rtl2-fab-actions{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-webkit-flex-direction:column-reverse;flex-direction:column-reverse;-webkit-box-ordinal-group:2;-webkit-order:1;order:1}rtl2-fab-speed-dial.rtl2-up .rtl2-fab-speed-dial-container rtl2-fab-actions .rtl2-fab-action-item{margin-bottom:10px}rtl2-fab-speed-dial.rtl2-up .rtl2-fab-speed-dial-container rtl2-fab-actions button{font-size:revert;line-height:revert;font-family:revert}rtl2-fab-speed-dial.rtl2-left .rtl2-fab-speed-dial-container{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}rtl2-fab-speed-dial.rtl2-left .rtl2-fab-speed-dial-container rtl2-fab-trigger{-webkit-box-ordinal-group:3;-webkit-order:2;order:2}rtl2-fab-speed-dial.rtl2-left .rtl2-fab-speed-dial-container rtl2-fab-actions{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row-reverse;flex-direction:row-reverse;-webkit-box-ordinal-group:2;-webkit-order:1;order:1}rtl2-fab-speed-dial.rtl2-left .rtl2-fab-speed-dial-container rtl2-fab-actions .rtl2-fab-action-item{margin-right:10px}rtl2-fab-speed-dial.rtl2-left .rtl2-fab-speed-dial-container rtl2-fab-actions button{font-size:revert;line-height:revert;font-family:revert}rtl2-fab-speed-dial.rtl2-right .rtl2-fab-speed-dial-container{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row}rtl2-fab-speed-dial.rtl2-right .rtl2-fab-speed-dial-container rtl2-fab-trigger{-webkit-box-ordinal-group:2;-webkit-order:1;order:1}rtl2-fab-speed-dial.rtl2-right .rtl2-fab-speed-dial-container rtl2-fab-actions{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;flex-direction:row;-webkit-box-ordinal-group:3;-webkit-order:2;order:2}rtl2-fab-speed-dial.rtl2-right .rtl2-fab-speed-dial-container rtl2-fab-actions .rtl2-fab-action-item{margin-left:10px}rtl2-fab-speed-dial.rtl2-right .rtl2-fab-speed-dial-container rtl2-fab-actions button{font-size:revert;line-height:revert;font-family:revert}rtl2-fab-speed-dial:not(.rtl2-opened) rtl2-fab-actions{max-height:0}\n"],
        encapsulation: 2
      });
    }
  }
  return Rtl2FabSpeedDialComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const COMPONENTS = [Rtl2FabSpeedDialComponent, Rtl2FabSpeedDialActionsComponent, Rtl2FabSpeedDialTriggerComponent];
let Rtl2FabSpeedDialModule = /*#__PURE__*/(() => {
  class Rtl2FabSpeedDialModule {
    static {
      this.ɵfac = function Rtl2FabSpeedDialModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2FabSpeedDialModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2FabSpeedDialModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return Rtl2FabSpeedDialModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Rtl2FileSelectService {}
/**
 * This service is just a placeholder that does nothing, inject your own service for server communication
 */
let FakeUploadService = /*#__PURE__*/(() => {
  class FakeUploadService extends Rtl2FileSelectService {
    upload(file) {
      console.log('File selected ', file.name);
      return of(file.name);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵFakeUploadService_BaseFactory;
        return function FakeUploadService_Factory(__ngFactoryType__) {
          return (ɵFakeUploadService_BaseFactory || (ɵFakeUploadService_BaseFactory = i0.ɵɵgetInheritedFactory(FakeUploadService)))(__ngFactoryType__ || FakeUploadService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FakeUploadService,
        factory: FakeUploadService.ɵfac
      });
    }
  }
  return FakeUploadService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2FileDropDirective = /*#__PURE__*/(() => {
  class Rtl2FileDropDirective {
    constructor(uploadWorker) {
      this.uploadWorker = uploadWorker;
      this.disableUpload = false;
      this.fileOver = new EventEmitter();
      this.onFileDrop = new EventEmitter();
    }
    onDragOver(event) {
      const transfer = this.getDataTransfer(event);
      if (!this.dragContainsFiles(transfer.types)) {
        return;
      }
      transfer.dropEffect = 'copy';
      this.preventAndStop(event);
      this.fileOver.emit(true);
    }
    onDragLeave(event) {
      // CHeck if leave event originates from inside this directive element
      if (this.element) {
        if (event.currentTarget === this.element[0]) {
          return;
        }
      }
      this.preventAndStop(event);
      this.fileOver.emit(false);
    }
    onDrop(event) {
      const transferData = this.getDataTransfer(event);
      if (!transferData) {
        return;
      }
      this.preventAndStop(event);
      if (!this.disableUpload) {
        this.uploadWorker.upload(transferData.files);
      }
      this.fileOver.emit(false);
      this.onFileDrop.emit(transferData.files);
    }
    getDataTransfer(event) {
      return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
    }
    dragContainsFiles(types) {
      if (!types) {
        return false;
      }
      if (types.indexOf) {
        return types.indexOf('Files') !== -1;
      } else if (types.contains) {
        return types.contains('Files');
      } else {
        return false;
      }
    }
    preventAndStop(event) {
      event.preventDefault();
      event.stopPropagation();
    }
    static {
      this.ɵfac = function Rtl2FileDropDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2FileDropDirective)(i0.ɵɵdirectiveInject(Rtl2FileSelectService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: Rtl2FileDropDirective,
        selectors: [["", "rtl2FileSelectDrop", ""]],
        hostBindings: function Rtl2FileDropDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("dragover", function Rtl2FileDropDirective_dragover_HostBindingHandler($event) {
              return ctx.onDragOver($event);
            })("dragleave", function Rtl2FileDropDirective_dragleave_HostBindingHandler($event) {
              return ctx.onDragLeave($event);
            })("drop", function Rtl2FileDropDirective_drop_HostBindingHandler($event) {
              return ctx.onDrop($event);
            });
          }
        },
        inputs: {
          disableUpload: "disableUpload"
        },
        outputs: {
          fileOver: "fileOver",
          onFileDrop: "onFileDrop"
        }
      });
    }
  }
  return Rtl2FileDropDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2FileSelectDirective = /*#__PURE__*/(() => {
  class Rtl2FileSelectDirective {
    constructor(element, uploadWorker) {
      this.uploadWorker = uploadWorker;
      this.onFileSelected = new EventEmitter();
      this.element = element;
    }
    isEmptyAfterSelection() {
      return !!this.element.nativeElement.attributes.multiple;
    }
    onChange() {
      const files = this.element.nativeElement.files;
      this.uploadWorker.upload(files);
      this.onFileSelected.emit(files);
      if (this.isEmptyAfterSelection()) {
        this.element.nativeElement.value = '';
      }
    }
    static {
      this.ɵfac = function Rtl2FileSelectDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2FileSelectDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(Rtl2FileSelectService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: Rtl2FileSelectDirective,
        selectors: [["", "rtl2FileSelect", ""]],
        hostBindings: function Rtl2FileSelectDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("change", function Rtl2FileSelectDirective_change_HostBindingHandler() {
              return ctx.onChange();
            });
          }
        },
        outputs: {
          onFileSelected: "onFileSelected"
        }
      });
    }
  }
  return Rtl2FileSelectDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2FileSelectModule = /*#__PURE__*/(() => {
  class Rtl2FileSelectModule {
    static forRoot(config = {}) {
      return {
        ngModule: Rtl2FileSelectModule,
        providers: [config.uploadService || {
          provide: Rtl2FileSelectService,
          useClass: FakeUploadService
        }]
      };
    }
    static {
      this.ɵfac = function Rtl2FileSelectModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2FileSelectModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2FileSelectModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return Rtl2FileSelectModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * IdName autocomplete component
 *
 * Example:
 * ```html
 *  <form [formGroup]="basicForm">
 *    <mat-form-field>
 *      <rtl2-id-name-autocomplete
 *        formGroupName="test"
 *        placeholder="Enter keyword"
 *        (query)="filterData($event)"
 *        [options]="results | slice:0:14"
 *        ></rtl2-id-name-autocomplete>
 *    </mat-form-field>
 *  </form>
 * ```
 * ```typescript
 * basicForm: FormGroup;
 * public results: Rtl2IdName[];
 * private data: Rtl2IdName[];
 *
 * constructor() {
 *  this.basicForm = new FormGroup({test: new FormControl(null)});
 *  this.results = this.data = ('enthusiastically brand error-free innovation vis-a-vis business ' +
 *    'web services dramatically morph ethical niches for low-risk high-yield methodologies interactively ' +
 *    'matrix accurate convergence rather than accurate services professionally orchestrate ' +
 *    'client-centric results without cross-platform scenarios efficiently communicate synergistic ' +
 *    'technologies and e-business channels seamlessly extend fully researched methodologies via ' +
 *    'multimedia based convergence continually optimize excellent e-services whereas end-to-end ' +
 *    'vortals assertively evolve sustainable value through enterprise-wide potentialities ' +
 *    'collaboratively plagiarize collaborative vortals via human capital proactively envisioneer ' +
 *    'superior convergence before superior technology').split(' ')
 *      .map(v => <Rtl2IdName>{
 *      id: Math.floor(Math.random() * 10000) + 1,
 *      name: v
 *    });
 * }
 *
 * filterData(q: string) {
 *  this.results = this.data.filter(s => s.name.includes(q));
 * }
 * ```
 */
let Rtl2IdNameAutocompleteComponent = /*#__PURE__*/(() => {
  class Rtl2IdNameAutocompleteComponent {
    static {
      this.nextId = 0;
    }
    get empty() {
      const {
        value: {
          id,
          name
        }
      } = this.baseForm;
      return id == null;
    }
    filter(query) {
      this.query.emit(query);
    }
    focus(event) {}
    get errorState() {
      return this._formGroup.invalid;
    }
    get shouldLabelFloat() {
      return this.focused || !this.empty;
    }
    get placeholder() {
      return this._placeholder;
    }
    set placeholder(value) {
      this._placeholder = value;
      this.stateChanges.next();
    }
    get required() {
      return this._required;
    }
    set required(value) {
      this._required = coerceBooleanProperty(value);
      this.stateChanges.next();
    }
    get disabled() {
      return this._disabled;
    }
    set disabled(value) {
      this._disabled = coerceBooleanProperty(value);
      this._disabled ? this.inputCtrl.disable() : this.inputCtrl.enable();
      this.stateChanges.next();
      if (this.focused) {
        this.focused = false;
        this.stateChanges.next();
      }
    }
    get value() {
      const {
        value: {
          id,
          name
        }
      } = this.baseForm;
      return {
        id,
        name
      };
    }
    set value(val) {
      const {
        id,
        name
      } = val || new Rtl2IdName();
      this.baseForm.setValue({
        id,
        name
      });
      this.stateChanges.next();
      if (this._formGroup.value?.id !== id) {
        this._formGroup.control.setValue({
          id,
          name
        });
      }
    }
    get options() {
      // Default to currently selected value when no options is available
      // return this._options.length ? this._options : [this.baseForm.value];
      return this._options;
    }
    set options(value) {
      this._options = [...(value || [])];
      this.stateChanges.next();
    }
    constructor(formBuilder, _focusMonitor, _elementRef, _formGroup, _parentFormGroup, _parentForm, _parentFormField, ngControl) {
      this._focusMonitor = _focusMonitor;
      this._elementRef = _elementRef;
      this._formGroup = _formGroup;
      this._parentFormGroup = _parentFormGroup;
      this._parentForm = _parentForm;
      this._parentFormField = _parentFormField;
      this.ngControl = ngControl;
      this.stateChanges = new Subject();
      this.focused = false;
      this.id = `id-name-autocomplete-input-${Rtl2IdNameAutocompleteComponent.nextId++}`;
      this.describedBy = '';
      this.inputCtrl = new FormControl('');
      this._required = false;
      this._disabled = false;
      this.query = new EventEmitter();
      this.optionsDisplayResolver = val => val;
      if (this.ngControl) {
        // Note: we provide the value accessor through here, instead of
        // the `providers` to avoid running into a circular import.
        this.ngControl.valueAccessor = this;
      }
      this.baseForm = formBuilder.group({
        id: null,
        name: null
      });
      this.setupFocusMonitor();
    }
    ngOnInit() {
      this._formGroup.valueChanges.pipe(takeUntil(this.stateChanges.pipe(last()))).subscribe(() => {
        const test = this._formGroup.value;
        const validFormGroup = test.hasOwnProperty('id') && test.hasOwnProperty('name');
        if (!validFormGroup) {
          console.error('ERROR | Rtl2 ID name autocomplete component', 'color: white; background-color: red; padding: 2px 5px', '\n', 'instance of value is not Rtl2IdName');
          return;
        }
        this.value = this._formGroup.value;
        this.disabled = this._formGroup.disabled;
        this.inputCtrl.setValue(this.value.id != null ? this.value.name : null);
      });
      this.disabled = this._formGroup.disabled;
      this.inputCtrl.valueChanges.pipe(takeUntil(this.stateChanges.pipe(last()))).subscribe(val => {
        this.query.emit(val);
      });
      this.inputCtrl.setValue(this.value.id != null ? this.value.name : '');
    }
    select(selectionEvent) {
      this.writeValue(selectionEvent.source.value);
    }
    onChange(_) {}
    onTouched() {}
    getDisplayFn() {
      return val => this.display(val);
    }
    display(option) {
      return this.value.name;
    }
    ngOnDestroy() {
      this.stateChanges.complete();
      this._focusMonitor.stopMonitoring(this._elementRef);
    }
    setDescribedByIds(ids) {
      this.describedBy = ids.join(' ');
    }
    onContainerClick(event) {
      // TODO: FW click to select?
    }
    writeValue(val) {
      this.value = val;
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    _handleInput() {
      this.onChange(this.baseForm.value);
    }
    setupFocusMonitor() {
      this._focusMonitor.monitor(this._elementRef, true).subscribe(origin => {
        // When the field is disabled, skip focus events
        if (this.disabled) {
          this.focused = false;
          return;
        }
        if (this.focused && !origin) {
          this.onTouched();
        }
        this.focused = !!origin;
        this.stateChanges.next();
      });
    }
    static {
      this.ɵfac = function Rtl2IdNameAutocompleteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2IdNameAutocompleteComponent)(i0.ɵɵdirectiveInject(i1$2.FormBuilder), i0.ɵɵdirectiveInject(i2$2.FocusMonitor), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$2.ControlContainer, 9), i0.ɵɵdirectiveInject(i1$2.FormGroupDirective, 8), i0.ɵɵdirectiveInject(i1$2.NgForm, 8), i0.ɵɵdirectiveInject(i3$2.MatFormField, 8), i0.ɵɵdirectiveInject(i1$2.NgControl, 10));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2IdNameAutocompleteComponent,
        selectors: [["rtl2-id-name-autocomplete"]],
        inputs: {
          placeholder: "placeholder",
          required: "required",
          disabled: "disabled",
          value: "value",
          optionsDisplayResolver: "optionsDisplayResolver",
          options: "options"
        },
        outputs: {
          query: "query"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: MatFormFieldControl,
          useExisting: Rtl2IdNameAutocompleteComponent
        }])],
        decls: 6,
        vars: 8,
        consts: [["auto", "matAutocomplete"], ["results", ""], ["matInput", "", "type", "text", 3, "placeholder", "matAutocomplete", "formControl"], [3, "displayWith"], ["class", "is-loading", 3, "disabled", 4, "ngIf", "ngIfElse"], [1, "is-loading", 3, "disabled"], [1, "mb-0"], [3, "value", "innerHtml", "onSelectionChange", 4, "ngFor", "ngForOf"], [3, "onSelectionChange", "value", "innerHtml"]],
        template: function Rtl2IdNameAutocompleteComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "input", 2);
            i0.ɵɵelementStart(1, "mat-autocomplete", 3, 0);
            i0.ɵɵtemplate(3, Rtl2IdNameAutocompleteComponent_mat_option_3_Template, 3, 1, "mat-option", 4)(4, Rtl2IdNameAutocompleteComponent_ng_template_4_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const auto_r4 = i0.ɵɵreference(2);
            const results_r5 = i0.ɵɵreference(5);
            i0.ɵɵclassProp("read", ctx.disabled);
            i0.ɵɵproperty("placeholder", ctx.placeholder)("matAutocomplete", auto_r4)("formControl", ctx.inputCtrl);
            i0.ɵɵadvance();
            i0.ɵɵproperty("displayWith", ctx.getDisplayFn());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.options.length === 0)("ngIfElse", results_r5);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.FormControlDirective, i6.MatAutocomplete, i6$1.MatOption, i6.MatAutocompleteTrigger, i7.MatInput],
        styles: ["span[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.floating[_nghost-%COMP%]   span[_ngcontent-%COMP%]{opacity:1}.is-loading[_ngcontent-%COMP%]     .mat-mdc-option-text{display:flex;justify-content:center;align-items:center}.read[_ngcontent-%COMP%]{color:#000!important}"]
      });
    }
  }
  return Rtl2IdNameAutocompleteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2IdNameAutocompleteModule = /*#__PURE__*/(() => {
  class Rtl2IdNameAutocompleteModule {
    static {
      this.ɵfac = function Rtl2IdNameAutocompleteModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2IdNameAutocompleteModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2IdNameAutocompleteModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, MatAutocompleteModule, MatFormFieldModule, MatInputModule]
      });
    }
  }
  return Rtl2IdNameAutocompleteModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * IdName selector component
 *
 * Example:
 * ```html
 * <form [formGroup]="basicForm">
 *   <mat-form-field>
 *     <rtl2-id-name-select
 *       formGroupName="test"
 *       placeholder="Enter keyword"
 *       [options]="data"
 *       ></rtl2-id-name-select>
 *   </mat-form-field>
 * </form>
 * ```
 *
 * ```typescript
 * basicForm: FormGroup;
 * data: Rtl2IdName[];
 *
 * constructor() {
 *  this.basicForm = new FormGroup({test: new FormControl(null)});
 *  this.data = ('continually optimize excellent e-services whereas end-to-end ' +
 *    'vortals assertively evolve sustainable value through enterprise-wide potentialities ' +
 *    'collaboratively plagiarize collaborative vortals via human capital proactively envisioneer ' +
 *    'superior convergence before superior technology').split(' ')
 *    .map(v => <Rtl2IdName>{
 *      id: Math.floor(Math.random() * 10000) + 1,
 *      name: v
 *    });
 * }
 * ```
 */
let Rtl2IdNameSelectComponent = /*#__PURE__*/(() => {
  class Rtl2IdNameSelectComponent {
    static {
      this.nextId = 0;
    }
    get empty() {
      const {
        value: {
          id,
          name
        }
      } = this.baseForm;
      return id == null;
    }
    get errorState() {
      return this._formGroup.invalid;
    }
    get shouldLabelFloat() {
      return this.focused || !this.empty;
    }
    get placeholder() {
      return this._placeholder;
    }
    set placeholder(value) {
      this._placeholder = value;
      this.stateChanges.next();
    }
    get required() {
      return this._required;
    }
    set required(value) {
      this._required = coerceBooleanProperty(value);
      this.stateChanges.next();
    }
    get disabled() {
      return this._disabled;
    }
    set disabled(value) {
      this._disabled = coerceBooleanProperty(value);
      this._disabled ? this.baseForm.disable() : this.baseForm.enable();
      this.stateChanges.next();
      if (this.focused) {
        this.focused = false;
        this.stateChanges.next();
      }
    }
    get value() {
      const {
        value: {
          id,
          name
        }
      } = this.baseForm;
      return {
        id,
        name
      };
    }
    set value(val) {
      const {
        id,
        name
      } = val || new Rtl2IdName();
      this.baseForm.setValue({
        id,
        name
      });
      this.stateChanges.next();
      if (this._formGroup.value?.id !== id) {
        this._formGroup.control.setValue({
          id,
          name
        });
      }
    }
    get options() {
      // Default to currently selected value when no options is available
      return this._options.length ? this._options : [this.baseForm.value];
    }
    set options(value) {
      this._options = [...(value || [])];
      this.stateChanges.next();
    }
    constructor(formBuilder, _focusMonitor, _elementRef, _formGroup, _parentFormGroup, _parentForm, _parentFormField, ngControl) {
      this._focusMonitor = _focusMonitor;
      this._elementRef = _elementRef;
      this._formGroup = _formGroup;
      this._parentFormGroup = _parentFormGroup;
      this._parentForm = _parentForm;
      this._parentFormField = _parentFormField;
      this.ngControl = ngControl;
      this.stateChanges = new Subject();
      this.focused = false;
      this.id = `id-name-select-input-${Rtl2IdNameSelectComponent.nextId++}`;
      this.describedBy = '';
      this._required = false;
      this._disabled = false;
      if (this.ngControl) {
        // Note: we provide the value accessor through here, instead of
        // the `providers` to avoid running into a circular import.
        this.ngControl.valueAccessor = this;
      }
      this.baseForm = formBuilder.group({
        id: null,
        name: null
      });
      this.setupFocusMonitor();
    }
    ngOnInit() {
      this.disabled = this._formGroup.disabled;
      this._formGroup.valueChanges.pipe(takeUntil(this.stateChanges.pipe(last()))).subscribe(() => {
        const test = this._formGroup.value;
        const validFormGroup = test.hasOwnProperty('id') && test.hasOwnProperty('name');
        if (!validFormGroup) {
          console.error('ERROR | Rtl2 ID name select component', 'color: white; background-color: red; padding: 2px 5px', '\n', 'instance of value is not Rtl2IdName');
          return;
        }
        this.value = this._formGroup.value;
        this.disabled = this._formGroup.disabled;
      });
    }
    onChange(_) {}
    onTouched() {}
    onSelectionChange(event) {
      this.value = this.options.find(o => o.id === event.value);
    }
    ngOnDestroy() {
      this.stateChanges.complete();
      this._focusMonitor.stopMonitoring(this._elementRef);
    }
    setDescribedByIds(ids) {
      this.describedBy = ids.join(' ');
    }
    onContainerClick(event) {
      // TODO: FW click to select?
    }
    writeValue(tel) {
      this.value = tel;
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    _handleInput() {
      this.onChange(this.baseForm.value);
    }
    setupFocusMonitor() {
      this._focusMonitor.monitor(this._elementRef, true).subscribe(origin => {
        // When the field is disabled, skip focus events
        if (this.disabled) {
          this.focused = false;
          return;
        }
        if (this.focused && !origin) {
          this.onTouched();
        }
        this.focused = !!origin;
        this.stateChanges.next();
      });
    }
    static {
      this.ɵfac = function Rtl2IdNameSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2IdNameSelectComponent)(i0.ɵɵdirectiveInject(i1$2.FormBuilder), i0.ɵɵdirectiveInject(i2$2.FocusMonitor), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$2.ControlContainer, 9), i0.ɵɵdirectiveInject(i1$2.FormGroupDirective, 8), i0.ɵɵdirectiveInject(i1$2.NgForm, 8), i0.ɵɵdirectiveInject(i3$2.MatFormField, 8), i0.ɵɵdirectiveInject(i1$2.NgControl, 10));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2IdNameSelectComponent,
        selectors: [["rtl2-id-name-select"]],
        inputs: {
          placeholder: "placeholder",
          required: "required",
          disabled: "disabled",
          value: "value",
          options: "options"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: MatFormFieldControl,
          useExisting: Rtl2IdNameSelectComponent
        }])],
        decls: 2,
        vars: 3,
        consts: [[3, "selectionChange", "value", "disabled"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]],
        template: function Rtl2IdNameSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-select", 0);
            i0.ɵɵlistener("selectionChange", function Rtl2IdNameSelectComponent_Template_mat_select_selectionChange_0_listener($event) {
              return ctx.onSelectionChange($event);
            });
            i0.ɵɵtemplate(1, Rtl2IdNameSelectComponent_mat_option_1_Template, 2, 2, "mat-option", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("value", ctx.baseForm.value.id)("disabled", ctx.disabled);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.options);
          }
        },
        dependencies: [i2.NgForOf, i5$1.MatSelect, i6$1.MatOption]
      });
    }
  }
  return Rtl2IdNameSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2IdNameSelectModule = /*#__PURE__*/(() => {
  class Rtl2IdNameSelectModule {
    static {
      this.ɵfac = function Rtl2IdNameSelectModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2IdNameSelectModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2IdNameSelectModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, MatSelectModule, MatFormFieldModule]
      });
    }
  }
  return Rtl2IdNameSelectModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Iframe modal functionality for custom dialogs
 *
 * Example:
 * ```html
 * <button mat-raised-button
 *   class="mr-2"
 *   (click)="callModalView('image')" color="accent">
 *   Open image select modal</button>
 * <button mat-raised-button
 *   class="mr-2"
 *   (click)="callModalView('video')"
 *   color="accent">Open video select modal</button>
 * <button mat-raised-button
 *   class="mr-2"
 *   (click)="callModalView('playlist')"
 *   color="accent">Open playlist select modal</button>
 * <button mat-raised-button
 *   (click)="callModalView('star-portrait-edit')"
 *   color="accent">Open star-portrait edit modal</button>
 *
 * <rtl2-iframe-modal [iFrameUrl]="url"></rtl2-iframe-modal>
 * ```
 *
 * ```typescript
 * private path = {
 *  modalImage: 'iframe/select', // modal path
 *  modalPlaylist: 'iframe/modal', // modal path
 *  modalVideo: '?modal=true', // modal path
 *  modalStarEdit: 'iframe/modal', // modal path
 *  queryImage: '?singleSelect=true&details=true', // example
 *  queryStar: '/3', // example
 * };
 * url = '';
 *
 * constructor(
 *   private dialog: MatDialog,
 *   private environment: Rtl2EnvironmentService,
 *   private note: Rtl2NotificationService
 * ) {
 *    this.url = `${this.environment.get('urlImageManagement')}${this.path['modalImage']}${this.path['queryImage']}`;
 * }
 *
 * public callModalView(type) {
 *  let url: string;
 *  switch (type) {
 *    case 'video':
 *      url = `${this.environment.get('urlVideoManagement')}${this.path['modalVideo']}`;
 *      break;
 *    case 'playlist':
 *      url = `${this.environment.get('urlVideoPlaylist')}${this.path['modalPlaylist']}`;
 *      break;
 *    case 'star-portrait-edit':
 *      url = `${this.environment.get('urlStarPortraits')}${this.path['modalStarEdit']}${this.path['queryStar']}`;
 *      break;
 *    default:
 *      url = `${this.environment.get('urlImageManagement')}${this.path['modalImage']}`;
 *      break;
 *  }
 *  const dialogRef = this.dialog.open(Rtl2IframeModalComponent, {
 *    height: '90%',
 *    width: '80%'
 *  });
 *  dialogRef.componentInstance.iFrameUrl = url;
 *  const subscription = dialogRef.componentInstance.iFrameResponse.subscribe(value => {
 *    this.note.callDialog({
 *        title: 'Modal response',
 *        message: `Review response object of ${type} modal`,
 *      details: value,
 *      close: 'Close'
 *    });
 *    dialogRef.close();
 *  });
 *
 *  dialogRef.afterClosed().subscribe(() => {
 *    subscription.unsubscribe();
 *  });
 * }
 * ```
 */
let Rtl2IframeModalComponent = /*#__PURE__*/(() => {
  class Rtl2IframeModalComponent {
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
      this.iFrameResponse = new EventEmitter();
    }
    ngOnInit() {
      this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.iFrameUrl);
    }
    onMessage(e) {
      if (!Rtl2Util.objectPropertyValue(e, 'data.origin')) {
        return false;
      }
      this.iFrameResponse.next(e.data);
      return true;
    }
    static {
      this.ɵfac = function Rtl2IframeModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2IframeModalComponent)(i0.ɵɵdirectiveInject(i1$1.DomSanitizer));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2IframeModalComponent,
        selectors: [["rtl2-iframe-modal"]],
        viewQuery: function Rtl2IframeModalComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c11, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.iFrameElement = _t.first);
          }
        },
        hostBindings: function Rtl2IframeModalComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("message", function Rtl2IframeModalComponent_message_HostBindingHandler($event) {
              return ctx.onMessage($event);
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          iFrameUrl: "iFrameUrl"
        },
        outputs: {
          iFrameResponse: "iFrameResponse"
        },
        decls: 3,
        vars: 1,
        consts: [["iframe", ""], [1, "iframe-wrapper"], ["width", "100%", "height", "100%", 3, "src"]],
        template: function Rtl2IframeModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵelement(1, "iframe", 2, 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("src", ctx.sanitizedUrl, i0.ɵɵsanitizeResourceUrl);
          }
        },
        styles: [".iframe-wrapper{display:block;position:relative;height:100%}iframe{position:absolute;inset:0;border:0}\n"],
        encapsulation: 2
      });
    }
  }
  return Rtl2IframeModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2IframeModalModule = /*#__PURE__*/(() => {
  class Rtl2IframeModalModule {
    static {
      this.ɵfac = function Rtl2IframeModalModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2IframeModalModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2IframeModalModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return Rtl2IframeModalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Rtl2ImageCarouselInput {
  constructor(init) {
    this.imageRightMargin = 2;
    Object.assign(this, init);
  }
}
let Rtl2ImageCarouselThumbnailComponent = /*#__PURE__*/(() => {
  class Rtl2ImageCarouselThumbnailComponent {
    constructor(element, renderer) {
      this.element = element;
      this.renderer = renderer;
      this.noError = true;
      this.iconSize = 32;
    }
    get height() {
      return this.element?.nativeElement?.offsetHeight || 0;
    }
    get width() {
      return this.element?.nativeElement?.offsetWidth || 0;
    }
    imageLoaded(image) {
      if (this.height === 0) return;
      this.setImageDisplayDimensions(image);
    }
    setImageDisplayDimensions(image) {
      const s = image.height >= image.width;
      this.renderer.setStyle(image, 'width', s ? `${this.width}px` : 'auto');
      this.renderer.setStyle(image, 'height', s ? 'auto' : `${this.height}px`);
    }
    setError() {
      this.noError = false;
      const s = Math.round((this.width > this.height ? this.height : this.width) / 0.75);
      this.iconSize = s > 64 ? 64 : s;
    }
    static {
      this.ɵfac = function Rtl2ImageCarouselThumbnailComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ImageCarouselThumbnailComponent)(i0.ɵɵdirectiveInject(i0.ElementRef, 2), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2ImageCarouselThumbnailComponent,
        selectors: [["rtl2-image-carousel-thumbnail"]],
        inputs: {
          url: "url"
        },
        decls: 2,
        vars: 2,
        consts: [["image", ""], [3, "src", "load", "error", 4, "ngIf"], ["color", "primary", 3, "width", "height", "font-size", 4, "ngIf"], [3, "load", "error", "src"], ["color", "primary"]],
        template: function Rtl2ImageCarouselThumbnailComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, Rtl2ImageCarouselThumbnailComponent_img_0_Template, 2, 1, "img", 1)(1, Rtl2ImageCarouselThumbnailComponent_mat_icon_1_Template, 2, 6, "mat-icon", 2);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.noError);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.noError);
          }
        },
        dependencies: [i2.NgIf, i2$3.MatIcon],
        styles: ["[_nghost-%COMP%]{overflow:hidden;display:block;position:relative}[_nghost-%COMP%] > *[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}"]
      });
    }
  }
  return Rtl2ImageCarouselThumbnailComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2ImageCarouselContainerComponent = /*#__PURE__*/(() => {
  class Rtl2ImageCarouselContainerComponent {
    set inputElements(ie) {
      this.displayElements = ie;
    }
    set highlightedElements(list) {
      this.highlighted = list;
    }
    constructor(element) {
      this.element = element;
      this.startReached = new EventEmitter();
      this.endReached = new EventEmitter();
      this.imageAndElementSelected = new EventEmitter();
      this.imageAndElementHoverEnter = new EventEmitter();
      this.imageAndElementHoverLeave = new EventEmitter();
      this.scrollWatcher = new Subject();
      this.debounceTime = 100;
      this.selected = null;
      this.displayElements = [];
      this.highlighted = null;
      this.showButtonLeft = false;
      this.showButtonRight = true;
      this.destroy$ = new Subject();
      this.scrollLeft = 0;
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    ngAfterViewInit() {
      this.scrollbar.scrolled.pipe(takeUntil$1(this.destroy$), debounceTime(this.debounceTime), map$1(e => e?.target), filter(t => !!t), tap(t => {
        if (this.scrollLeft < t.scrollLeft) this.showButtonLeft = true;
        if (this.scrollLeft > t.scrollLeft) this.showButtonRight = true;
        this.scrollLeft = t.scrollLeft;
      })).subscribe();
    }
    ngOnInit() {
      this.scrollWatcher.pipe(takeUntil$1(this.destroy$), debounceTime(this.debounceTime), filter(v => !!v), tap(delta => {
        if (delta < 0) this.navigateLeft();
        if (delta > 0) this.navigateRight();
      })).subscribe();
    }
    get parentHeight() {
      return this.element.nativeElement.parentNode.offsetHeight;
    }
    onReachStart(event) {
      this.showButtonLeft = false;
      this.startReached.emit(event);
    }
    onReachEnd(event) {
      this.showButtonRight = false;
      this.endReached.emit(event);
    }
    onScrollWheel(event) {
      if (!event?.deltaY) return;
      this.scrollWatcher.next(event.deltaY);
    }
    navigateRight() {
      const next = this.element?.nativeElement?.querySelector('.rtl2-visible')?.nextSibling;
      const offset = next?.offsetLeft || this.scrollbar.viewport.scrollMaxX;
      this.scrollbar.scrollTo({
        left: offset,
        duration: this.scrollbar.trackClickScrollDuration
      });
    }
    navigateLeft() {
      const previous = this.element?.nativeElement?.querySelector('.rtl2-visible')?.previousSibling;
      const offset = previous?.offsetLeft || 0;
      this.scrollbar.scrollTo({
        left: offset,
        duration: this.scrollbar.trackClickScrollDuration
      });
    }
    triggerEmmiterForElementAndInputClick(inputElement, imgCrslTmbn) {
      this.selected = inputElement;
      this.imageAndElementSelected.emit({
        input: inputElement,
        element: imgCrslTmbn
      });
    }
    triggerEmmiterForElementAndInputMouseEnter(inputElement, imgCrslTmbn) {
      this.imageAndElementHoverEnter.emit({
        input: inputElement,
        element: imgCrslTmbn
      });
    }
    triggerEmmiterForElementAndInputMouseLeave(inputElement, imgCrslTmbn) {
      this.imageAndElementHoverLeave.emit({
        input: inputElement,
        element: imgCrslTmbn
      });
    }
    isSelected(inputElement) {
      return !!this.selected && this.selected.url === inputElement.url;
    }
    isHighlighted(inputElement) {
      return !!this.highlighted?.filter(v => v.url === inputElement.url)?.length;
    }
    static {
      this.ɵfac = function Rtl2ImageCarouselContainerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ImageCarouselContainerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef, 2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2ImageCarouselContainerComponent,
        selectors: [["rtl2-image-carousel-container"]],
        viewQuery: function Rtl2ImageCarouselContainerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(NgScrollbar, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollbar = _t.first);
          }
        },
        inputs: {
          inputElements: "inputElements",
          highlightedElements: "highlightedElements"
        },
        outputs: {
          startReached: "startReached",
          endReached: "endReached",
          imageAndElementSelected: "imageAndElementSelected",
          imageAndElementHoverEnter: "imageAndElementHoverEnter",
          imageAndElementHoverLeave: "imageAndElementHoverLeave"
        },
        decls: 4,
        vars: 4,
        consts: [["imgCrslTmbn", ""], ["mat-mini-fab", "", "color", "primary", "class", "button-navigation button-left", 3, "click", 4, "ngIf"], ["reachedOffset", "1", 1, "w-100", 3, "reachedStart", "reachedEnd", "wheel", "track"], ["rtl2TrackVisibility", "", 3, "url", "min-width", "min-height", "margin-right", "is-selected", "is-highlighted", "click", "mouseenter", "mouseleave", 4, "ngFor", "ngForOf"], ["mat-mini-fab", "", "color", "primary", "class", "button-navigation button-right", 3, "click", 4, "ngIf"], ["mat-mini-fab", "", "color", "primary", 1, "button-navigation", "button-left", 3, "click"], ["rtl2TrackVisibility", "", 3, "click", "mouseenter", "mouseleave", "url"], ["mat-mini-fab", "", "color", "primary", 1, "button-navigation", "button-right", 3, "click"]],
        template: function Rtl2ImageCarouselContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, Rtl2ImageCarouselContainerComponent_button_0_Template, 3, 0, "button", 1);
            i0.ɵɵelementStart(1, "ng-scrollbar", 2);
            i0.ɵɵlistener("reachedStart", function Rtl2ImageCarouselContainerComponent_Template_ng_scrollbar_reachedStart_1_listener($event) {
              return ctx.onReachStart($event);
            })("reachedEnd", function Rtl2ImageCarouselContainerComponent_Template_ng_scrollbar_reachedEnd_1_listener($event) {
              return ctx.onReachEnd($event);
            })("wheel", function Rtl2ImageCarouselContainerComponent_Template_ng_scrollbar_wheel_1_listener($event) {
              return ctx.onScrollWheel($event);
            });
            i0.ɵɵtemplate(2, Rtl2ImageCarouselContainerComponent_rtl2_image_carousel_thumbnail_2_Template, 2, 11, "rtl2-image-carousel-thumbnail", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, Rtl2ImageCarouselContainerComponent_button_3_Template, 3, 0, "button", 4);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.showButtonLeft);
            i0.ɵɵadvance();
            i0.ɵɵproperty("track", "horizontal");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.displayElements);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showButtonRight);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i2$3.MatIcon, i3$1.MatMiniFabButton, i5.NgScrollbar, i5$2.NgScrollbarReachedStart, i5$2.NgScrollbarReachedEnd, Rtl2TrackVisibilityDirective, Rtl2ImageCarouselThumbnailComponent],
        styles: ["[_nghost-%COMP%]{position:relative}[_nghost-%COMP%]     .ng-scroll-content{display:flex}.button-navigation[_ngcontent-%COMP%]{position:absolute;top:50%;transform:translateY(-50%);z-index:2}.button-right[_ngcontent-%COMP%]{right:10px}.button-left[_ngcontent-%COMP%]{left:10px}rtl2-image-carousel-thumbnail[_ngcontent-%COMP%]:last-child{margin-right:0!important}"]
      });
    }
  }
  return Rtl2ImageCarouselContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Image carousel functionality
 *
 * Example:
 * ```html
 * <rtl2-image-carousel
 *   [height]="300"
 *   [images]="images300"></rtl2-image-carousel>
 * ```
 *
 * ```typescript
 * public images300: Rtl2ImageCarouselInput[];
 *
 * constructor() {
 *  this.images300 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
 *    .map(i => {
 *      const min = 150;
 *      const max = 500;
 *      const random = Math.floor(Math.random() * (max - min + 1)) + min;
 *      return `https://source.unsplash.com/${random}x300`;
 *    })
 *    .map(url => new Rtl2ImageCarouselInput({url: url}));
 * }
 * ```
 */
let Rtl2ImageCarouselComponent = /*#__PURE__*/(() => {
  class Rtl2ImageCarouselComponent {
    set images(urls) {
      this.imageList = [...urls];
    }
    set highlighted(urls) {
      this.highlightedList = [...urls];
    }
    constructor() {
      this.height = 100;
      this.imageList = [];
      this.highlightedList = [];
      this.endReached = new EventEmitter();
      this.startReached = new EventEmitter();
      this.imageSelected = new EventEmitter();
      this.elementSelected = new EventEmitter();
      this.imageMouseEnter = new EventEmitter();
      this.elementMouseEnter = new EventEmitter();
      this.imageMouseLeave = new EventEmitter();
      this.elementMouseLeave = new EventEmitter();
    }
    emitImageAndElementSelected(event) {
      const input = event.input;
      this.imageSelected.emit(input.url);
      const element = event.element;
      this.elementSelected.emit(element);
    }
    emitImageAndElementHoverEnter(event) {
      const input = event.input;
      this.imageMouseEnter.emit(input.url);
      const element = event.element;
      this.elementMouseEnter.emit(element);
    }
    emitImageAndElementHoverLeave(event) {
      const input = event.input;
      this.imageMouseLeave.emit(input.url);
      const element = event.element;
      this.elementMouseLeave.emit(element);
    }
    onReachedEnd(event) {
      this.endReached.emit(event);
    }
    onReachedStart(event) {
      this.startReached.emit(event);
    }
    static {
      this.ɵfac = function Rtl2ImageCarouselComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ImageCarouselComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2ImageCarouselComponent,
        selectors: [["rtl2-image-carousel"]],
        hostVars: 2,
        hostBindings: function Rtl2ImageCarouselComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("height", ctx.height, "px");
          }
        },
        inputs: {
          height: "height",
          images: "images",
          highlighted: "highlighted"
        },
        outputs: {
          endReached: "endReached",
          startReached: "startReached",
          imageSelected: "imageSelected",
          elementSelected: "elementSelected",
          imageMouseEnter: "imageMouseEnter",
          elementMouseEnter: "elementMouseEnter",
          imageMouseLeave: "imageMouseLeave",
          elementMouseLeave: "elementMouseLeave"
        },
        decls: 1,
        vars: 2,
        consts: [[3, "imageAndElementSelected", "imageAndElementHoverEnter", "imageAndElementHoverLeave", "startReached", "endReached", "inputElements", "highlightedElements"]],
        template: function Rtl2ImageCarouselComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "rtl2-image-carousel-container", 0);
            i0.ɵɵlistener("imageAndElementSelected", function Rtl2ImageCarouselComponent_Template_rtl2_image_carousel_container_imageAndElementSelected_0_listener($event) {
              return ctx.emitImageAndElementSelected($event);
            })("imageAndElementHoverEnter", function Rtl2ImageCarouselComponent_Template_rtl2_image_carousel_container_imageAndElementHoverEnter_0_listener($event) {
              return ctx.emitImageAndElementHoverEnter($event);
            })("imageAndElementHoverLeave", function Rtl2ImageCarouselComponent_Template_rtl2_image_carousel_container_imageAndElementHoverLeave_0_listener($event) {
              return ctx.emitImageAndElementHoverLeave($event);
            })("startReached", function Rtl2ImageCarouselComponent_Template_rtl2_image_carousel_container_startReached_0_listener($event) {
              return ctx.onReachedStart($event);
            })("endReached", function Rtl2ImageCarouselComponent_Template_rtl2_image_carousel_container_endReached_0_listener($event) {
              return ctx.onReachedEnd($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("inputElements", ctx.imageList)("highlightedElements", ctx.highlightedList);
          }
        },
        dependencies: [Rtl2ImageCarouselContainerComponent],
        styles: ["[_nghost-%COMP%]{display:block;min-width:100%;overflow:hidden}"]
      });
    }
  }
  return Rtl2ImageCarouselComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2ImageCarouselModule = /*#__PURE__*/(() => {
  class Rtl2ImageCarouselModule {
    static {
      this.ɵfac = function Rtl2ImageCarouselModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ImageCarouselModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2ImageCarouselModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatIconModule, MatButtonModule, NgScrollbarModule, NgScrollbarReachedModule, Rtl2UiModule]
      });
    }
  }
  return Rtl2ImageCarouselModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Fast load image component, that gets base64 low res and image source inputs.
 * When the image takes longer to load, the transition is done with fade.
 *
 * Example:
 * ```html
 * <div *ngFor="let img of images">
 *  <rtl2-image-loader-speed
 *    fill="false"
 *    src="/assets/{{img.name}}.png"
 *    base64="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNc/x8AAmMBsFXIDN0AAAAASUVORK5CYII="
 *  ></rtl2-image-loader-speed>
 * </div>
 * ```
 */
let Rtl2ImageLoaderComponent = /*#__PURE__*/(() => {
  class Rtl2ImageLoaderComponent {
    get isCover() {
      return this.fill;
    }
    constructor(sanitizer, cdRef, containerElement) {
      this.sanitizer = sanitizer;
      this.cdRef = cdRef;
      this.containerElement = containerElement;
      /**
       * Base64 encoded string of image/jpg format used to display
       * the placeholder background while the image is being loaded
       **/
      this.base64 = '';
      /**
       * Url to the image resource
       */
      this.src = '';
      /**
       * Fill flag, if true, the component will fill parent container content with cover option
       * when false, the contain strategy will be used.
       */
      this.fill = true;
      /**
       * Load event when image is successfuly displayed
       */
      this.load = new EventEmitter();
      /**
       * Error event when image load fails
       */
      this.error = new EventEmitter();
      this.validSrc = false;
      this.loaded = false;
      this.loadFail = false;
      this.portrait = false;
      this.state = 'loading';
    }
    ngOnInit() {
      this.animateLoad();
      this.sanitize();
    }
    ngOnDestroy() {
      this.loaded = false;
      this.loadFail = false;
    }
    ngOnChanges(changes) {
      this.loaded = false;
      this.portrait = false;
      this.loadFail = false;
      this.isCached();
      if (!changes.src.currentValue) {
        this.src = '';
        this.validSrc = false;
      } else {
        this.validSrc = true;
      }
      if (changes.base64.previousValue !== changes.base64.currentValue) {
        if (!this.loaded) {
          this.animateLoad();
          this.state = 'loading';
        }
        this.sanitize();
        this.updateRatio();
        this.cdRef.detectChanges();
      }
    }
    onLoad(event) {
      this.updateRatio();
      this.loaded = true;
      this.load.emit(this.loaded);
      of().pipe(delay(500)).subscribe(() => {
        this.base64UrlProp = null;
      });
      event.stopImmediatePropagation();
    }
    onError(event) {
      this.loadFail = true;
      this.error.emit(this.loadFail);
      event.stopImmediatePropagation();
    }
    animateLoad() {
      const loadStart = new Date().getTime();
      this.load.asObservable().pipe(take(1), tap$1(() => {
        const fast = new Date().getTime() - loadStart < 500;
        this.state = fast ? 'fast' : 'slow';
        this.cdRef.detectChanges();
      })).subscribe();
    }
    isCached() {
      const image = new Image();
      image.src = this.src;
      this.loaded = image.complete;
      image.src = '';
      this.load.emit(this.loaded);
      if (this.loaded) {
        this.updateRatio();
      }
      return this.loaded;
    }
    updateRatio() {
      if (!this.validSrc || this.imageElement == null) {
        return;
      }
      const cw = this.containerElement.nativeElement.offsetWidth;
      const ch = this.containerElement.nativeElement.offsetHeight;
      const w = this.imageElement.nativeElement.naturalWidth;
      const h = this.imageElement.nativeElement.naturalHeight;
      const ratioContainer = cw / ch;
      const ratioImage = w / h;
      this.portrait = ratioImage < 1 || ratioImage < ratioContainer;
      this.cdRef.detectChanges();
    }
    sanitize() {
      this.base64UrlProp = this.sanitizer.bypassSecurityTrustStyle(`url('data:image/jpg;base64, ${this.base64}')`);
    }
    static {
      this.ɵfac = function Rtl2ImageLoaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ImageLoaderComponent)(i0.ɵɵdirectiveInject(i1$1.DomSanitizer), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2ImageLoaderComponent,
        selectors: [["rtl2-image-loader"]],
        viewQuery: function Rtl2ImageLoaderComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c12, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.imageElement = _t.first);
          }
        },
        hostVars: 4,
        hostBindings: function Rtl2ImageLoaderComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("background-image", ctx.base64UrlProp);
            i0.ɵɵclassProp("cover", ctx.isCover);
          }
        },
        inputs: {
          base64: "base64",
          src: "src",
          fill: "fill"
        },
        outputs: {
          load: "load",
          error: "error"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 3,
        vars: 3,
        consts: [["imageElement", ""], [3, "src", "hidden", "portrait", "load", "error", 4, "ngIf"], ["class", "error-icon", "color", "error", 3, "matTooltip", "matTooltipPosition", "matTooltipClass", 4, "ngIf"], ["color", "primary", "class", "error-icon-center spin", 4, "ngIf"], [3, "load", "error", "src"], ["color", "error", 1, "error-icon", 3, "matTooltip", "matTooltipPosition", "matTooltipClass"], ["color", "primary", 1, "error-icon-center", "spin"]],
        template: function Rtl2ImageLoaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, Rtl2ImageLoaderComponent_img_0_Template, 2, 6, "img", 1)(1, Rtl2ImageLoaderComponent_mat_icon_1_Template, 3, 5, "mat-icon", 2)(2, Rtl2ImageLoaderComponent_mat_icon_2_Template, 2, 0, "mat-icon", 3);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.validSrc);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.loadFail);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.loaded && !ctx.loadFail);
          }
        },
        dependencies: [i2.NgIf, i2$3.MatIcon, i4$1.MatTooltip, i2$1.TranslatePipe],
        styles: ["[_nghost-%COMP%]{position:relative;height:100%;width:100%;overflow:hidden;display:flex;align-items:center;justify-content:center;background-position:center center;background-repeat:no-repeat;background-size:contain}.cover[_nghost-%COMP%]{background-size:cover}.cover[_nghost-%COMP%] > img[_ngcontent-%COMP%]{max-width:none;max-height:none;height:100%;width:auto}.cover[_nghost-%COMP%] > img.portrait[_ngcontent-%COMP%]{max-width:none;max-height:none;width:100%;height:auto}img[_ngcontent-%COMP%]{max-width:100%;max-height:100%;height:auto;width:auto;flex-basis:0}.error-icon[_ngcontent-%COMP%]{position:absolute;bottom:0;right:0}.error-icon-center[_ngcontent-%COMP%]{position:absolute;top:calc(50% - 12px);left:calc(50% - 12px);opacity:.4}.hidden[_ngcontent-%COMP%]{opacity:0}.spin[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_spin-animation 2s infinite linear}@keyframes _ngcontent-%COMP%_spin-animation{0%{transform:rotate(0)}to{transform:rotate(359deg)}}"],
        data: {
          animation: [trigger('fadeIn', [state('slow', style({
            opacity: 1,
            visibility: 'visible'
          })), state('loading', style({
            opacity: 0,
            visibility: 'hidden'
          })), transition('loading => slow', [animate('1s ease-out')])])]
        },
        changeDetection: 0
      });
    }
  }
  return Rtl2ImageLoaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2ImageLoaderModule = /*#__PURE__*/(() => {
  class Rtl2ImageLoaderModule {
    static {
      this.ɵfac = function Rtl2ImageLoaderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ImageLoaderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2ImageLoaderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatIconModule, MatTooltipModule, TranslateModule]
      });
    }
  }
  return Rtl2ImageLoaderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Keywords input field
 *
 * Example:
 * ```html
 * <form [formGroup]="basicForm">
 *   <mat-form-field>
 *     <rtl2-keywords-input
 *       formArrayName="tags"
 *       placeholder="Enter keyword"
 *       [value]="value"
 *       ></rtl2-keywords-input>
 *   </mat-form-field>
 * </form>
 * ```
 *
 * ```typescript
 * basicForm: FormGroup;
 * value = [
 * {id: 1, name: 'one'},
 * {id: 2, name: 'two'},
 * {id: 3, name: 'three'},
 * {id: 4, name: 'four'}
 * ];
 *
 * constructor() {
 *  this.basicForm = new FormGroup({tags: new FormArray([])});
 * }
 * ```
 */
let Rtl2KeywordsInputComponent = /*#__PURE__*/(() => {
  class Rtl2KeywordsInputComponent {
    static {
      this.nextId = 0;
    }
    get empty() {
      const value = this.keywords.length;
      return value === 0;
    }
    get errorState() {
      return this._formArray.control.get(this.formArrayName).invalid;
    }
    get shouldLabelFloat() {
      return this.focused || !this.empty;
    }
    get placeholder() {
      return this._placeholder;
    }
    set placeholder(value) {
      this._placeholder = value;
      this.stateChanges.next();
    }
    get required() {
      return this._required;
    }
    set required(value) {
      this._required = coerceBooleanProperty(value);
      this.stateChanges.next();
    }
    get disabled() {
      return this._disabled;
    }
    set disabled(value) {
      this._disabled = coerceBooleanProperty(value);
      this.stateChanges.next();
      if (this.focused) {
        this.focused = false;
        this.stateChanges.next();
      }
    }
    get value() {
      return this.keywords;
    }
    set value(val) {
      if (val != null) {
        const keys = [];
        val.map(x => keys.push({
          id: x.id,
          name: x.name
        }));
        this.keywords = keys;
        this.stateChanges.next();
      }
    }
    constructor(_focusMonitor, _elementRef, _formArray, ngControl) {
      this._focusMonitor = _focusMonitor;
      this._elementRef = _elementRef;
      this._formArray = _formArray;
      this.ngControl = ngControl;
      this.stateChanges = new Subject();
      this.focused = false;
      this.id = `rtl2-keywords-input-${Rtl2KeywordsInputComponent.nextId++}`;
      this.describedBy = '';
      this.keywords = [];
      this.separatorKeysCodes = [ENTER, COMMA];
      this._required = false;
      this._disabled = false;
      this.optionsDisplayResolver = val => val;
      if (this.ngControl) {
        // Note: we provide the value accessor through here, instead of
        // the `providers` to avoid running into a circular import.
        this.ngControl.valueAccessor = this;
      }
      this.setupFocusMonitor();
    }
    get keys() {
      return this._formArray.control.get(this.formArrayName);
    }
    addTag(event) {
      const tag = event.value;
      if ((tag || '').trim()) {
        this.addToList(tag);
        this.addToForm(tag);
        event.input.value = '';
      }
    }
    addToForm(tag) {
      this.keys.push(new Rtl2FormGroupTyped({
        id: new FormControl(null),
        name: new FormControl(tag.trim())
      }));
    }
    addToList(tag) {
      this.keywords.push({
        id: 1,
        name: tag.trim()
      });
    }
    removeTag(index) {
      if (index >= 0) {
        this.keywords.splice(index, 1);
        this.keys.removeAt(index);
      }
    }
    ngOnInit() {
      this.disabled = this._formArray.disabled;
      this._formArray.control.valueChanges.pipe(takeUntil(this.stateChanges.pipe(last()))).subscribe(x => {
        this.value = x.keys;
        this.disabled = this._formArray.disabled;
      });
    }
    onChange(_) {}
    onTouched() {}
    onBlur(event) {}
    ngOnDestroy() {
      this.stateChanges.complete();
      this._focusMonitor.stopMonitoring(this._elementRef);
    }
    setDescribedByIds(ids) {
      this.describedBy = ids.join(' ');
    }
    onContainerClick(event) {
      // TODO: FW click to select?
    }
    writeValue(val) {
      this.value = val;
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    _handleInput() {
      this.onChange(this.keywords);
    }
    setupFocusMonitor() {
      this._focusMonitor.monitor(this._elementRef, true).subscribe(origin => {
        // When the field is disabled, skip focus events
        if (this.disabled) {
          this.focused = false;
          return;
        }
        if (this.focused && !origin) {
          this.onTouched();
        }
        setTimeout(() => {
          this.focused = !!origin;
          this.stateChanges.next();
        }, 200);
      });
    }
    static {
      this.ɵfac = function Rtl2KeywordsInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2KeywordsInputComponent)(i0.ɵɵdirectiveInject(i2$2.FocusMonitor), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$2.ControlContainer, 13), i0.ɵɵdirectiveInject(i1$2.NgControl, 10));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2KeywordsInputComponent,
        selectors: [["rtl2-keywords-input"]],
        inputs: {
          formArrayName: "formArrayName",
          placeholder: "placeholder",
          required: "required",
          disabled: "disabled",
          value: "value",
          optionsDisplayResolver: "optionsDisplayResolver"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: MatFormFieldControl,
          useExisting: Rtl2KeywordsInputComponent
        }])],
        decls: 4,
        vars: 5,
        consts: [["tagList", ""], [3, "disabled", "removable", "read", "removed", 4, "ngFor", "ngForOf"], [3, "matChipInputTokenEnd", "matChipInputFor", "matChipInputSeparatorKeyCodes", "matChipInputAddOnBlur", "disabled"], [3, "removed", "disabled", "removable"], ["matChipRemove", "", 4, "ngIf"], ["matChipRemove", ""]],
        template: function Rtl2KeywordsInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "mat-chip-grid", null, 0);
            i0.ɵɵtemplate(2, Rtl2KeywordsInputComponent_mat_chip_row_2_Template, 3, 6, "mat-chip-row", 1);
            i0.ɵɵelementStart(3, "input", 2);
            i0.ɵɵlistener("matChipInputTokenEnd", function Rtl2KeywordsInputComponent_Template_input_matChipInputTokenEnd_3_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.addTag($event));
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const tagList_r6 = i0.ɵɵreference(1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.keywords);
            i0.ɵɵadvance();
            i0.ɵɵproperty("matChipInputFor", tagList_r6)("matChipInputSeparatorKeyCodes", ctx.separatorKeysCodes)("matChipInputAddOnBlur", true)("disabled", ctx.disabled);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i4$2.MatChipGrid, i4$2.MatChipInput, i4$2.MatChipRemove, i4$2.MatChipRow, i2$3.MatIcon],
        styles: [".read[_ngcontent-%COMP%]{color:#000!important}.mat-mdc-chip.mat-mdc-standard-chip.mat-mdc-chip-disabled[_ngcontent-%COMP%]{opacity:1!important}"]
      });
    }
  }
  return Rtl2KeywordsInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2KeywordsInputModule = /*#__PURE__*/(() => {
  class Rtl2KeywordsInputModule {
    static {
      this.ɵfac = function Rtl2KeywordsInputModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2KeywordsInputModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2KeywordsInputModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatChipsModule, MatIconModule, TranslateModule]
      });
    }
  }
  return Rtl2KeywordsInputModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2LogoComponent = /*#__PURE__*/(() => {
  class Rtl2LogoComponent {
    constructor() {
      this.color = null;
      this.size = null;
      this.text = true;
    }
    ngOnInit() {}
    static {
      this.ɵfac = function Rtl2LogoComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2LogoComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2LogoComponent,
        selectors: [["rtl2-logo"]],
        hostVars: 4,
        hostBindings: function Rtl2LogoComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx.size, "px")("background", ctx.background);
          }
        },
        inputs: {
          color: "color",
          size: "size",
          background: "background",
          text: "text"
        },
        decls: 10,
        vars: 3,
        consts: [["version", "1.1", "id", "Ebene_1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 595.3 598.9", 0, "xml", "space", "preserve", "width", "100%", "preserveAspectRatio", "xMidYMid meet", 2, "enable-background", "new 0 0 595.3 598.9"], ["type", "text/css"], [1, "default"], [4, "ngIf"], ["points", "289.1,207.3 255.1,213.9 255.1,299 289.1,292.4 \t\t", 1, "st0"], ["points", "306.1,204 306.1,289 340.2,282.4 340.2,197.4 \t\t", 1, "st0"], ["points", "221.1,171.6 306.1,171.6 306.1,137.6 187.1,137.6 187.1,358.7 255.1,358.7 255.1,324.7 221.1,324.7 \n\t\t\t\t\t", 1, "st0"], ["points", "340.2,137.6 340.2,171.6 374.2,171.6 374.2,324.7 289.1,324.7 289.1,358.7 408.2,358.7 408.2,137.6 \n\t\t\t\t\t", 1, "st0"], ["d", "M121.2,392.7c11.8,0,20.4,6.5,20.4,17.9c0,8.6-3.9,15.1-11.9,17.4v0.2c4.5,1,7.6,3,9.2,8.3\n\t\t\tc0.8,2.4,1.2,5.9,1.3,10.1c0.4,8.1,1.3,11.6,3.7,14.7h-10.2c-1.2-1.2-1.5-3.7-1.6-5.3l-0.4-8.2c0-0.9-0.7-6.5-2.1-10.2\n\t\t\tc-1.4-3.6-4.7-5.7-9.5-5.7H97.7v29.3h-9.1v-68.5H121.2z M117.1,424.3c10.1,0,15.4-3.6,15.4-12.2c0-7.5-4.5-11.7-12-11.7H97.7v23.9\n\t\t\tH117.1z", 1, "st0"], ["d", "M198.1,392.7v7.7h-22.8v60.8h-9.1v-60.8h-22.8v-7.7H198.1z", 1, "st0"], ["d", "M211.9,392.7v60.8h36.3v7.7h-45.4v-68.5H211.9z", 1, "st0"], ["d", "M314.7,392.7v15.4l-32.1,35.6h33.7v17.6h-61.2v-16.5l31.9-34.4h-30v-17.6H314.7z", 1, "st0"], ["d", "M340.7,392.7l8.3,42.3h0.2l8.3-42.3h18.6l8.1,42.9h0.2l8.5-42.9h20.8l-19.2,68.5H374l-7.4-41.7h-0.2\n\t\t\tl-7.2,41.7h-20.6L320,392.7H340.7z", 1, "st0"], ["d", "M475.8,392.7v17.6h-35.6v8.5h32.3v16.3h-32.3v8.5h36.7v17.6h-57.8v-68.5H475.8z", 1, "st0"], ["d", "M506.7,392.7v68.5h-21.1v-68.5H506.7z", 1, "st0"]],
        template: function Rtl2LogoComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(0, "svg", 0);
            i0.ɵɵelement(1, "style", 1);
            i0.ɵɵelementStart(2, "g", 2);
            i0.ɵɵtemplate(3, Rtl2LogoComponent__svg_g_3_Template, 8, 0, "g", 3);
            i0.ɵɵelementStart(4, "g");
            i0.ɵɵelement(5, "polygon", 4)(6, "polygon", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "g");
            i0.ɵɵelement(8, "polygon", 6)(9, "polygon", 7);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("fill", ctx.color);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.text);
          }
        },
        dependencies: [i2.NgIf],
        styles: ["[_nghost-%COMP%]{display:block;width:100%;height:auto;overflow:hidden}"],
        changeDetection: 0
      });
    }
  }
  return Rtl2LogoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2LogoModule = /*#__PURE__*/(() => {
  class Rtl2LogoModule {
    static {
      this.ɵfac = function Rtl2LogoModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2LogoModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2LogoModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return Rtl2LogoModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const RTL2_FAVICON_CONFIG = new InjectionToken('RTL2_FAVICON_CONFIG');
class Rtl2FaviconUnknownFaviconError extends Error {
  constructor(faviconName) {
    super(`Favicon with name "${faviconName}" was not found into the "custom" property of the config`);
  }
}
let Rtl2FaviconService = /*#__PURE__*/(() => {
  class Rtl2FaviconService {
    constructor(document, faviconConfig) {
      this.document = document;
      this.faviconConfig = faviconConfig;
    }
    setFaviconByUrl(faviconUrl) {
      if (!this.document) return;
      const linkElement = document.querySelector('link[rel*=icon]');
      if (!linkElement) return;
      linkElement.type = 'image/x-icon';
      linkElement.rel = 'icon';
      linkElement.href = faviconUrl;
    }
    setCustomFavicon(faviconName) {
      if (!faviconName || !this.faviconConfig.custom[faviconName]) {
        throw new Rtl2FaviconUnknownFaviconError(faviconName);
      }
      this.updateFavicon(faviconName);
    }
    setDefaultFavicon() {
      this.updateFavicon();
    }
    updateFavicon(faviconName) {
      this.setFaviconByUrl(this.faviconConfig.custom[faviconName] || this.faviconConfig.defaultUrl);
    }
    static {
      this.ɵfac = function Rtl2FaviconService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2FaviconService)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(RTL2_FAVICON_CONFIG));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: Rtl2FaviconService,
        factory: Rtl2FaviconService.ɵfac
      });
    }
  }
  return Rtl2FaviconService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var Rtl2EnvironmentFavicons = /*#__PURE__*/function (Rtl2EnvironmentFavicons) {
  Rtl2EnvironmentFavicons["dev"] = "dev";
  Rtl2EnvironmentFavicons["test"] = "test";
  Rtl2EnvironmentFavicons["integration"] = "integration";
  return Rtl2EnvironmentFavicons;
}(Rtl2EnvironmentFavicons || {});
const rtl2EnvironmentFavicons = {
  dev: 'assets/favicon.test.ico',
  test: 'assets/favicon.test.ico',
  integration: 'assets/favicon.integration.ico'
};
let Rtl2FaviconModule = /*#__PURE__*/(() => {
  class Rtl2FaviconModule {
    static forRoot(conf) {
      return {
        ngModule: Rtl2FaviconModule,
        providers: [Rtl2FaviconService, {
          provide: RTL2_FAVICON_CONFIG,
          useValue: conf
        }]
      };
    }
    static {
      this.ɵfac = function Rtl2FaviconModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2FaviconModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2FaviconModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return Rtl2FaviconModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Placeholder screen used to cover app view until loading processes (e.g. authentication) finished
 *
 * Example:
 * ```html
 * <rtl2-placeholder-empty [title]="'Random title'"></rtl2-placeholder-empty>
 * ```
 */
let Rtl2PlaceholderEmptyComponent = /*#__PURE__*/(() => {
  class Rtl2PlaceholderEmptyComponent {
    constructor(uiService) {
      this.uiService = uiService;
    }
    ngOnInit() {
      if (!this.title || !this.title.length) {
        this.uiService.menuGetMenuNameCurrent().subscribe(name => this.title = name);
      }
    }
    static {
      this.ɵfac = function Rtl2PlaceholderEmptyComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2PlaceholderEmptyComponent)(i0.ɵɵdirectiveInject(Rtl2UiInterface));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2PlaceholderEmptyComponent,
        selectors: [["rtl2-placeholder-empty"]],
        inputs: {
          title: "title"
        },
        decls: 6,
        vars: 4,
        consts: [[1, "d-flex", "flex-column", "align-items-center", "justify-content-center", "h-100", "w-100", "text-center", "empty-page-placeholder"], [3, "size"]],
        template: function Rtl2PlaceholderEmptyComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "rtl2-logo", 1)(2, "hr");
            i0.ɵɵelementStart(3, "h1");
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("size", 300);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 2, ctx.title));
          }
        },
        dependencies: [Rtl2LogoComponent, i2$1.TranslatePipe],
        styles: [".empty-page-placeholder[_ngcontent-%COMP%]{position:absolute;top:0}.empty-page-placeholder[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{margin-bottom:2rem;border:0;border-top-width:2px;border-top-style:solid;width:40%}.empty-page-placeholder[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font-weight:400;font-size:4rem}"]
      });
    }
  }
  return Rtl2PlaceholderEmptyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Toolbar component
 *
 * Example:
 * ```html
 * <rtl2-toolbar [title]="'Random title'" [menu]="true"></rtl2-toolbar>
 * ```
 */
let Rtl2ToolbarComponent = /*#__PURE__*/(() => {
  class Rtl2ToolbarComponent {
    onkeyup(ev) {
      this.displayMenu = false;
      this.displayInfoMenu = false;
    }
    constructor(ts, translate, uiService) {
      this.ts = ts;
      this.translate = translate;
      this.uiService = uiService;
      this.destroy$ = new Subject();
      this.dashboard = '#';
      this.infoMenu = null;
      this.displayMenu = false;
      this.displayInfoMenu = false;
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    ngOnInit() {
      if (this.title) {
        this.translate.get(this.title).pipe(take(1)).subscribe(v => this.ts.setTitle(v));
      }
      if (!this.title?.length) {
        this.uiService.menuGetMenuNameCurrent().pipe(filter$1(v => !!v?.length), takeUntil(this.destroy$)).subscribe(name => {
          this.title = name;
          this.translate.get(name).pipe(take(1)).subscribe(v => this.ts.setTitle(v));
        });
      }
      this.uiService.fetchMenu().pipe(take(1)).subscribe(m => {
        const dash = m.find(app => app.id === 'dashboard');
        if (dash != null) {
          this.dashboard = dash.link;
        }
      });
      this.infoMenu = this.uiService.environmentVar('infoMenu')?.filter(v => !(!v?.name?.length || !v?.url?.length));
    }
    toggleMenu(event) {
      event.stopImmediatePropagation();
      this.displayInfoMenu = false;
      this.displayMenu = !this.displayMenu;
    }
    toggleInfoMenu(event) {
      event.stopImmediatePropagation();
      this.displayMenu = false;
      this.displayInfoMenu = !this.displayInfoMenu;
    }
    goUrl(url) {
      window.location.assign(url);
    }
    isVisible(roles) {
      return this.uiService.ssoCheckRole(roles);
    }
    go(url) {
      window.open(url, '_blank');
    }
    static {
      this.ɵfac = function Rtl2ToolbarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ToolbarComponent)(i0.ɵɵdirectiveInject(i1$1.Title), i0.ɵɵdirectiveInject(i2$1.TranslateService), i0.ɵɵdirectiveInject(Rtl2UiInterface));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2ToolbarComponent,
        selectors: [["rtl2-toolbar"]],
        hostBindings: function Rtl2ToolbarComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown.escape", function Rtl2ToolbarComponent_keydown_escape_HostBindingHandler($event) {
              return ctx.onkeyup($event);
            }, false, i0.ɵɵresolveDocument);
          }
        },
        inputs: {
          title: "title",
          menu: "menu"
        },
        ngContentSelectors: _c14,
        decls: 15,
        vars: 8,
        consts: [["color", "primary", 1, "rtl2-toolbar"], [1, "toolbar-logo", 3, "href"], [1, "logo-alignment"], [1, "h3", "headline"], [1, "toolbar-controls"], ["mat-button", "", 3, "click", 4, "ngIf"], ["class", "menu-container", 3, "rtl2MouseclickOutside", 4, "ngIf"], ["mat-button", "", 3, "click"], [1, "menu-container", 3, "rtl2MouseclickOutside"], [3, "innerHTML", "click", 4, "ngFor", "ngForOf"], [3, "click", "innerHTML"]],
        template: function Rtl2ToolbarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c13);
            i0.ɵɵelementStart(0, "mat-toolbar", 0)(1, "a", 1);
            i0.ɵɵelement(2, "rtl2-logo", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 4);
            i0.ɵɵprojection(7);
            i0.ɵɵelementStart(8, "div");
            i0.ɵɵtemplate(9, Rtl2ToolbarComponent_button_9_Template, 3, 0, "button", 5)(10, Rtl2ToolbarComponent_div_10_Template, 3, 2, "div", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "div");
            i0.ɵɵtemplate(12, Rtl2ToolbarComponent_button_12_Template, 3, 0, "button", 5)(13, Rtl2ToolbarComponent_div_13_Template, 2, 1, "div", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(14, 1);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("href", ctx.dashboard, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 6, ctx.title));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.infoMenu == null ? null : ctx.infoMenu.length);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.displayInfoMenu);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.menu);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.displayMenu);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i3$1.MatButton, i2$3.MatIcon, i4.MatNavList, i8.MatToolbar, Rtl2MouseclickOutsideDirective, Rtl2DashboardPopupComponent, Rtl2LogoComponent, i2$1.TranslatePipe],
        styles: ["[_nghost-%COMP%]     .menu-container *{font-size:1rem;line-height:1.5}[_nghost-%COMP%]     .mat-mdc-button>.mat-icon{margin:0;font-size:1.5rem;height:1.5rem;width:1.5rem}.rtl2-toolbar[_ngcontent-%COMP%]   .headline[_ngcontent-%COMP%]{margin:0 1rem;max-width:calc(100% - 10rem);text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.rtl2-toolbar[_ngcontent-%COMP%]   .toolbar-logo[_ngcontent-%COMP%]{width:2rem;max-height:100%}.rtl2-toolbar[_ngcontent-%COMP%]   .toolbar-logo[_ngcontent-%COMP%]   .logo-alignment[_ngcontent-%COMP%]{width:4rem;margin-left:-16px}.rtl2-toolbar[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{cursor:pointer}.toolbar-controls[_ngcontent-%COMP%]{display:flex;height:100%;margin-left:auto;position:relative}.toolbar-controls[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{height:100%}mat-nav-list[_ngcontent-%COMP%]{padding:0}mat-nav-list[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{display:block;padding:.5rem 1rem;text-decoration:none}mat-nav-list[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{text-decoration:underline}mat-nav-list[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:not(:first-child){border-top-width:1px;border-top-style:solid}.menu-container[_ngcontent-%COMP%]{display:flex;position:absolute;right:0;bottom:0;max-height:max-content;width:max-content;padding:0;overflow:hidden;z-index:110;transform:translateY(100%)}"],
        data: {
          animation: [trigger('appMenu', [transition(':enter', [style({
            opacity: 0
          }), animate('100ms', style({
            opacity: 1
          }))]), transition(':leave', [animate('100ms', style({
            height: 0
          }))])])]
        }
      });
    }
  }
  return Rtl2ToolbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2LayoutBaseComponent = /*#__PURE__*/(() => {
  class Rtl2LayoutBaseComponent {
    constructor(breakpointObserver, uiInterface, viewContainerRef, faviconService) {
      this.breakpointObserver = breakpointObserver;
      this.uiInterface = uiInterface;
      this.faviconService = faviconService;
      this.useToolbar = true;
      this.useFullHeight = true;
      this.showMenu = false;
      this.isMobile = false;
      this.uiInterface.notificationAddComponentDialog(viewContainerRef);
      this.uiInterface.notificationAddComponentSnackBar(viewContainerRef);
      this.breakpointObserver.observe(['(max-width: 599.98px)']).subscribe(result => {
        this.isMobile = result.matches;
      });
    }
    ngOnInit() {
      this.initFavicon();
    }
    initFavicon() {
      const envName = this.uiInterface.environmentVar('name');
      if (!envName || !Rtl2EnvironmentFavicons?.[envName]) return;
      this.faviconService.setCustomFavicon(envName);
    }
    static {
      this.ɵfac = function Rtl2LayoutBaseComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2LayoutBaseComponent)(i0.ɵɵdirectiveInject(i1$4.BreakpointObserver), i0.ɵɵdirectiveInject(Rtl2UiInterface), i0.ɵɵdirectiveInject(ViewContainerRef), i0.ɵɵdirectiveInject(Rtl2FaviconService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2LayoutBaseComponent,
        selectors: [["rtl2-layout-base"]],
        hostVars: 2,
        hostBindings: function Rtl2LayoutBaseComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("toolbar-low", ctx.isMobile);
          }
        },
        inputs: {
          title: "title",
          placeholder: "placeholder",
          useToolbar: "useToolbar",
          useFullHeight: "useFullHeight",
          showMenu: "showMenu"
        },
        ngContentSelectors: _c16,
        decls: 3,
        vars: 2,
        consts: [["placeholderTemplate", ""], [4, "ngIf", "ngIfElse"], [3, "title", "menu", 4, "ngIf"], [1, "container-basecontent"], [3, "title", "menu"], ["controls-prefix", ""], ["controls-suffix", ""], [3, "title"]],
        template: function Rtl2LayoutBaseComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c15);
            i0.ɵɵtemplate(0, Rtl2LayoutBaseComponent_ng_container_0_Template, 4, 3, "ng-container", 1)(1, Rtl2LayoutBaseComponent_ng_template_1_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const placeholderTemplate_r2 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", !ctx.placeholder)("ngIfElse", placeholderTemplate_r2);
          }
        },
        dependencies: [i2.NgIf, Rtl2PlaceholderEmptyComponent, Rtl2ToolbarComponent],
        styles: ["[_nghost-%COMP%]{width:100%}[_nghost-%COMP%]   .container-fullheight[_ngcontent-%COMP%]{height:100%}[_nghost-%COMP%]   rtl2-toolbar[_ngcontent-%COMP%] + .container-fullheight[_ngcontent-%COMP%]{height:calc(100% - 4rem)}.toolbar-low[_nghost-%COMP%]   rtl2-toolbar[_ngcontent-%COMP%] + .container-fullheight[_ngcontent-%COMP%]{height:calc(100% - 3.5rem)}"]
      });
    }
  }
  return Rtl2LayoutBaseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2403Component = /*#__PURE__*/(() => {
  class Rtl2403Component {
    constructor(route) {
      this.route = route;
      this.missingRole$ = this.route.queryParamMap.pipe(map(params => params.get('missingRole')));
    }
    navigate() {
      document.location.href = window.location.origin;
    }
    static {
      this.ɵfac = function Rtl2403Component_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2403Component)(i0.ɵɵdirectiveInject(i1$5.ActivatedRoute));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2403Component,
        selectors: [["rtl2-403"]],
        decls: 20,
        vars: 17,
        consts: [["title", "rtl2.services.403.title"], [1, "d-flex", "h-100", "w-100", "align-items-center", "justify-content-center"], [1, "large", "mat-h1", "text-center"], [1, "mat-h1", "text-center"], [1, "text-center"], [4, "ngIf"], [1, "w-100", "d-flex", "justify-content-center", "mb-4"], ["mat-raised-button", "", "color", "primary", 3, "routerLink"], ["mat-raised-button", "", "color", "primary", 1, "ms-2", 3, "click"], [1, "small", "text-center", "mb-0"], [1, "text-strong", "text-center", "mt-0"]],
        template: function Rtl2403Component_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "rtl2-layout-base", 0)(1, "div", 1)(2, "mat-card")(3, "p", 2);
            i0.ɵɵtext(4, "403");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "p", 3);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "p", 4);
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(11, Rtl2403Component_div_11_Template, 7, 6, "div", 5);
            i0.ɵɵpipe(12, "async");
            i0.ɵɵelementStart(13, "div", 6)(14, "a", 7);
            i0.ɵɵtext(15);
            i0.ɵɵpipe(16, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "button", 8);
            i0.ɵɵlistener("click", function Rtl2403Component_Template_button_click_17_listener() {
              return ctx.navigate();
            });
            i0.ɵɵtext(18);
            i0.ɵɵpipe(19, "translate");
            i0.ɵɵelementEnd()()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 6, "rtl2.services.403.title"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 8, "rtl2.services.403.message"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(12, 10, ctx.missingRole$));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(16, _c17));
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 12, "rtl2.services.403.reload"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 14, "rtl2.services.403.dashboard"), " ");
          }
        },
        dependencies: [i2.NgIf, i1$5.RouterLink, i3$1.MatAnchor, i3$1.MatButton, i3.MatCard, Rtl2LayoutBaseComponent, i2.AsyncPipe, i2$1.TranslatePipe],
        styles: [".large[_ngcontent-%COMP%]{font-size:8rem;font-weight:200;line-height:8rem;width:500px}"]
      });
    }
  }
  return Rtl2403Component;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2404Component = /*#__PURE__*/(() => {
  class Rtl2404Component {
    constructor() {}
    navigate() {
      document.location.href = window.location.origin;
    }
    static {
      this.ɵfac = function Rtl2404Component_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2404Component)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2404Component,
        selectors: [["rtl2-404"]],
        decls: 18,
        vars: 14,
        consts: [["title", "rtl2.services.404.title"], [1, "d-flex", "h-100", "w-100", "align-items-center", "justify-content-center"], [1, "large", "mat-h1", "text-center"], [1, "mat-h1", "text-center"], [1, "text-center"], [1, "w-100", "d-flex", "justify-content-center", "mb-4"], ["mat-raised-button", "", "color", "primary", 3, "routerLink"], ["mat-raised-button", "", "color", "primary", 1, "ms-2", 3, "click"]],
        template: function Rtl2404Component_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "rtl2-layout-base", 0)(1, "div", 1)(2, "mat-card")(3, "p", 2);
            i0.ɵɵtext(4, "404");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "p", 3);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "p", 4);
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "div", 5)(12, "a", 6);
            i0.ɵɵtext(13);
            i0.ɵɵpipe(14, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(15, "button", 7);
            i0.ɵɵlistener("click", function Rtl2404Component_Template_button_click_15_listener() {
              return ctx.navigate();
            });
            i0.ɵɵtext(16);
            i0.ɵɵpipe(17, "translate");
            i0.ɵɵelementEnd()()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 5, "rtl2.services.404.title"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 7, "rtl2.services.404.message"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(13, _c17));
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 9, "rtl2.services.404.reload"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 11, "rtl2.services.404.dashboard"), " ");
          }
        },
        dependencies: [i1$5.RouterLink, i3$1.MatAnchor, i3$1.MatButton, i3.MatCard, Rtl2LayoutBaseComponent, i2$1.TranslatePipe],
        styles: [_c18]
      });
    }
  }
  return Rtl2404Component;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2PlaceholderEmptyModule = /*#__PURE__*/(() => {
  class Rtl2PlaceholderEmptyModule {
    static {
      this.ɵfac = function Rtl2PlaceholderEmptyModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2PlaceholderEmptyModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2PlaceholderEmptyModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, Rtl2LogoModule]
      });
    }
  }
  return Rtl2PlaceholderEmptyModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2ToolbarModule = /*#__PURE__*/(() => {
  class Rtl2ToolbarModule {
    static {
      this.ɵfac = function Rtl2ToolbarModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ToolbarModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2ToolbarModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatButtonModule, MatIconModule, MatListModule, MatToolbarModule, TranslateModule, Rtl2UiModule, Rtl2DashboardPopupModule, Rtl2LogoModule]
      });
    }
  }
  return Rtl2ToolbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2LayoutBaseModule = /*#__PURE__*/(() => {
  class Rtl2LayoutBaseModule {
    static {
      this.ɵfac = function Rtl2LayoutBaseModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2LayoutBaseModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2LayoutBaseModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, Rtl2PlaceholderEmptyModule, Rtl2ToolbarModule, Rtl2FaviconModule.forRoot({
          defaultUrl: 'favicon.ico',
          custom: rtl2EnvironmentFavicons
        })]
      });
    }
  }
  return Rtl2LayoutBaseModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2PagesDefaultModule = /*#__PURE__*/(() => {
  class Rtl2PagesDefaultModule {
    static {
      this.ɵfac = function Rtl2PagesDefaultModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2PagesDefaultModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2PagesDefaultModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule, TranslateModule, MatButtonModule, MatCardModule, Rtl2LayoutBaseModule]
      });
    }
  }
  return Rtl2PagesDefaultModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Time picker input field
 *
 * Example:
 * ```html
 * <form [formGroup]="basicForm">
 *   <rtl2-time-picker
 *     [form]="basicForm.get('time')"
 *     ></rtl2-time-picker>
 * </form>
 * ```
 *
 * ```typescript
 * basicForm: FormGroup;
 *
 * constructor() {
 *  this.basicForm = new FormGroup({time: new FormControl(new Date())});
 * }
 * ```
 */
let Rtl2TimePickerComponent = /*#__PURE__*/(() => {
  class Rtl2TimePickerComponent {
    constructor(fb) {
      this.fb = fb;
      this.MAX_MINUTES = 59;
      this.MAX_HOURS = 23;
      this.focusOut$ = new BehaviorSubject(false);
      this.inputFocusOut = new EventEmitter();
      this.hostInFocus = false;
      this.destroy$ = new Subject();
    }
    ngOnInit() {
      this.timeForm = this.buildForm(this.fb);
      this.setupInteraction();
      this.focusOut$.pipe(debounceTime$1(100), filter$1(v => v), takeUntil(this.destroy$)).subscribe(() => this.inputFocusOut.emit());
      this.updateControlValues(this.form.value);
      this.formControlValueChanged();
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    ngOnChanges(changes) {
      if (!!changes.disabled && this.timeForm) {
        changes.disabled.currentValue ? this.timeForm.disable() : this.timeForm.enable();
      }
    }
    onFocus(event) {
      event.target.select();
      this.hostInFocus = true;
      this.focusOut$.next(false);
    }
    onFocusout(event) {
      event.srcElement.value = event.srcElement.value.padStart(2, '0');
      this.hostInFocus = false;
      this.focusOut$.next(true);
    }
    onInputChange(event) {
      const value = event.srcElement.value;
      const id = event.srcElement.id;
      if (value.length === event.srcElement.maxLength) {
        if (id === 'hours') {
          return this.minutesInput.nativeElement.focus();
        }
      }
    }
    buildForm(fb) {
      return fb.group({
        hours: {
          value: null,
          disabled: this.disabled
        },
        minutes: {
          value: null,
          disabled: this.disabled
        }
      });
    }
    numberOnly(event) {
      let keycode = event.keyCode || event.which;
      if (keycode >= 96 && keycode <= 105) {
        keycode -= 48;
      }
      return [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96].includes(keycode);
    }
    formControlValueChanged() {
      this.timeForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(data => {
        if (!!data) {
          const h = this.timeForm.get('hours').value;
          const m = this.timeForm.get('minutes').value;
          const date = !!this.form.value ? new Date(this.form.value) : null;
          if (!!date) {
            date.setHours(h);
            date.setMinutes(m);
            this.currentValue = date;
            this.form.setValue(date);
          }
        }
      });
      this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(val => {
        if (this.currentValue !== val) {
          this.updateControlValues(val);
        }
      });
    }
    updateControlValues(val) {
      if (!val) {
        this.hours.setValue(null, {
          emitEvent: false
        });
        this.minutes.setValue(null, {
          emitEvent: false
        });
        return;
      }
      const h = val.getHours();
      const m = val.getMinutes();
      this.hours.setValue(this.padZero(h), {
        emitEvent: false
      });
      this.minutes.setValue(this.padZero(m), {
        emitEvent: false
      });
    }
    setupInteraction() {
      this.hours.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(val => {
        this.hours.patchValue(this.clamp(0, this.MAX_HOURS, val), {
          emitEvent: false
        });
      });
      this.minutes.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(val => {
        this.minutes.patchValue(this.clamp(0, this.MAX_MINUTES, val), {
          emitEvent: false
        });
      });
    }
    get hours() {
      return this.timeForm.get('hours');
    }
    get minutes() {
      return this.timeForm.get('minutes');
    }
    clamp(min, max, val) {
      return val > max ? max : val;
    }
    padZero(value) {
      return ('0' + value).slice(-2);
    }
    static {
      this.ɵfac = function Rtl2TimePickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2TimePickerComponent)(i0.ɵɵdirectiveInject(i1$2.FormBuilder));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2TimePickerComponent,
        selectors: [["rtl2-time-picker"]],
        viewQuery: function Rtl2TimePickerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c19, 5);
            i0.ɵɵviewQuery(_c20, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hoursInput = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.minutesInput = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function Rtl2TimePickerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("focus", function Rtl2TimePickerComponent_focus_HostBindingHandler($event) {
              return ctx.onFocus($event);
            })("focusout", function Rtl2TimePickerComponent_focusout_HostBindingHandler($event) {
              return ctx.onFocusout($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("in-focus", ctx.hostInFocus);
          }
        },
        inputs: {
          form: "form",
          disabled: "disabled",
          placeholder: "placeholder",
          text: "text",
          errorFrames: "errorFrames"
        },
        outputs: {
          inputFocusOut: "inputFocusOut"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 15,
        vars: 16,
        consts: [["prelHours", ""], ["prelMinutes", ""], [1, "d-flex", "justify-content-start", "label"], [1, "release-time-container", 3, "formGroup"], [3, "ngClass"], ["id", "hours", "maxlength", "2", "type", "text", "autocomplete", "off", "formControlName", "hours", "matInput", "", 3, "focus", "focusout", "keypress", "input", "click"], [1, "break"], ["id", "minutes", "maxlength", "2", "type", "text", "autocomplete", "off", "formControlName", "minutes", "matInput", "", 3, "focus", "focusout", "input", "keypress", "click"], [1, "d-flex", "justify-content-center", "align-items-center"], [1, "pl-2"]],
        template: function Rtl2TimePickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2)(1, "span");
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(3, "div", 3)(4, "mat-form-field", 4)(5, "input", 5, 0);
            i0.ɵɵlistener("focus", function Rtl2TimePickerComponent_Template_input_focus_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocus($event));
            })("focusout", function Rtl2TimePickerComponent_Template_input_focusout_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocusout($event));
            })("keypress", function Rtl2TimePickerComponent_Template_input_keypress_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.numberOnly($event));
            })("input", function Rtl2TimePickerComponent_Template_input_input_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onInputChange($event));
            })("click", function Rtl2TimePickerComponent_Template_input_click_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView($event.target.select());
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "span", 6);
            i0.ɵɵtext(8, ":");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "mat-form-field", 4)(10, "input", 7, 1);
            i0.ɵɵlistener("focus", function Rtl2TimePickerComponent_Template_input_focus_10_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocus($event));
            })("focusout", function Rtl2TimePickerComponent_Template_input_focusout_10_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocusout($event));
            })("input", function Rtl2TimePickerComponent_Template_input_input_10_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onInputChange($event));
            })("keypress", function Rtl2TimePickerComponent_Template_input_keypress_10_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.numberOnly($event));
            })("click", function Rtl2TimePickerComponent_Template_input_click_10_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView($event.target.select());
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 8)(13, "mat-icon", 9);
            i0.ɵɵtext(14, "access_time");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵclassProp("focus", ctx.hostInFocus);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.placeholder, " ");
            i0.ɵɵadvance();
            i0.ɵɵclassProp("text", ctx.text);
            i0.ɵɵproperty("formGroup", ctx.timeForm);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("read", ctx.disabled);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c21, ctx.errorFrames));
            i0.ɵɵadvance(5);
            i0.ɵɵclassProp("read", ctx.disabled);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c21, ctx.errorFrames));
          }
        },
        dependencies: [i2.NgClass, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i1$2.MaxLengthValidator, i1$2.FormGroupDirective, i1$2.FormControlName, i3$2.MatFormField, i2$3.MatIcon, i7.MatInput],
        styles: ["[_nghost-%COMP%]{padding-left:1rem;margin-top:2px}[_nghost-%COMP%]     .text .mat-mdc-form-field-underline{display:none}mat-form-field.mat-mdc-form-field-invalid[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{font-weight:700}.release-time-container[_ngcontent-%COMP%]{display:flex;justify-content:flex-start}.release-time-container[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{width:40px}.release-time-container[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{position:relative;top:-3px}input[type=text][_ngcontent-%COMP%]{text-align:center}input[type=text][_ngcontent-%COMP%]::-webkit-inner-spin-button, input[type=text][_ngcontent-%COMP%]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.label[_ngcontent-%COMP%]{color:#0000008a;font-size:12px;font-weight:400;min-height:16px;margin-top:-2px;margin-bottom:-16px}.break[_ngcontent-%COMP%]{padding-bottom:3px;display:flex;align-items:center}.read[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .read[_ngcontent-%COMP%]   .mat-mdc-select-value[_ngcontent-%COMP%]{color:#000!important}mat-icon[_ngcontent-%COMP%]{font-size:18px}"]
      });
    }
  }
  return Rtl2TimePickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2TimePickerModule = /*#__PURE__*/(() => {
  class Rtl2TimePickerModule {
    static {
      this.ɵfac = function Rtl2TimePickerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2TimePickerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2TimePickerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatIconModule, MatInputModule]
      });
    }
  }
  return Rtl2TimePickerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2ElementContentContainer = /*#__PURE__*/(() => {
  class Rtl2ElementContentContainer {
    constructor(element, renderer) {
      this.element = element;
      this.renderer = renderer;
      this.loading = false;
      this.height100 = true;
      this.width = null;
      this.styles = null;
      this.showContent = false;
    }
    ngAfterViewInit() {
      setTimeout(() => {
        this.showContent = true;
      }, 200);
    }
    ngOnChanges(changes) {
      this.asignProperties();
    }
    asignProperties() {
      if (this.styles) {
        this.renderer.setAttribute(this.element.nativeElement, 'style', Object.keys(this.styles).map(e => e + ':' + this.styles[e]).join(';'));
      }
      if (this.width) {
        this.renderer.setStyle(this.element.nativeElement, 'width', this.width);
      }
    }
    static {
      this.ɵfac = function Rtl2ElementContentContainer_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ElementContentContainer)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2ElementContentContainer,
        selectors: [["", "rtl2ElementContentContainer", ""]],
        inputs: {
          loading: "loading",
          height100: "height100",
          width: "width",
          styles: "styles"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        attrs: _c22,
        ngContentSelectors: _c23,
        decls: 4,
        vars: 2,
        consts: [["content", ""], [3, "ngSwitch", 4, "ngIf"], ["class", "container-loading", 4, "ngIf"], [3, "ngSwitch"], [4, "ngSwitchCase"], [3, "ngTemplateOutlet"], [1, "container-loading"]],
        template: function Rtl2ElementContentContainer_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, Rtl2ElementContentContainer_ng_container_0_Template, 3, 3, "ng-container", 1)(1, Rtl2ElementContentContainer_div_1_Template, 2, 1, "div", 2)(2, Rtl2ElementContentContainer_ng_template_2_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.showContent);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.loading);
          }
        },
        dependencies: [i2.NgIf, i2.NgTemplateOutlet, i2.NgSwitch, i2.NgSwitchCase, i2$4.MatProgressSpinner, i5.NgScrollbar],
        styles: ["[_nghost-%COMP%]{position:relative;display:block;min-height:100%;width:0;overflow:hidden;transition:width .2s ease}"],
        data: {
          animation: [trigger('loadingAnimation', [state('void', style({
            opacity: 0,
            zIndex: -1
          })), state('*', style({
            opacity: 1,
            zIndex: 1
          })), transition('void => *', animate('.3s')), transition('* => void', animate('.3s'))])]
        }
      });
    }
  }
  return Rtl2ElementContentContainer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2ElementContentCenteredComponent = /*#__PURE__*/(() => {
  class Rtl2ElementContentCenteredComponent {
    constructor(element, renderer) {
      this.element = element;
      this.renderer = renderer;
      this.loading = false;
      this.height100 = true;
      this.width = '1800px';
      this.styles = null;
    }
    ngOnInit() {
      if (this.height100) {
        this.renderer.addClass(this.element.nativeElement, 'height100');
      } else {
        this.renderer.removeClass(this.element.nativeElement, 'height100');
      }
      setTimeout(() => {
        if (!this.width) {
          return;
        }
        this.renderer.setStyle(this.element.nativeElement, 'width', this.width);
      }, 0);
    }
    static {
      this.ɵfac = function Rtl2ElementContentCenteredComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ElementContentCenteredComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2ElementContentCenteredComponent,
        selectors: [["rtl2-element-content-centered"]],
        inputs: {
          loading: "loading",
          height100: "height100",
          width: "width",
          styles: "styles"
        },
        ngContentSelectors: _c23,
        decls: 4,
        vars: 6,
        consts: [["containerContent", ""], [1, "container-content"], ["rtl2ElementContentContainer", "", 1, "container-wrapper", 3, "loading", "height100", "width", "styles"]],
        template: function Rtl2ElementContentCenteredComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "mat-card", 1, 0)(2, "div", 2);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("height100", ctx.height100);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("loading", ctx.loading)("height100", ctx.height100)("width", "100%")("styles", ctx.styles);
          }
        },
        dependencies: [i3.MatCard, Rtl2ElementContentContainer],
        styles: ["[_nghost-%COMP%]{display:block;overflow:hidden;max-width:95%;width:0;padding:1rem .2rem;margin:0 auto;transition:width .2s ease}.container-wrapper[_ngcontent-%COMP%]{max-width:100%}.container-content[_ngcontent-%COMP%]{padding:0}.container-content.height100[_ngcontent-%COMP%]{height:100%}.container-content.height100[_ngcontent-%COMP%] > .container-wrapper[_ngcontent-%COMP%]{height:100%}"]
      });
    }
  }
  return Rtl2ElementContentCenteredComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2ElementContentContainerModule = /*#__PURE__*/(() => {
  class Rtl2ElementContentContainerModule {
    static {
      this.ɵfac = function Rtl2ElementContentContainerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ElementContentContainerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2ElementContentContainerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatCardModule, MatProgressSpinnerModule, NgScrollbarModule]
      });
    }
  }
  return Rtl2ElementContentContainerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2ElementContentCenteredModule = /*#__PURE__*/(() => {
  class Rtl2ElementContentCenteredModule {
    static {
      this.ɵfac = function Rtl2ElementContentCenteredModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ElementContentCenteredModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2ElementContentCenteredModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatCardModule, MatProgressSpinnerModule, Rtl2ElementContentContainerModule]
      });
    }
  }
  return Rtl2ElementContentCenteredModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2ElementContentColumnsCenteredComponent = /*#__PURE__*/(() => {
  class Rtl2ElementContentColumnsCenteredComponent {
    constructor(element, renderer) {
      this.element = element;
      this.renderer = renderer;
      this.loading = false;
      this.width = '1800px';
      this.styles = null;
      this.columnLoading = [false, false, false, false, false, false, false, false, false, false];
      this.columnHeight100 = [true, true, true, true, true, true, true, true, true, true];
      this.columnWidth = [];
      this.columnStyles = [];
    }
    ngOnInit() {
      this.renderer.addClass(this.element.nativeElement, 'height100');
      setTimeout(() => {
        if (!this.width) {
          return;
        }
        this.renderer.setStyle(this.element.nativeElement, 'width', this.width);
      }, 0);
    }
    static {
      this.ɵfac = function Rtl2ElementContentColumnsCenteredComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ElementContentColumnsCenteredComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2ElementContentColumnsCenteredComponent,
        selectors: [["rtl2-element-content-columns-centered"]],
        inputs: {
          loading: "loading",
          width: "width",
          styles: "styles",
          columnLoading: "columnLoading",
          columnHeight100: "columnHeight100",
          columnWidth: "columnWidth",
          columnStyles: "columnStyles"
        },
        ngContentSelectors: _c25,
        decls: 14,
        vars: 14,
        consts: [["containerContent", ""], [1, "container-content", "height100"], ["rtl2ElementContentContainer", "", 1, "container-wrapper", 3, "loading", "height100", "width", "styles"], [1, "d-flex", "h-100"], ["rtl2ElementContentContainer", "", 3, "loading", "height100", "width", "styles", 4, "ngIf"], ["rtl2ElementContentContainer", "", 3, "loading", "height100", "width", "styles"]],
        template: function Rtl2ElementContentColumnsCenteredComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c24);
            i0.ɵɵelementStart(0, "mat-card", 1, 0)(2, "div", 2)(3, "div", 3);
            i0.ɵɵtemplate(4, Rtl2ElementContentColumnsCenteredComponent_div_4_Template, 2, 4, "div", 4)(5, Rtl2ElementContentColumnsCenteredComponent_div_5_Template, 2, 4, "div", 4)(6, Rtl2ElementContentColumnsCenteredComponent_div_6_Template, 2, 4, "div", 4)(7, Rtl2ElementContentColumnsCenteredComponent_div_7_Template, 2, 4, "div", 4)(8, Rtl2ElementContentColumnsCenteredComponent_div_8_Template, 2, 4, "div", 4)(9, Rtl2ElementContentColumnsCenteredComponent_div_9_Template, 2, 4, "div", 4)(10, Rtl2ElementContentColumnsCenteredComponent_div_10_Template, 2, 4, "div", 4)(11, Rtl2ElementContentColumnsCenteredComponent_div_11_Template, 2, 4, "div", 4)(12, Rtl2ElementContentColumnsCenteredComponent_div_12_Template, 2, 4, "div", 4)(13, Rtl2ElementContentColumnsCenteredComponent_div_13_Template, 2, 4, "div", 4);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("loading", ctx.loading)("height100", false)("width", "100%")("styles", ctx.styles);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.columnWidth[0]);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.columnWidth[1]);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.columnWidth[2]);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.columnWidth[3]);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.columnWidth[4]);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.columnWidth[5]);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.columnWidth[6]);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.columnWidth[7]);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.columnWidth[8]);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.columnWidth[9]);
          }
        },
        dependencies: [i2.NgIf, i3.MatCard, Rtl2ElementContentContainer],
        styles: [_c26]
      });
    }
  }
  return Rtl2ElementContentColumnsCenteredComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2ElementContentColumnsCenteredModule = /*#__PURE__*/(() => {
  class Rtl2ElementContentColumnsCenteredModule {
    static {
      this.ɵfac = function Rtl2ElementContentColumnsCenteredModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ElementContentColumnsCenteredModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2ElementContentColumnsCenteredModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatCardModule, MatProgressSpinnerModule, Rtl2ElementContentContainerModule]
      });
    }
  }
  return Rtl2ElementContentColumnsCenteredModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2ElementContentToolbarComponent = /*#__PURE__*/(() => {
  class Rtl2ElementContentToolbarComponent {
    constructor() {
      this.width = '1800px';
    }
    static {
      this.ɵfac = function Rtl2ElementContentToolbarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ElementContentToolbarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2ElementContentToolbarComponent,
        selectors: [["rtl2-element-content-toolbar"]],
        inputs: {
          width: "width"
        },
        ngContentSelectors: _c23,
        decls: 3,
        vars: 2,
        consts: [[1, "d-flex", "container-toolbar"]],
        template: function Rtl2ElementContentToolbarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "mat-toolbar")(1, "div", 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", ctx.width);
          }
        },
        dependencies: [i8.MatToolbar],
        styles: ["mat-toolbar[_ngcontent-%COMP%]{padding:0}.container-toolbar[_ngcontent-%COMP%]{max-width:95%;margin:0 auto}"]
      });
    }
  }
  return Rtl2ElementContentToolbarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2ElementContentToolbarModule = /*#__PURE__*/(() => {
  class Rtl2ElementContentToolbarModule {
    static {
      this.ɵfac = function Rtl2ElementContentToolbarModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ElementContentToolbarModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2ElementContentToolbarModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatCardModule, MatToolbarModule]
      });
    }
  }
  return Rtl2ElementContentToolbarModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// Services

/**
 * Generated bundle index. Do not edit.
 */

export { FakeUploadService, Rtl2403Component, Rtl2404Component, Rtl2Calendar, Rtl2CamelPipeToDash, Rtl2CollapseHeaderDirective, Rtl2DashToCamelPipe, Rtl2DashboardFavoritesComponent, Rtl2DashboardFocusDirective, Rtl2DashboardPopupComponent, Rtl2DashboardPopupModule, Rtl2DashboardSearchComponent, Rtl2DashboardServicesComponent, Rtl2Data, Rtl2Date, Rtl2DateCleanPipe, Rtl2DateParserFormatter, Rtl2Datepicker, Rtl2DatepickerConfig, Rtl2DatepickerDayView, Rtl2DatepickerI18n, Rtl2DatepickerModule, Rtl2DatepickerMonthView, Rtl2DatepickerNavigation, Rtl2DatepickerNavigationSelect, Rtl2DatepickerWeekNumberView, Rtl2DatesPipe, Rtl2ElementContentCenteredComponent, Rtl2ElementContentCenteredModule, Rtl2ElementContentColumnsCenteredComponent, Rtl2ElementContentColumnsCenteredModule, Rtl2ElementContentContainer, Rtl2ElementContentContainerModule, Rtl2ElementContentToolbarComponent, Rtl2ElementContentToolbarModule, Rtl2EnvironmentFavicons, Rtl2ExtractArrayPropertyPipe, Rtl2ExtractPropertyPipe, Rtl2FabSpeedDialActionsComponent, Rtl2FabSpeedDialComponent, Rtl2FabSpeedDialModule, Rtl2FabSpeedDialTriggerComponent, Rtl2FallbackImageDirective, Rtl2FaviconModule, Rtl2FaviconService, Rtl2FaviconUnknownFaviconError, Rtl2FileDropDirective, Rtl2FileSelectDirective, Rtl2FileSelectModule, Rtl2FileSelectService, Rtl2FocusClassDirective, Rtl2FormGroupTyped, Rtl2HoverClassDirective, Rtl2IdName, Rtl2IdNameAutocompleteComponent, Rtl2IdNameAutocompleteModule, Rtl2IdNameSelectComponent, Rtl2IdNameSelectModule, Rtl2IframeModalComponent, Rtl2IframeModalModule, Rtl2ImageCarouselComponent, Rtl2ImageCarouselContainerComponent, Rtl2ImageCarouselInput, Rtl2ImageCarouselModule, Rtl2ImageCarouselThumbnailComponent, Rtl2ImageLoaderComponent, Rtl2ImageLoaderModule, Rtl2InputDatepicker, Rtl2KeywordsInputComponent, Rtl2KeywordsInputModule, Rtl2LayoutBaseComponent, Rtl2LayoutBaseModule, Rtl2LogoComponent, Rtl2LogoModule, Rtl2MouseclickOutsideDirective, Rtl2MousedownOutsideDirective, Rtl2ObjectUtil, Rtl2PagesDefaultModule, Rtl2PlaceholderEmptyComponent, Rtl2PlaceholderEmptyModule, Rtl2QuoteMarksDeDirective, Rtl2SafePipe, Rtl2SearchComponent, Rtl2SearchModule, Rtl2TimePickerComponent, Rtl2TimePickerModule, Rtl2ToolbarComponent, Rtl2ToolbarModule, Rtl2TrackVisibilityDirective, Rtl2UiDirectives, Rtl2UiInterface, Rtl2UiMenuGroup, Rtl2UiMenuItem, Rtl2UiModule, Rtl2UiPipes, Rtl2Util, Rtl2WindowResizeObserverService, Rtl2XMLPipe, rtl2EnvironmentFavicons };
